(ns pfo.admin.component
  (:require [reagent.core :as reagent :refer [atom track!] :refer-macros [with-let]]
            [reagent.ratom :refer-macros [run!]]
            #_:clj-kondo/ignore [taoensso.timbre :as timbre
                                 :refer [log trace debug info warn error fatal report logf
                                         tracef debugf infof warnf errorf fatalf reportf spy]]
            [applied-science.js-interop :as j]
            [ajax.core]
            [ajax.formats :refer [text-response-format]]
            [promesa.core :as p]
            [goog.string :as gstring]
            [clojure.string :as str :refer [blank?]]
            [cljs-time.coerce :as time-coerce]
            [cljs-time.core :as time-core]
            [statecharts.core :as fsm]
            [pfo.widget.timepicker :as timepicker :refer [datetimepicker hour-minute-picker]]
            [pfo.auth.model :as auth-model :refer [is-user-admin is-user-group-admin is-user-license-admin is-user-regular is-user-any-group-admin is-user-subscriber-admin is-user-any-subscriber-admin has-perm is-user-any-admin]]
            [pfo.auth.component :as auth-component]
            [pfo.admin.model :as model]
            [pfo.widget.upload :refer [upload-field]]
            [pfo.widget.tabs :as tabs]
            [pfo.state :as state]
            [pfo.automation.component :as automation]
            [pfo.common.component :refer [sidebar] :as common]
            [pfo.common.model :as common-model]
            [pfo.document.component :as document-component]
            [pfo.widget.tree :refer [tree-view]]
            [pfo.widget.paginator :refer [paginator tfoot-paginator]]
            [pfo.collection.model :as collection-model]
            [pfo.collection.component :as collection]
            [pfo.coltype.model :as coltype-model]
            [pfo.coltype.component :as coltype]
            [pfo.category.component :as category-component]
            [pfo.category.model :as category-model]
            [pfo.assignment.component :refer [assignment-list collection-name assignment-list-with-header assignment-list]]
            [pfo.task.component :as task-component :refer [rule-chooser signature-scope-chooser get-assignments show-task-add-modal-preselected-collection hide-task-add-modal alert-edit]]
            [pfo.label.component :as label]
            [pfo.link.component :refer [task-url]]
            [pfo.task.model :as task-model]
            [pfo.form :as form :refer [set-checked set-selected checked? option-value set-value with-disabled]]
            [pfo.util :as util :refer [handler reset-from-event swap-from-event to-value set-location vec-insert vec-remove]]
            [pfo.flash :refer [set-flash]]
            [pfo.scope.scope :as scope :refer [get-scope]]
            [pfo.time :as time]
            [cljs-time.core :refer [plus days hours minutes]]
            [pfo.tz :as tz]
            [pfo.flag :refer [enabled document-queue-enabled?]]
            [pfo.widget.list :refer [orderer]]
            [pfo.widget.progressbar :as progressbar]
            [pfo.controller :as controller :refer [subscribe]]
            [pfo.api :as api :refer [process-error handle-error-response]]
            [pfo.widget.modal :refer [modal modal-window]]
            [clojure.set :as set :refer [union difference superset?]]
            [pfo.widget.autocomplete :refer [react-select-styles]]
            ["react-select" :default Select]
            [pfo.revroutes :refer [path-for go-to-deletion-waypoint]]
            [cljs-pikaday.reagent :as pikaday]
            [clojure.core :as c]
            [pfo.chat.debug :refer [debug conversation-dumps dump-download]]
            [pfo.chat.model :as chat-model]
            [pfo.chat.common-component :refer [markdown-message]]
            [pfo.widget.icons :as icons]))

(def catom clojure.core/atom)

(declare group-collections tree permissions-edit group-list user-password-reset-form category-list-controls collection-type-list
         mfa-settings mfa-setup nomination-edit value-if-not-none load-all-families
         rollback-leftover-documents label-form)

(def demo-inactivity-limit 7) ;; days

(defn user-edit-link [user text]
  [:a {:href (str "#/admin/user/edit/" (:id user))} text])

(defn contact-edit-link [user text]
  [:a {:href (if (:is_contact user)
               (str "#/admin/contact/" (:id user) "/edit")
               (str "#/admin/user/edit/" (:id user)))} text])

(defn list-options [& components]
  [:div.o-media--1x05.u-shadow--bottom.u-width--full
   (doall (map-indexed (fn [idx component] [:div.list-option {:key idx} component]) (filter identity components)))])

(defn subscriber-chooser [{allow-empty :allow-empty
                           admin-only  :admin-only
                           load-cb :load-cb
                           preselect-if-one :preselect-if-one
                           filter-pred :filter-pred
                           :as         options}]
  (let [subscribers (atom nil)
        subscriber  (or (:subscriber-atom options) (atom nil))
        group       (or (:group-atom options) (atom nil))
        load-subscribers (fn []
                           (->> (model/subscribers admin-only)
                                (p/map
                                 (fn [response]
                                   (reset! subscribers (if filter-pred
                                                         (filterv filter-pred response)
                                                         response))
                                   (let [subscriber-id-to-set (when (or
                                                                     (and (not (value-if-not-none @subscriber)) (not allow-empty))
                                                                     (and
                                                                      (= 1 (count @subscribers))
                                                                      preselect-if-one))
                                                                (:id (first @subscribers)))]
                                     (when (and subscriber-id-to-set (not= (value-if-not-none @subscriber) subscriber-id-to-set))
                                       (reset! subscriber subscriber-id-to-set)
                                       (when (some? (:subscriber-changed-cb options))
                                         ((:subscriber-changed-cb options)
                                          (value-if-not-none @subscriber)
                                          (value-if-not-none @group)))))
                                   (some-> load-cb (apply [response]))))
                                (process-error)))]

    (load-subscribers)
    (when-let [reload-on-change (:reload-on-change options)]
      (add-watch reload-on-change :subscribers-reload-watch #(load-subscribers)))
    (fn []
      [:div
       [:ul [:li "Subscriber"]]
       [:select
        (merge {:on-change (fn [ev]
                             ((reset-from-event subscriber) ev)
                             (reset! group nil)
                             (when (some? (:subscriber-changed-cb options))
                               ((:subscriber-changed-cb options) (when (not= "<NONE>" @subscriber) @subscriber)
                                                                 (when (not= "<NONE>" @group) @group))))}
               (when (:disabled options) {:disabled :disabled}))
        (when allow-empty
          [:option {:value "<NONE>"} (or (:empty-label options) "-- Choose --")])
        (doall
         (for [sub @subscribers]
           [:option (option-value @subscriber (:id sub)) (util/add-inactive-to-name sub)]))]])))

(defn group-chooser [{allow-empty :allow-empty
                      admin-only :admin-only
                      filter-pred :filter-pred
                      all-families :all-families
                      load-cb :load-cb
                      preselect-if-one :preselect-if-one
                      :as options} initial-group-id]
  (let [groups (atom nil)
        group (or (:group-atom options) (atom nil))
        subscriber  (:subscriber-atom options)
        group-obj (or (:group-obj-atom options) (atom nil))
        selected?   (fn [obj]
                      (when (and (some? obj) (not= "<NONE>" @obj)) @obj))
        load-groups (fn [& [not-set-subscriber not-set-group]]
                      (let [subscriber-id (and subscriber (value-if-not-none @subscriber))]
                        (->>
                         (cond
                           (is-user-license-admin) (model/license-admin-groups)
                           subscriber-id (collection-model/permitted-subscriber-groups subscriber-id)
                           all-families (p/promise all-families)
                           :else (collection-model/permitted-groups nil))
                         (p/map
                          (fn [response]
                            (reset! groups
                                    (filter (or filter-pred identity) (if admin-only (auth-model/only-admin-groups response) response)))
                            (when-not (and @group (first (filterv #(= (str (:id %)) (str @group)) @groups)))
                              (let [group-id-to-set (if allow-empty
                                                      (if (and (= 1 (count @groups)) preselect-if-one)
                                                        (:id (first @groups))
                                                        (and (some #{initial-group-id} (map (comp str :id) @groups)) initial-group-id))
                                                      (or initial-group-id (:id (first @groups))))]
                                (when (and group-id-to-set (not not-set-group))
                                  (reset! group group-id-to-set)
                                  (when (and subscriber (not not-set-subscriber))
                                    (reset! subscriber (:subscriber_id (first (filterv #(= (:id %) group-id-to-set) @groups)))))))
                              (when @group
                                (some-> (:group-changed-cb options) (apply [(some-> subscriber (deref)) @group]))))
                            (reset! group-obj (first (filterv #(= (:id %) @group) @groups)))
                            (some-> load-cb (apply [subscriber-id @groups]))))
                         (process-error))))]
    (load-groups)
    (when subscriber
      (add-watch subscriber nil
                 (fn [_ _ old-subscriber new-subscriber]
                   (when (not= old-subscriber new-subscriber)
                     (load-groups true true)))))
    (when-let [reload-on-change (:reload-on-change options)]
      (add-watch reload-on-change :groups-reload-watch #(load-groups true true)))
    (fn []
      [:div
       (when-not (:hide-label options) [:ul [:li "Family"]])
       [:select
        {:on-change (fn [ev]
                      ((reset-from-event group) ev)
                      (reset! group-obj (first (filterv #(= (str (:id %)) @group) @groups)))
                      (when (some? (:group-changed-cb options))
                        (when (and subscriber (selected? group)) (reset! subscriber (:subscriber_id @group-obj)))
                        ((:group-changed-cb options) (when (and subscriber (not= "<NONE>" @subscriber)) @subscriber)
                                                     (when (not= "<NONE>" @group) @group))))
         :value (or @group "")}
        (when allow-empty
          [:option {:value "<NONE>"} (or (:empty-label options) "-- Choose --")])
        (doall
         (for [gr @groups]
           [:option {:value (:id gr) :key (:id gr)} (util/add-inactive-to-name gr)]))]])))

(defn collection-type-chooser [options group-id _]
  (let [collection-types (atom nil)]
    (->> (coltype-model/collection-types group-id (:order options))
         (p/map #(reset! collection-types %))
         (process-error))
    (fn [_ _ collection-type-atom]
      [:select {:on-change (reset-from-event collection-type-atom)}
       [:option {:value "<NONE>"} "Choose Collection Type"]
       (doall
        (for [ct @collection-types]
          [:option (option-value @collection-type-atom (:id ct)) (get-in ct [:asset_type :name]) ": " (:name ct)]))])))

(defn contact-list-controls [options]
  [:span
   (let [selected-group-atom (:selected-group-atom options)]
     (when-let [group-id (and selected-group-atom @selected-group-atom)]
       [:div
        [:button {:on-click (fn [_] (util/set-location (str "#/admin/contact/add?group_id=" group-id)))} "Add Contact"] " "
        [:button {:on-click (fn [_] (util/set-location (str "#/admin/contact/import?group_id=" group-id)))} "Import Contacts"]]))])

(defn contact-list [options group-id]
  (let [users (atom nil)
        load-contact-users (fn [_ group-id]
                             (->> (model/group-admin-contact-user-list group-id)
                                  (p/map #(reset! users %))
                                  (process-error)))]
    (fn []
      [:div
       [:div.filter.user-filter
        [:div.filter-items
         [list-options [group-chooser {:group-changed-cb load-contact-users
                                       :group-atom (:selected-group-atom options)
                                       :admin-only true} group-id]]]]
       (if (seq @users)
         [:table.user-list.t-table-redesign
          [:thead
           [:tr
            [:th "Name"]
            [:th "Type"]
            [:th "Company Name"]
            [:th "E-mail"]
            [:th "Phone Number"]
            [:th.icon ""]]]
          [:tbody (doall
                   (for [user @users]
                     [:tr
                      [:td [contact-edit-link user (let [full-name (auth-model/get-full-name user true)]
                                                     (or (not-empty full-name) (not-empty (:company_name user))))]]
                      [:td (if (:is_contact user) "Contact" "User")]
                      [:td (:company_name user)]
                      [:td.email.u-text-align-center [contact-edit-link user (:email user)]]
                      [:td (:phone_number user)]
                      [:td (when-let [collection-id (:collection_id user)]
                             {:class "icon collection u-cursor"
                              :on-click #(.open js/window
                                                (path-for :collection-details :id collection-id)
                                                "_blank")})]]))]]
         [:div.o-media "No contacts in this family."])])))

(defn us-states-chooser [options]
  (let [us-state-choices (atom [])
        load-us-states (fn []
                         (->> (model/us-states)
                              (p/map #(reset! us-state-choices %))
                              (process-error)))]
    (load-us-states)
    (fn []
      [:select.c-field-inline__field
       (merge {:on-change (fn [ev]
                            ((util/reset-from-event (:state-atom options)) ev))}
              (when (:disabled options) {:disabled :disabled}))
       (when (:allow-empty options)
         [:option {:value ""} (or (:empty-label options) "-- Choose --")])
       (doall
        (for [choice @us-state-choices]
          [:option  (option-value @(:state-atom options) (first choice)) (second choice)]))])))

(defn country-chooser [options]
  [:select.c-field-inline__field
   (merge {:on-change (fn [ev]
                        (when-let [on-change-cb (:on-change-cb options)]
                          (on-change-cb (util/event-value ev)))
                        ((util/reset-from-event (:value-atom options)) ev))}
          (when (:disabled options) {:disabled :disabled}))
   (when (:allow-empty options)
     [:option {:value ""} (or (:empty-label options) "-- Choose --")])
   (doall
    (for [choice (:countries options)]
      [:option  (option-value @(:value-atom options) (first choice)) (second choice)]))])

(defn highlighted-by-fin-cen-id [fin-cen-id]
  (when (blank? fin-cen-id)
    {:class :u-color--highlighted}))

(defn fincen-id-not-required? [options]
  (fn []
    (every?
     (complement blank?)
     (concat [@(:first-name options)
              @(:last-name options)
              @(:physical-address-line-1 options)
              @(:physical-address-line-2 options)
              @(:physical-address-city options)
              @(:physical-address-zip options)
              @(:physical-address-country options)
              @(:birth-date options)
              @(:id-type options)
              @(:id-country options)
              @(:id-number options)]
             (when (= @(:physical-address-country options) "United States") [@(:physical-address-state options)])
             (when (and (not= @(:id-type options) model/id-type-passport) (= @(:id-country options) "United States")) [@(:id-state options)])))))

(defn contact-edit [{:keys [on-submit
                            register-submit-action-fn
                            highlighted-by-fin-cen-id-fn
                            fincen-id-not-required-fn]
                     :as options} user group-id]
  (let [highlighted-by-fin-cen-id (or highlighted-by-fin-cen-id-fn highlighted-by-fin-cen-id)
        fincen-id-not-required? (or fincen-id-not-required-fn fincen-id-not-required?)
        errors (atom {})
        email (atom (:email user))
        first-name (atom (:first_name user))
        middle-name (atom (:middle_name user))
        last-name (atom (:last_name user))
        suffix (atom (:suffix user))
        phone-number (atom (:phone_number user))
        company-name (atom (:company_name user))
        title (atom (:title user))
        physical-address-line-1 (atom (:physical_address_line_1 user))
        physical-address-line-2 (atom  (:physical_address_line_2 user))
        physical-address-city (atom  (:physical_address_city user))
        physical-address-state (atom  (:physical_address_state user))
        physical-address-zip (atom  (:physical_address_zip user))
        physical-address-country (atom  (:physical_address_country user))
        physical-address-type (atom  (:physical_address_type user))
        ssn-ein (atom  (:ssn_ein user))
        citizenship-status (atom (:citizenship_status user))
        fin-cen-id (atom  (:fin_cen_id user))
        birth-date (atom (when-let [birth-date (:birth_date user)]
                           (tz/parsed-date-to-browser-date (time-coerce/to-date (util/parse-datetime birth-date)))))
        minor-child (atom (:minor_child user))
        individual (atom (if user (:individual user) true))
        exempt-entity (atom (or (not-empty (str (:exempt_entity user))) "false"))
        legal-name (atom (:legal_name user))
        id-type (atom (:id_type user))
        id-number (atom (:id_number user))
        id-country (atom (:id_country user))
        id-state (atom (:id_state user))
        collection-tree (atom {})
        collection (atom nil)
        coltact (atom nil)
        upload-id (atom nil)
        document-delete (atom false)
        show-more-expanded (atom false)
        assignment (track! (fn [] (when @collection
                                    {:main true
                                     :collection_id (:id @collection)
                                     :collection @collection})))
        include-inactive-atom (atom false)
        load-collection-with-ancestors (fn [collection-id]
                                         (->>
                                          (p/all [(collection-model/collection-details collection-id)
                                                  (collection-model/collection-ancestors collection-id)])
                                          (p/map (fn [[col ancestors]]
                                                   (assoc col :ancestors ancestors)))
                                          (process-error)))
        countries (subscribe :countries)
        load-countries #(controller/dispatch :countries :load {:scope model/country-scope-all})
        id-countries (subscribe :id-countries)
        load-id-countries (fn [scope]
                            (controller/dispatch :id-countries :load {:scope scope}))

        fincen-id-not-required (track! (fincen-id-not-required? {:first-name first-name
                                                                 :last-name last-name
                                                                 :physical-address-line-1 physical-address-line-1
                                                                 :physical-address-line-2 physical-address-line-2
                                                                 :physical-address-city physical-address-city
                                                                 :physical-address-state physical-address-state
                                                                 :physical-address-zip physical-address-zip
                                                                 :physical-address-country physical-address-country
                                                                 :birth-date birth-date
                                                                 :id-type id-type
                                                                 :id-number id-number
                                                                 :id-country id-country
                                                                 :id-state id-state}))
        download-form (atom nil)
        get-submit-args (fn []
                          {:first_name @first-name
                           :middle_name @middle-name
                           :last_name @last-name
                           :suffix @suffix
                           :phone_number @phone-number
                           :company_name @company-name
                           :title @title
                           :email @email
                           :physical_address_line_1 @physical-address-line-1
                           :physical_address_line_2 @physical-address-line-2
                           :physical_address_city @physical-address-city
                           :physical_address_state @physical-address-state
                           :physical_address_zip @physical-address-zip
                           :physical_address_country @physical-address-country
                           :physical_address_type @physical-address-type
                           :ssn_ein @ssn-ein
                           :citizenship_status @citizenship-status
                           :fin_cen_id @fin-cen-id
                           :birth_date  (and @birth-date (util/local-date-time-to-date-string @birth-date))
                           :minor_child (util/string-to-boolean @minor-child)
                           :individual @individual
                           :exempt_entity (util/string-to-boolean @exempt-entity)
                           :legal_name @legal-name
                           :id_type @id-type
                           :id_country @id-country
                           :id_state @id-state
                           :id_number @id-number
                           :collection_id (:id @collection)
                           :upload_id @upload-id
                           :document_delete @document-delete})
        on-submit-handler (fn []
                             (on-submit (get-submit-args)) )
        _ (some-> register-submit-action-fn (apply [on-submit-handler]))]
    (load-countries)
    (when (and user (not (:disable-coltact options)))
      (->> (collection-model/collection-tree group-id true @include-inactive-atom nil)
           (p/map (fn [response] (reset! collection-tree response)))
           (process-error))
      (controller/dispatch :coltact :get
                           [{:on-success (fn [clt]
                                           (reset! coltact clt)
                                           (when-let [col-id (:collection_id clt)]
                                             (->>
                                              (load-collection-with-ancestors col-id)
                                              (p/map #(reset! collection %)))))
                             :on-error (fn [err] (if (= 404 (:status err)) (reset! coltact {}) (throw err)))}
                            (:id user)]))
    (fn []
      [:div.o-media
       (when user
         [:div.o-flex-align--right
          (if @collection
            [:div.o-margin-elements--medium
             [:button {:on-click (fn []
                                   (when (js/confirm "Are you sure you want to unlink this contact's collection?")
                                     (controller/dispatch :coltact :save
                                                          [{:on-success (fn [document]
                                                                          (set-flash :success "Collection unlinked")
                                                                          (swap! state/collection-tree-modal assoc :enabled false)
                                                                          (reset! collection nil))}
                                                           (:id user)
                                                           nil])))}
              "Unlink"]
             [:button {:on-click #(util/set-location (str "#/admin/collection/edit/" (:id @collection) "/"))} "Edit"]]
            (when @coltact
              [:button
               {:on-click (util/handler (fn []
                                          (reset!
                                           state/collection-tree-modal
                                           {:enabled true
                                            :current-id nil
                                            :cb (fn [col]
                                                  (swap! state/collection-tree-modal
                                                         assoc :choosen-assignments
                                                         [{:collection (str (:id col))
                                                           :collection-obj (collection-model/to-search-obj col)
                                                           :main false}]
                                                         :disabled-ids #{(:id col)}))
                                            :on-save-cb (fn [arg]
                                                          (let [collection-id (:value (:collection-obj (first (:choosen-assignments @state/collection-tree-modal))))]
                                                            (controller/dispatch :coltact :save
                                                                                 [{:on-success (fn [_]
                                                                                                 (set-flash :success "Collection linked")
                                                                                                 (swap! state/collection-tree-modal assoc :enabled false)
                                                                                                 (when collection-id
                                                                                                   (->>
                                                                                                    (load-collection-with-ancestors collection-id)
                                                                                                    (p/map #(reset! collection %)))
                                                                                                   (swap! state/collection-tree-modal assoc :enabled false)))}
                                                                                  (:id user)
                                                                                  collection-id])))
                                            :options {:single-choice true}
                                            :tree-items collection-tree
                                            :include-inactive-atom include-inactive-atom})))}
               "Link Collection"]))])
       (if @assignment
         [:div
          [:div.u-border-bottom.u-margin-bottom
           [:h2 (:first_name user) " " (:last_name user)]
           [:h2 (:company_name user)]]
          [assignment-list-with-header {:label "Linked Collection"} [@assignment]]
          [:div.u-padding-top "All information for contacts linked to collections is provided by the collection details."]]
         [:div
          (when (:title options) [:h2 (:title options)])
          [:form.c-form--edit.c-form--input-wide
           {:on-submit (fn [ev]
                         (let [args (get-submit-args)]
                           (if on-submit
                             (on-submit args)
                             (->> ((if user
                                     (partial model/group-admin-contact-user-update (:id user))
                                     (partial model/group-admin-contact-user-add group-id)) args)
                                  (p/map (fn [_]
                                           (set-flash :success "Contact saved")
                                           (util/back ev)))
                                  (process-error errors))))
                         (.preventDefault ev))}

           (when-not (:show-more options) 
             [:dl
              [:dd [:label [:input (set-checked @individual {:on-click #(reset! individual (checked? %))})] "Individual"]
               [:span.error (:individual @errors "")]]])
           
           [:dl (when (:name-fields-inline options) {:class "c-form__name-fields-inline"})
            
            [:div.c-form__name-fields-inline-row  (when-not (:name-fields-inline options) {:class "u-margin-bottom"})
             [:dt (highlighted-by-fin-cen-id @fin-cen-id) "First Name: "]
             [:dd [:input.c-form__name-field (set-value first-name)]
              [:span.error (:first_name @errors "")]]]
            
            [:div.c-form__name-fields-inline-row  (when-not (:name-fields-inline options) {:class "u-margin-bottom"})
             [:dt (highlighted-by-fin-cen-id @fin-cen-id) "Middle Name: "]
             [:dd [:input.c-form__name-field (set-value middle-name)]
              [:span.error (:middle_name @errors "")]]]
            
            [:div.c-form__name-fields-inline-row  (when-not (:name-fields-inline options) {:class "u-margin-bottom"})
             [:dt (highlighted-by-fin-cen-id @fin-cen-id) "Last Name: "]
             [:dd [:input (set-value last-name)]
              [:span.error (:last_name @errors "")]]]
            
            [:div.c-form__name-fields-inline-row  (when-not (:name-fields-inline options) {:class "u-margin-bottom"})
             [:dt (highlighted-by-fin-cen-id @fin-cen-id) "Suffix: "]
             [:dd [:input (set-value suffix)]
              [:span.error (:suffix @errors "")]]]] 
           
           [:dl
            [:dt "Company Name"]
            [:dd [:input (set-value company-name)]
             [:span.error (:company_name @errors "")]]]

           [:dl
            [:dt "Title/Role"]
            [:dd [:input (set-value title)]
             [:span.error (:title @errors "")]]]
           
           [:dl
            [:dt "E-mail"]
            [:dd [:input (set-value email {:type :email})]
             [:span.error (:email @errors "")]]]
           
           [:dl
            [:dt "Phone Number"]
            [:dd [:input (set-value phone-number)]
             [:span.error (:phone_number @errors "")]]]

           (when (:show-more options)
             [:div.cs-show-more-btn {:on-click (fn [] (swap! show-more-expanded not))}
              (if @show-more-expanded "Show less" "Show more")])

           (when (or (not (:show-more options)) @show-more-expanded)
             [:div
              [:dl
               [:dt (highlighted-by-fin-cen-id @fin-cen-id) "Birth Date"]
               [:dd [pikaday/date-selector {:date-atom birth-date
                                            :calendar-icon (:calendar-icon options)}]
                [:span.error (:birth_date @errors "")]]]

              [:dl
               [:dt "Minor child"]
               [:span.c-note "Note: Selection is required if minor is BOI"]
               [:dd [:select.c-field-inline__field {:on-change (fn [ev]
                                                                 ((reset-from-event minor-child) ev))
                                                    :value @minor-child}
                     [:option {:value false} "No"]
                     [:option {:value true} "Yes"]]
                [:span.error (:minor_child @errors "")]]]

              [:dl
               [:dt (highlighted-by-fin-cen-id @fin-cen-id) "Street Address"]
               [:dd [:input (set-value physical-address-line-1)]
                [:span.error (:physical_address_line_1 @errors "")]]]

              [:dl
               [:dt (highlighted-by-fin-cen-id @fin-cen-id) "Suite/Unit Number"]
               [:dd [:input (set-value physical-address-line-2)]
                [:span.error (:physical_address_line_2 @errors "")]]]

              [:dl
               [:dt (highlighted-by-fin-cen-id @fin-cen-id) "City"]
               [:dd [:input (set-value physical-address-city)]
                [:span.error (:physical_address_city @errors "")]]]

              [:dl
               [:dt (highlighted-by-fin-cen-id @fin-cen-id) "Zip Code"]
               [:dd [:input (set-value physical-address-zip)]
                [:span.error (:physical_address_zip @errors "")]]]

              [:dl
               [:dt (highlighted-by-fin-cen-id @fin-cen-id) "Country"]
               [:dd
                [country-chooser {:value-atom physical-address-country
                                  :allow-empty true
                                  :on-change-cb (fn [country]
                                                  (when-not (= country "United States")
                                                    (reset! physical-address-state nil)))
                                  :countries @countries}]
                [:span.error (:physical_address_country @errors "")]]]

              (when (= @physical-address-country "United States")
                [:dl
                 [:dt (highlighted-by-fin-cen-id @fin-cen-id) "State"]
                 [:dd
                  [us-states-chooser {:state-atom physical-address-state
                                      :allow-empty true}]
                  [:span.error (:physical_address_state @errors "")]]])

              [:dl
               [:dt "SSN/EIN"]
               [:dd [:input (set-value ssn-ein)]
                [:span.error (:ssn_ein @errors "")]]]

              [:dl
               [:dt "Citizenship Status"]
               [:dd
                [:select.c-field-inline__field {:on-change (fn [ev]
                                                             ((reset-from-event citizenship-status) ev))}
                 [:option (option-value @citizenship-status "") "-- Choose --"]
                 [:option (option-value @citizenship-status "us_citizen") "US Citizen"]
                 [:option (option-value @citizenship-status "green_card_holder") "Green card holder"]
                 [:option (option-value @citizenship-status "non_us") "Non-US"]]
                [:span.error (:citizenship_status @errors "")]]]

              [:dl
               [:dt (when-not @fincen-id-not-required {:class :u-color--highlighted}) "FinCEN ID"]
               [:span.c-note "Note: If minor, use parent or guardian's FinCEN ID or other ID information"]
               [:dd [:input (set-value fin-cen-id)]
                [:span.error (:fin_cen_id @errors "")]]]

              [:dl
               [:dt "Address Type"]
               [:dd
                [:select.c-field-inline__field {:on-change (fn [ev]
                                                             ((reset-from-event physical-address-type) ev))}
                 [:option (option-value @physical-address-type "") "-- Choose --"]
                 [:option (option-value @physical-address-type "residential") "Residential"]
                 [:option (option-value @physical-address-type "business") "Business"]]
                [:span.error (:physical_address_type @errors "")]]]

              [:dl
               [:dt "Exempt Entity"]
               [:dd [:select.c-field-inline__field {:on-change (fn [ev]
                                                                 ((reset-from-event exempt-entity) ev)
                                                                 (when (= @exempt-entity "false")
                                                                   (reset! legal-name nil)))
                                                    :value @exempt-entity}
                     [:option {:value "false"} "No"]
                     [:option {:value "true"} "Yes"]]
                [:span.error (:exempt_entity @errors "")]]]
              (when (= @exempt-entity "true")
                [:dl
                 [:dt "Legal Name"]
                 [:dd
                  [:select.c-field-inline__field {:on-change (fn [ev]
                                                               ((reset-from-event legal-name) ev))}
                   [:option (option-value @legal-name "") "-- Choose --"]
                   [:option (option-value @legal-name "individual_last_name") "Individual Last Name"]
                   [:option (option-value @legal-name "entity_legal_name") "Entity Legal Name"]]
                  [:span.error (:legal_name @errors "")]]])

              [:dl
               [:dt (highlighted-by-fin-cen-id @fin-cen-id) "ID Type"]
               [:dd
                [:select.c-field-inline__field {:on-change (fn [ev]
                                                             ((reset-from-event id-type) ev)
                                                             (load-id-countries (model/country-scope-by-id-type @id-type))
                                                             (when (= @id-type model/id-type-passport)
                                                               (reset! id-state nil)))}
                 [:option (option-value @id-type "") "-- Choose --"]
                 [:option (option-value @id-type model/it-type-drivers-license) "State-issued driver's license"]
                 [:option (option-value @id-type model/id-type-state-local-tribe) "State/local/tribe-issued ID"]
                 [:option (option-value @id-type model/id-type-passport) "US Passport"]
                 [:option (option-value @id-type model/id-type-foreign-passport) "Foreign passport"]]
                [:span.error (:id_type @errors "")]]]

              [:dl
               [:dt (highlighted-by-fin-cen-id @fin-cen-id) "ID Number"]
               [:dd [:input (set-value id-number)]
                [:span.error (:id_number @errors "")]]]

              [:dl
               [:dt (highlighted-by-fin-cen-id @fin-cen-id) "ID Country/Jurisdiction"]
               [:dd
                [country-chooser {:value-atom id-country
                                  :allow-empty true
                                  :on-change-cb (fn [country]
                                                  (when-not (= country "United States")
                                                    (reset! id-state nil)))
                                  :countries @id-countries}]
                [:span.error (:id_country @errors "")]]]

              (when (and (= @id-country "United States") (not= @id-type model/id-type-passport))
                [:dl
                 [:dt (highlighted-by-fin-cen-id @fin-cen-id) "ID State"]
                 [:dd
                  [us-states-chooser {:state-atom id-state
                                      :allow-empty true}]
                  [:span.error (:id_state @errors "")]]])
              (when-not (:disable-id-document-upload options)
                [:dl.u-margin-bottom--lg
                 [:dt (highlighted-by-fin-cen-id @fin-cen-id) "ID Document"
                  [:div.u-margin-left--md {:style {:display :inline}}
                   (when (and
                          (:document_download_key user)
                          (not @document-delete))
                     [:button.c-button--small {:on-click (util/handler
                                                          (fn []
                                                            (when-let [form @download-form]
                                                              (.submit form))))} "Download ID Document"] )
                   " "
                   (when (and
                          (:document_download_key user)
                          (not @document-delete))
                     [:button.c-button--small
                      {:on-click (util/handler
                                  (fn []
                                    (if @upload-id
                                      (reset! upload-id nil)
                                      (reset! document-delete true))))}
                      "Delete ID Document"])]]

                 [:dd
                  (when @document-delete
                    [:span.c-note "Document will be deleted when contact is saved."])
                  (when (empty? (:document_download_key user))
                    [:div
                     [document-component/upload nil upload-id errors]
                     [:span.error (:upload_id @errors "")]])]])])

           (when-not (:disable-controls options)
             [:footer.u-flex
              [:button.c-button {:on-click util/back} "Cancel"]
              [:div.u-flex__element-to-right.o-margin-elements--xs
               (when (and user (:is_contact user))
                 [:button.c-button {:on-click (fn [ev]
                                                (when (js/confirm "Are you sure you want to delete this contact?")
                                                  (->> (model/group-admin-contact-user-delete (:id user))
                                                       (p/map (fn [_]
                                                                (set-flash :success "Contact deleted")
                                                                (util/back ev)
                                                                (.preventDefault ev)))
                                                       (process-error errors)))
                                                (.preventDefault ev))} "Delete contact"])
               [:button.c-button "Save contact"]]])]
          [:form {:method :post
                  :action (str "/download/document/")
                  :target "_blank"
                  :ref #(reset! download-form %)}
           [:input {:type :hidden
                    :name :key
                    :value (:document_download_key user)}]
           [:input {:type :hidden
                    :name :attachment
                    :value "no"}]
           [:input {:type :hidden
                    :name :btn
                    :value "1"}]]])])))

(defn contacts-import [_ group-id]
  (let [group (atom nil)
        error (atom nil)
        import-result (atom nil)]
    (->> (collection-model/collection-details group-id)
         (p/map #(reset! group %))
         (process-error))
    (fn []
      [:div.o-media
       (when @group
         [:h2 "Importing users to " (:name @group)])

       [:dl
        [:dt "CSV file:"]
        [:dd [upload-field {:url (api/api-url (str "/groupadmin/groups/" group-id "/contacts/csv/"))
                            :error-cb (fn [_]
                                        (reset! error "Import failed. Try again later."))
                            :success-cb (fn [_ response]
                                          (reset! error nil)
                                          (reset! import-result (js->clj response))
                                          (set-flash :success "Import successful"))}]]]
       [:span.error @error]

       (when-let [{imported-count "imported_count"
                   import-errors "import_errors"} @import-result]
         [:div
          [:p "Imported " imported-count " contact(s). "
           (when (seq import-errors)
             [:span "The following contacts have not been imported:"])]
          [:ul
           (doall
            (for [{first-name "first_name"
                   last-name "last_name"
                   email "email"
                   company-name "company_name"
                   country "country"
                   us-state "us_state"
                   row-num "row_num"
                   error-type "error_type"} import-errors]
              [:li first-name " " last-name (when-let [company (not-empty company-name)]
                                              (str " (" company ")")) ", row " row-num " ("
               (case error-type
                 "non_unique" "contact already exists"
                 "insufficient_data" "first name, last name or company name are required"
                 "invalid_email" (str email " is not an email address")
                 "invalid_country" (str country  " is not valid country")
                 "invalid_us_state" (str us-state " is not valid US state")
                 "invalid_state" "Only US states are allowed to import") ")"]))]])
       [:button.u-flex.u-flex--element-to-right {:on-click #(util/set-location (str "#/admin/contact/list?group_id=" group-id))} "I'm done"]])))


(defn subscribers-controls []
  [:button {:on-click #(set-location "#/admin/subscribers/add/")}
   "Add subscriber"])

(defn user-list-controls []
  [:button {:on-click #(set-location "#/admin/user/add")}
   "Add user"])

(defn user-list [users family-id load-users-func]
  (let [users (atom users)
        filter-active (atom "active")
        order (atom "name")
        current-page (atom 1)
        load-users (fn [page] (->>
                               (load-users-func family-id @filter-active @order page)
                               (p/map (fn [loaded-users]
                                        (reset! users loaded-users)
                                        (reset! current-page page)))
                               (process-error)))]
    (add-watch order :changed-order (fn [& _] (load-users @current-page)))
    (fn []
      [:div
       [:div.o-media--1x05.u-shadow--bottom
        [:ul [:li "Active status"]]
        [:select {:on-change (fn [ev]
                               ((reset-from-event filter-active) ev)
                               (load-users @current-page))}
         [:option (option-value @filter-active "active") "Active"]
         [:option (option-value @filter-active "inactive") "Inactive"]
         [:option (option-value @filter-active "all") "All"]]]

       (if (seq (:results @users))
         [:table.user-list.t-table-redesign
          [:thead
           [:tr
            [:th (orderer order "Name" "name")]
            [:th (orderer order "Login"  "login")]
            [:th (orderer order "E-mail"  "email")]
            [:th (if (is-user-license-admin)
                   "Type"
                   (orderer order "Type"  "user_type"))]
            [:th "Active?"]
            [:th "Registration status"]]]
          [:tbody (doall
                   (for [user (:results @users)]
                     [:tr {:key (:id user)}
                      [:td [user-edit-link user (str (:last_name user) ", " (:first_name user))]]
                      [:td [user-edit-link user (:login user)]]
                      [:td [user-edit-link user (:email user)]]
                      [:td.u-text-align-center
                       (if (is-user-license-admin)
                         (:admin_type user)
                         "Regular User")]
                      [:td.u-text-align-center (if (:is_active user) "yes" "no")]
                      [:td.u-text-align-center (case (:registration_confirmation_state user)
                                                 "notsent" "Email not sent"
                                                 "sent" "Email sent, awaiting password reset"
                                                 "pwsetauth" "Authenticated but no password set"
                                                 "pwset" "Password set"
                                                 :default (:registration_confirmation_state user))]]))]
          [tfoot-paginator
           [paginator
            (map (fn [page]
                   {:number page
                    :on-click (util/handler #(load-users page))})
                 (:page_numbers @users))
            @current-page
            (when (:has_previous @users) (util/handler #(load-users (- @current-page 1))))
            (when (:has_next @users) (util/handler #(load-users (+ @current-page 1))))]
           6
           (-> (:page_numbers @users) count (> 1))]]
         [:p.o-media "No users."])])))

(def shared-account-lock-message
  "This account also belongs to families you don't administer. For security, its credentials can't be changed here.")

(defn shared-account-locked?
  "True for a regular user shared with families outside the current family admin's scope.
   The backend restores credential fields on save (perm.UpdateRegularUser), so the login,
   e-mail, password, MFA reset and IP restriction inputs are locked in the UI to match."
  [user]
  (and (not (is-user-license-admin)) (> (:additional_group_count user) 0)))

(defn user-edit-form [options user]
  (let [errors (atom {})
        login (atom (:login user))
        email (atom (or (:email (:user options)) (:email user)))
        password (atom "")
        password-confirm (atom "")
        current-password (atom "")
        ;; The server re-authenticates only a caller changing their own password
        ;; (sec#153), so only then is the field asked for and sent.
        editing-self? (and (:id user) (= (str (:id user)) (str (api/get-auth-info :user-id))))
        first-name (atom (:first_name user))
        last-name (atom (:last_name user))
        uses-mfa (atom (:uses_mfa user))
        reset-mfa (atom false)
        is-active (atom (:is_active user))
        ip-restrict (atom (:ip_restrict user))
        ip-allowed (atom (:ip_allowed user))
        admin-nomination-notify (atom (:admin_nomination_notify user))
        timezone (atom (or (:timezone user) "America/New_York"))
        groups (atom (or (:group_ids (:user options)) (into #{} (:group_ids user))))
        original-groups (atom @groups)
        removed-groups (atom #{})
        current-groups (atom (or (:group_ids (:user options)) (into #{} (:group_ids user))))
        send-confirmation-email (atom (not (boolean user)))
        timezones (atom nil)
        admin-groups (atom nil)
        admin-group-count (clojure.core/atom nil)
        subscribers (atom nil)
        subscriber-ids (atom (or (:subscriber_ids (:user options)) (into #{} (:subscriber_ids user))))
        subscriber-id (atom (:subscriber_id user))
        load-timezones (fn [] (->> (auth-model/timezone-list)
                                   (p/map #(reset! timezones %))
                                   (process-error)))
        load-subscribers (fn []
                           (->> (model/license-admin-subscribers true nil)
                                (p/map (fn [response]
                                         (reset! subscribers response)))
                                (process-error)))
        regular-user-groups #(filterv (fn [gr] (and (contains? @removed-groups (:id gr)) (contains? @original-groups (:id gr)))) @admin-groups)
        keep-regular-user-in (atom {})
        load-groups (fn []
                      (->> ((:load-groups-func options))
                           (p/map
                            (fn [response]
                              (reset! admin-groups
                                      (for [group response
                                            :let  [result (if (and (contains? current-groups (:id group))
                                                                   (not= (str @subscriber-id) (str (:subscriber_id group))))
                                                            (assoc group :name (str (:name group) " (Invalid)"))
                                                            group)]]
                                        result))
                              (reset! admin-group-count (count response))))
                           (process-error)))]
    (when (is-user-license-admin)
      (load-subscribers))
    (load-timezones)
    (when (or (not user) (:allow-groups-edit options))
      (load-groups))
    (fn [options user]
      [:form.o-media.u-shadow--bottom.c-form--edit.c-form--spreaded
       {:on-submit (handler
                    (fn []
                      (if (not= @password @password-confirm)
                        (reset! errors {:password-confirm "Passwords don't match"})
                        (when (if (and
                                   user
                                   (is-user-license-admin)
                                   (not= "lic" (:user_type user))
                                   (and (empty? @groups) (empty? @subscriber-ids)))
                                (js/confirm "Removing user's Admin role from all families and subscriptions will make the user not visible to the License Admin. Continue?")
                                true)
                          (let [submit-func (if user (partial (:update-func options) (:id user)) (:add-func options))]
                            (->> (submit-func
                                  (merge
                                   {:login @login
                                    :email @email
                                    :password @password
                                    :first_name @first-name
                                    :last_name @last-name
                                    :timezone @timezone
                                    :uses_mfa @uses-mfa
                                    :reset_mfa @reset-mfa
                                    :is_active @is-active
                                    :ip_restrict @ip-restrict
                                    :ip_allowed @ip-allowed
                                    :send_confirmation_email @send-confirmation-email
                                    :permitted_subscriber_id (into [] @subscriber-ids)
                                    :group_id (into [] @groups)}
                                   (when (= "lic" (:user_type user))
                                     {:admin_nomination_notify @admin-nomination-notify})
                                   (when (is-user-license-admin)
                                     {:subscriber_id @subscriber-id :regular_user_group_id (mapv :id (filterv (fn [gr] (@keep-regular-user-in (:id gr))) (regular-user-groups)))})
                                   (when (and editing-self? (not-empty @password))
                                     {:current_password @current-password})))
                                 (p/map (fn [user-data]
                                          (set-flash :success "User saved")
                                          (when @send-confirmation-email
                                            (->> (if (is-user-license-admin)
                                                   (model/license-admin-send-registration-confirmation (:id user-data))
                                                   (model/group-admin-send-registration-confirmation (:id user-data)))
                                                 (process-error)))
                                          (util/set-location "#/admin/user/list")))
                                 (process-error errors [:current_password])))))))}
       [:div
        [:fieldset
         [:legend "User"]
         [:dl
          [:dt "Login"]
          [:dd
           [util/disable-tool {:disabled (shared-account-locked? user)
                               :message shared-account-lock-message
                               :component [:input {:type "text" :value @login :disabled (shared-account-locked? user) :on-change (reset-from-event login)}]}]
           [:span.error (:login @errors "")]]]

         [:dl
          [:dt "E-mail"]
          [:dd
           [util/disable-tool {:disabled (shared-account-locked? user)
                               :message shared-account-lock-message
                               :component [:input.u-width--full {:type "email" :value @email :disabled (or (some? (:user options)) (shared-account-locked? user))  :on-change (reset-from-event email)}]}]
           [:span.error (:email @errors "")]]]
         [:dl
          [:dt "First Name"]
          [:dd
           [:input {:type "text" :value @first-name :on-change (reset-from-event first-name)}]
           [:span.error (:first_name @errors "")]]]
         [:dl
          [:dt "Last Name"]
          [:dd
           [:input {:type "text" :value @last-name :on-change (reset-from-event last-name)}]
           [:span.error (:last_name @errors "")]]]
         (when editing-self?
           [:dl
            [:dt "Current Password" " (required to set a new password)"]
            [:dd
             ;; autocomplete tells the browser which field is which; without it
             ;; it fills the first password input with the stored login password.
             [:input {:type "password" :autocomplete "current-password"
                      :value @current-password :on-change (reset-from-event current-password)}]
             [:span.error (:current_password @errors "")]]])
         [:dl
          [:dt "Password" (when user " (leave empty to keep the old password)")]
          [:dd
           [util/disable-tool {:disabled (shared-account-locked? user)
                               :message shared-account-lock-message
                               :component [:input {:type "password" :autocomplete "new-password" :value @password :disabled (shared-account-locked? user) :on-change (reset-from-event password)}]}]
           [:span.error (:password @errors "")]]]
         [:dl
          [:dt "Confirm Password"]
          [:dd
           [util/disable-tool {:disabled (shared-account-locked? user)
                               :message shared-account-lock-message
                               :component [:input {:type "password" :autocomplete "new-password" :value @password-confirm :disabled (shared-account-locked? user) :on-change (reset-from-event password-confirm)}]}]
           [:span.error (:password-confirm @errors "")]]]
         [:dl
          [:dt "Time Zone"]
          [:dd
           [:select {:on-change (reset-from-event timezone)}
            [:option {:value ""} "Choose..."]
            (doall
             (for [tz @timezones]
               [:option (set-selected @timezone tz {:value tz :key tz}) tz]))]
           [:span.error (:timezone @errors "")]]]


         [:dl
          [:dd.u-margin-bottom
           [util/disable-tool {:disabled (shared-account-locked? user)
                               :message shared-account-lock-message
                               :component [:label
                                           [:input (set-checked @is-active (merge
                                                                            {:on-click #(reset! is-active (checked? %))}
                                                                            (when (shared-account-locked? user)
                                                                              {:disabled :disabled})))]  "Is Active?"]}]]

          (when (and
                 (not @uses-mfa)
                 (not @ip-restrict))
            [:dd.u-color--red.u-bold [:label {:style {:margin-left :0.3em}} "Leaving both boxes unchecked allows user to login with password and no additional authentication."]])
          [:dd [util/disable-tool {:disabled (shared-account-locked? user)
                                   :message shared-account-lock-message
                                   :component [:label [:input (set-checked @uses-mfa {:disabled (shared-account-locked? user) :on-click #(reset! uses-mfa (checked? %))})] "Multi-factor authentication required"]}]]
          [:span.error (:uses_mfa  @errors "")]

          (when (and @uses-mfa (:mfa_configured user))
            [:div
             [:dd [util/disable-tool {:disabled (shared-account-locked? user)
                                      :message shared-account-lock-message
                                      :component [:span
                                                  [:input (set-checked @reset-mfa {:disabled (shared-account-locked? user) :on-click #(reset! reset-mfa (checked? %))})] "Reset Multi-factor authentication device information on Save"]}]]
             [:span.error (:reset-mfa  @errors "")]])
          [:dd
           [util/disable-tool {:disabled (shared-account-locked? user)
                               :message shared-account-lock-message
                               :component [:label
                                           (form/checkbox ip-restrict {:disabled (shared-account-locked? user)}) "IP address restriction required"]}]]
          (when @ip-restrict
            [:dd [:label "Enter one or more approved IP addresses, or ranges of IP addresses"]
             [form/textarea ip-allowed {:rows 4
                                        :disabled (shared-account-locked? user)
                                        :placeholder "Example:
198.199.208.196
198.199.207.16-198.199.208.192
47.200.8.4"}]
             [:span.error.u-preserve-whitespace (:ip_allowed  @errors "")]])

          (when (and (is-user-license-admin) (not= (:user_type user) auth-model/user-type-license-admin))
            [:dl
             [:dt "SmarterU Subscriber"]
             [:dd
              [:select
               {:on-change (fn [event]
                             (reset! subscriber-id (-> event .-target .-value))
                             (load-groups))}
               [:option {:value ""} "Choose..."]
               (doall
                (for [subscriber @subscribers]
                  [:option
                   (set-selected @subscriber-id (:id subscriber) {:value (:id subscriber) :key (:id subscriber)})
                   (util/add-inactive-to-name subscriber)]))]
              [:span.error (:subscriber_id @errors "")]]])
          (when (= "lic" (:user_type user))
            [:dd
             [:label
              [:input (set-checked @admin-nomination-notify {:on-click #(reset! admin-nomination-notify (checked? %))})]] "Notify about admin nominations"])

          [:span.error (:is_active @errors "")]
          (when (and (is-user-license-admin) (not= (:user_type user) auth-model/user-type-license-admin))
            [:div
             [:legend "Subscription admin permissions"]
             [:ul
              (doall
               (for [asubscriber @subscribers]
                 (let [subscriber-id (:id asubscriber)]
                   [:li
                    {:key (:id asubscriber)}
                    [:label
                     [:input
                      (set-checked
                       (contains? @subscriber-ids subscriber-id)
                       {:on-click (fn [ev]
                                    (let [selected (-> ev .-target .-checked)]
                                      (if selected
                                        (swap! subscriber-ids conj subscriber-id)
                                        (swap! subscriber-ids disj subscriber-id))))})]
                     (model/subscriber-name asubscriber)]])))]
             [:span.error (:subscriber_ids @errors "")]])
          (when (and (is-user-license-admin) (not= (:user_type user) auth-model/user-type-license-admin))
            [:div
             [:div
              [:legend (if (is-user-license-admin) "Family Admin in" "Families")]
              [:ul
               (doall
                (for [agroup @admin-groups]
                  (let [group-id (:id agroup)]
                    [:li {:key (:id agroup)}
                     [:label
                      [:input (merge
                               (set-checked
                                (contains? @groups group-id)
                                {:on-click (fn [ev]
                                             (let [selected (-> ev .-target .-checked)]
                                               (if selected
                                                 (do
                                                   (swap! groups conj group-id)
                                                   (swap! removed-groups disj group-id))
                                                 (do
                                                   (swap! groups disj group-id)
                                                   (swap! removed-groups conj group-id)
                                                   (swap! keep-regular-user-in (fn [current group-id] (merge {group-id true} current)) group-id)))))})
                               (when (contains? @subscriber-ids (:subscriber_id agroup))
                                 {:disabled "disabled", :checked "checked"}))]
                      [:span (collection-model/collection-name agroup) " (" (:id agroup) ")"]]])))]
              [:span.error (:group_id @errors "")]]
             (when (and (is-user-license-admin) (seq (regular-user-groups)))
               [:div
                [:dt "Keep as Regular User in"]
                [:ul
                 (doall
                  (for [agroup (regular-user-groups)]
                    (let [group-id (:id agroup)]
                      [:li {:key (:id agroup)}
                       [:label
                        [:input (set-checked
                                 (@keep-regular-user-in group-id)
                                 {:on-click (fn [ev]
                                              (let [selected (-> ev .-target .-checked)]
                                                (if selected
                                                  (swap! keep-regular-user-in assoc group-id true)
                                                  (swap! keep-regular-user-in assoc group-id false))))})]
                        (collection-model/collection-name agroup)]])))]
                [:span.error (:regular_user_group_id @errors "")]])])

          (when-not user
            [:div.u-margin-top--xs
             [:dd [:input (set-checked @send-confirmation-email {:on-click #(reset! send-confirmation-email (checked? %))})] "Send registration confirmation e-mail"]
             [:span.error (:send_confirmation_email @errors "")]])]

         [:footer.u-flex
          [:button {:on-click util/back} "Back"]
          [:div.o-margin-elements--xs.u-flex__element-to-right (when user
                                                                 [:button (merge
                                                                           (when-not (:is_active user) {:disabled :disabled})
                                                                           {:on-click (util/handler (fn []
                                                                                                      (->> (if (is-user-license-admin)
                                                                                                             (model/license-admin-send-registration-confirmation (:id user))
                                                                                                             (model/group-admin-send-registration-confirmation (:id user)))
                                                                                                           (p/map #(set-flash :success "Registration email sent"))
                                                                                                           (process-error))))}) (if (= "notsent" (:registration_confirmation_state user))
                                                                                                                                  "Send registration e-mail"
                                                                                                                                  "Re-send registration e-mail")])
           [:button {:type "submit"} "Save"]]]]]])))

(defn user-invite-form [options atom-current-form]
  (let [errors (atom {})
        email (atom (:email nil))
        selected-groups (atom #{})
        admin-groups (atom {})
        invited-user-groups (atom #{})
        load-groups (fn [] (->> ((:load-groups-func options))
                                (p/map #(reset! admin-groups (auth-model/only-admin-groups %)))
                                (process-error)))

        user-groups-intersection #(reset! errors {:group_id
                                                  (if (seq (clojure.set/intersection @invited-user-groups @selected-groups))
                                                    "User is already invited or a member of the highlighted families." nil)})

        validate-form #(reset! errors {:group_id (if (empty? (vals @selected-groups)) "Choose at least one family" nil)
                                       :email (if (blank? @email) "Email required" nil)})

        can-submit? #(every? blank? (vals @errors))]

    (load-groups)

    (fn []
      [:form.o-media.u-shadow--bottom.c-form--edit
       {:on-submit (handler (fn [] (validate-form)
                              (when (can-submit?)
                                (->> (model/group-admin-invitations-user @email)
                                       ; 200
                                     (p/map (fn [response]
                                              (reset! errors {})

                                                ; Concat user groups where he is already a member and groups where he is already invited
                                              (reset! invited-user-groups
                                                      (set (map (fn [group] (:id group))
                                                                (concat (:groups response) (:invited_groups response)))))

                                              (user-groups-intersection)

                                                ; When no error, show invite confirmation page
                                              (when (blank? (:group_id @errors))
                                                (reset! atom-current-form {:id :invite-confirm :user (assoc response :selected-groups @selected-groups)}))))

                                     (p/error (fn [err]
                                                (reset! invited-user-groups #{})
                                                (case (:status err)
                                                  400 (reset! errors {:email "This user cannot be invited"})
                                                  404 (reset! atom-current-form {:id :add :user {:email @email :groups @selected-groups}})
                                                  (throw err))))
                                       ; 422
                                     (process-error errors)))))}
       [:dl
        [:dt "E-mail"]
        [:input.u-full-width {:value @email :type "email" :on-change (reset-from-event email)}]
        [:span.error (:email @errors "")]]

       [:dl
        [:dt "Families"]
        [:ul
         (doall
          (for [agroup @admin-groups]
            (let [group-id (:id agroup)]
              [:li {:key (:id agroup)}
               [:label {:class (when (contains? @invited-user-groups (@selected-groups group-id)) "error")}
                [:input (set-checked
                         (contains? @selected-groups group-id)
                         {:on-click (fn [ev]
                                      (let [selected (-> ev .-target .-checked)]
                                        (if selected
                                          (swap! selected-groups conj group-id)
                                          (swap! selected-groups disj group-id))))})]
                (collection-model/collection-name agroup)]])))]
        [:span.error (:group_id @errors "")]]

       [:footer.u-flex.u-flex--justify-content-space-between
        [:button.c-button {:type :button :on-click util/back} "Back"]
        [:button.c-button {:type "submit"} "Next"]]])))

(defn user-invite-confirm [options user]
  (let [errors (atom {})
        email (:email user)
        selected-groups (atom (:selected-groups user))
        admin-groups (atom {})
        load-groups (fn [] (->> ((:load-groups-func options))
                                (p/map #(reset! admin-groups %))
                                (process-error)))]
    (load-groups)

    (fn []
      [:div.invitation.o-media "Are you sure you want to invite " (auth-model/get-full-name user) " (" [:a {:href (str "mailto:" email)} email] ") to the groups below?"

       [:ul
        (map (fn [group] (when (contains? @selected-groups (:id group)) [:li (collection-model/collection-name group)]))  @admin-groups)]
       [:span.error (:group_id @errors " ")]

       [:div
        [:button {:on-click #(->> (model/group-admin-invite-user  email (vec @selected-groups))
                                  (p/map (fn [_]
                                           (reset! errors {})
                                           (set-flash :success "User invited")
                                           (util/back %)))

                                  (process-error errors))}  "Yes"] " "
        [:button {:on-click util/back} "No"]]])))

(defn user-invitation-list [_]
  (let [group (atom nil)
        invitations (atom nil)

        load-invitations (fn [_ group-id]
                           (->> (model/group-admin-invitation-list group-id)
                                (p/map #(reset! invitations %))
                                (process-error)))]
    (load-invitations nil nil)
    (fn []
      [:div.invitations
       [:div.filter.user-filter
        [:div.filter-items
         [list-options [group-chooser {:group-changed-cb load-invitations
                                       :group-atom group
                                       :allow-empty true
                                       :admin-only true
                                       :empty-label "-- All Families --"} nil]]]]
       (if (seq @invitations)
         [:table.t-table-redesign
          [:thead
           [:tr
            [:th "E-mail"]
            [:th "Families"]
            [:th "Status"]
            [:th ""]]]
          [:tbody (doall
                   (for [invitation @invitations]
                     (let [status (keyword (:status invitation))]
                       [:tr {:key (:uid invitation)}
                        [:td (:email_sent invitation)]
                        [:td.u-text-align-center (clojure.string/join ", " (mapv #(:name %) (:invited_groups invitation)))]
                        [:td (case status
                               :notsent "Not sent"
                               :sent "Sent, awaiting user action"
                               :accepted "Accepted"
                               :rejected "Rejected"
                               :canceled "Canceled"
                               "")]
                        [:td.u-text-align-center (when (contains? #{:sent :notsent} status)
                                                   [:span
                                                    [:a {:href "#"
                                                         :on-click (util/handler (fn []
                                                                                   (->> (model/group-admin-invitation-list-resend (:uid invitation))
                                                                                        (p/map (fn [_]
                                                                                                 (set-flash :success (str "Invitation for " (:email_sent invitation) " resent"))
                                                                                                 (load-invitations nil @group)))
                                                                                        (process-error))))} "Resend"]
                                                    " | "
                                                    [:a {:href "#"
                                                         :on-click (util/handler (fn []
                                                                                   (when (js/confirm "Are you sure you want to cancel this invitation?")
                                                                                     (->> (model/group-admin-invitation-list-cancel (:uid invitation))
                                                                                          (p/map (fn [_]
                                                                                                   (set-flash :success (str "Invitation for " (:email_sent invitation) " canceled"))
                                                                                                   (load-invitations nil @group)))
                                                                                          (process-error)))))} "Cancel"]])]])))]]
         [:div.o-media "No current invitations."])])))

(defn user-edit-form-options [edited-user]
  (if (is-user-license-admin)
    {:add-func model/license-admin-user-add
     :update-func model/license-admin-user-update
     :load-groups-func model/license-admin-groups
     :allow-groups-edit (not= (:user_type edited-user) auth-model/user-type-license-admin)}
    {:add-func model/group-admin-user-add
     :update-func model/group-admin-user-update
     :load-groups-func (fn []
                         (->> (model/group-admin-groups)
                              (p/map #(model/only-admin-groups %))))}))

(defn user-add []
  (let [current-form (atom {:id :invite :user nil})]
    (fn []
      (if (is-user-license-admin)
        [user-edit-form (user-edit-form-options nil) nil]
        (let [[title component] (case (:id @current-form)
                                  :invite ["Add a new user" [user-invite-form (user-edit-form-options nil) current-form]]
                                  ; Merge not yet added user to options argument
                                  :add ["Add a new user" [user-edit-form (merge (user-edit-form-options nil) {:user (assoc (:user @current-form)
                                                                                                                           :group_ids (get-in @current-form [:user :groups]))})]]
                                  :invite-confirm ["Confirm user invitation" [user-invite-confirm (user-edit-form-options nil) (:user @current-form)]])]
          [common/header-tab-wrapper title component])))))

(defn user-edit [user]
  (let [admin-groups (atom nil)
        admin-group-count (clojure.core/atom nil)
        user (atom user)
        load-groups (fn [] (->> (model/group-admin-managed-user-groups (:id @user))
                                (p/map (fn [groups]
                                         (reset! admin-groups groups)
                                         (reset! admin-group-count (count groups))))
                                (process-error)))
        user-groups (atom (into #{} (:group_ids @user)))
        edit-state (atom {:mode :none})]
    (when-not (is-user-license-admin)
      (load-groups))
    (fn []
      [common/header-tab-wrapper (str "Edit user: " (auth-model/get-full-name @user))
       [:div
        [user-edit-form (user-edit-form-options @user) @user]
        (when-not (is-user-license-admin)
          (doall
           (for [group @admin-groups]
             [:div {:key group} [group-collections user user-groups group edit-state @admin-group-count]])))]])))

(defn contact-user-add [permitted-users-atom group-id]
  (let [errors (atom nil)
        show-form (atom false)
        first-name (atom nil)
        middle-name (atom nil)
        last-name (atom nil)
        suffix (atom nil)
        email (atom nil)
        phone-number (atom nil)
        company-name (atom nil)
        title (atom nil)
        physical-address-line-1 (atom nil)
        physical-address-line-2 (atom nil)
        physical-address-city (atom nil)
        physical-address-state (atom nil)
        physical-address-zip (atom nil)
        physical-address-country (atom nil)
        physical-address-type (atom nil)
        ssn-ein (atom nil)
        citizenship-status (atom nil)
        fin-cen-id (atom nil)
        birth-date (atom nil)
        minor-child (atom nil)
        exempt-entity (atom nil)
        legal-name (atom nil)
        id-type (atom nil)
        id-number (atom nil)
        id-country (atom nil)
        id-state (atom nil)
        clear-form! (fn []
                      (doseq [form-atom [first-name last-name email phone-number company-name title]]
                        (reset! form-atom nil))
                      (reset! errors nil))
        countries (subscribe :countries)
        load-countries #(controller/dispatch :countries :load {:scope model/country-scope-all})
        id-countries (subscribe :id-countries)
        load-id-countries (fn [scope]
                            (controller/dispatch :id-countries :load {:scope scope}))
        fincen-id-not-required (track! (fincen-id-not-required? {:first-name first-name
                                                                 :last-name last-name
                                                                 :physical-address-line-1 physical-address-line-1
                                                                 :physical-address-line-2 physical-address-line-2
                                                                 :physical-address-city physical-address-city
                                                                 :physical-address-state physical-address-state
                                                                 :physical-address-zip physical-address-zip
                                                                 :physical-address-country physical-address-country
                                                                 :birth-date birth-date
                                                                 :id-type id-type
                                                                 :id-number id-number
                                                                 :id-country id-country
                                                                 :id-state id-state}))
        upload-id (atom nil)]
    (load-countries)
    (fn []
      (if @show-form
        [:div.c-field-contact-user-add.o-margin-elements--md-vertical
         [:ul
          [:li.c-field-inline--small
           [:label (highlighted-by-fin-cen-id @fin-cen-id) "First Name: "]
           [:input {:type "text"
                    :on-change (util/reset-from-event first-name)}]
           [:span.error (:first_name @errors "")]]
          [:li.c-field-inline--small
           [:label (highlighted-by-fin-cen-id @fin-cen-id) "Middle Name: "]
           [:input {:type "text"
                    :on-change (util/reset-from-event middle-name)}]
           [:span.error (:middle_name @errors "")]]
          [:li.c-field-inline--small
           [:label (highlighted-by-fin-cen-id @fin-cen-id) "Last Name: "]
           [:input {:type "text"
                    :on-change (util/reset-from-event last-name)}]
           [:span.error (:last_name @errors "")]]
          [:li.c-field-inline--small
           [:label (highlighted-by-fin-cen-id @fin-cen-id) "Suffix: "]
           [:input {:type "text"
                    :on-change (util/reset-from-event suffix)}]
           [:span.error (:suffix @errors "")]]
          [:li.c-field-inline--small
           [:label (highlighted-by-fin-cen-id @fin-cen-id) "Birth Date: "]
           [pikaday/date-selector {:date-atom birth-date}]
           [:span.error (:birth_date @errors "")]]
          [:li.c-field-inline--small
           [:label "Minor child: "]
           [:select {:on-change (fn [ev]
                                  ((reset-from-event minor-child) ev))}
            [:option {:value false} "No"]
            [:option {:value true} "Yes"]]
           [:span.c-note " Note: Selection is required if minor is BOI"]
           [:span.error (:minor_child @errors "")]]
          [:li.c-field-inline--small
           [:label "Company Name: "]
           [:input {:type "text"
                    :on-change (util/reset-from-event company-name)}]
           [:span.error (:company_name @errors "")]]
          [:li.c-field-inline--small
           [:label "Title/Role: "]
           [:input {:type "text"
                    :on-change (util/reset-from-event title)}]
           [:span.error (:title @errors "")]]
          [:li.c-field-inline--small
           [:label "E-mail: "]
           [:input {:type "email"
                    :on-change (util/reset-from-event email)}]
           [:span.error (:email @errors "")]]
          [:li.c-field-inline--small
           [:label "Phone Number: "]
           [:input {:type "text"
                    :on-change (util/reset-from-event phone-number)}]
           [:span.error (:phone_number @errors "")]]
          [:li.c-field-inline--small
           [:label (highlighted-by-fin-cen-id @fin-cen-id) "Street Address: "]
           [:input {:type "text"
                    :on-change (util/reset-from-event physical-address-line-1)}]
           [:span.error (:physical_address_line_1 @errors "")]]
          [:li.c-field-inline--small
           [:label (highlighted-by-fin-cen-id @fin-cen-id) "Suite/Unit Number: "]
           [:input {:type "text"
                    :on-change (util/reset-from-event physical-address-line-2)}]
           [:span.error (:physical_address_line_2 @errors "")]]
          [:li.c-field-inline--small
           [:label (highlighted-by-fin-cen-id @fin-cen-id) "City: "]
           [:input {:type "text"
                    :on-change (util/reset-from-event physical-address-city)}]
           [:span.error (:physical_address_city @errors "")]]
          [:li.c-field-inline--small
           [:label (highlighted-by-fin-cen-id @fin-cen-id) "Zip Code: "]
           [:input {:type "text"
                    :on-change (util/reset-from-event physical-address-zip)}]
           [:span.error (:physical_address_zip @errors "")]]
          [:li.c-field-inline--small
           [:label (highlighted-by-fin-cen-id @fin-cen-id) "Country: "]
           [country-chooser {:value-atom physical-address-country
                             :allow-empty true
                             :on-change-cb (fn [country]
                                             (when-not (= country "United States")
                                               (reset! physical-address-state nil)))
                             :countries @countries}]
           [:span.error (:physical_address_country @errors "")]]
          (when (= @physical-address-country "United States")
            [:li.c-field-inline--small
             [:label (highlighted-by-fin-cen-id @fin-cen-id) "State: "]
             [us-states-chooser {:state-atom physical-address-state :allow-empty true}]
             [:span.error (:physical_address_state @errors "")]])
          [:li.c-field-inline--small
           [:label "SSN/EIN: "]
           [:input {:type "text"
                    :on-change (util/reset-from-event ssn-ein)}]
           [:span.error (:ssn_ein @errors "")]]
          [:li.c-field-inline--small
           [:label "Citizenship Status: "]
           [:select {:on-change (fn [ev]
                                  ((reset-from-event citizenship-status) ev))}
            [:option (option-value @citizenship-status "") "-- Choose --"]
            [:option (option-value @citizenship-status "us_citizen") "US Citizen"]
            [:option (option-value @citizenship-status "green_card_holder") "Green card holder"]
            [:option (option-value @citizenship-status "non_us") "Non-US"]]
           [:span.error (:citizenship_status @errors "")]]
          [:li.c-field-inline--small
           [:label (when-not @fincen-id-not-required {:class :u-color--highlighted}) "FinCEN ID: "]
           [:input {:type "text"
                    :on-change (util/reset-from-event fin-cen-id)}]
           [:span.c-note " Note: If minor, use parent or guardian's FinCEN ID or other ID information"]
           [:span.error (:fin_cen_id @errors "")]]
          [:li.c-field-inline--small
           [:label "Address Type: "]
           [:select {:on-change (fn [ev]
                                  ((reset-from-event physical-address-type) ev))}
            [:option (option-value @physical-address-type "") "-- Choose --"]
            [:option (option-value @physical-address-type "residential") "Residential"]
            [:option (option-value @physical-address-type "business") "Business"]]
           [:span.error (:physical_address_type @errors "")]]
          [:li.c-field-inline--small
           [:label "Exempt Entity: "]
           [:select {:on-change (fn [ev]
                                  ((reset-from-event exempt-entity) ev))}
            [:option {:value false} "No"]
            [:option {:value true} "Yes"]]
           [:span.error (:exempt_entity @errors "")]]
          (when (= @exempt-entity "true")
            [:li.c-field-inline--small
             [:label "Legal Name: "]
             [:select {:on-change (fn [ev]
                                    ((reset-from-event legal-name) ev))}
              [:option (option-value @legal-name "") "-- Choose --"]
              [:option (option-value @legal-name "individual_last_name") "Individual Last Name"]
              [:option (option-value @legal-name "entity_legal_name") "Entity Legal Name"]]
             [:span.error (:legal_name @errors "")]])
          [:li.c-field-inline--small
           [:label (highlighted-by-fin-cen-id @fin-cen-id) "ID Type: "]
           [:select {:on-change (fn [ev]
                                  ((reset-from-event id-type) ev)
                                  (load-id-countries (model/country-scope-by-id-type @id-type))
                                  (when (= @id-type model/id-type-passport)
                                    (reset! id-state nil)))}
            [:option (option-value @id-type "") "-- Choose --"]
            [:option (option-value @id-type model/it-type-drivers-license) "State-issued driver's license"]
            [:option (option-value @id-type model/id-type-state-local-tribe) "State/local/tribe-issued ID"]
            [:option (option-value @id-type model/id-type-passport) "US Passport"]
            [:option (option-value @id-type model/id-type-foreign-passport) "Foreign passport"]]
           [:span.error (:id_type @errors "")]]
          [:li.c-field-inline--small
           [:label (highlighted-by-fin-cen-id @fin-cen-id) "ID Number: "]
           [:input {:type "text"
                    :on-change (util/reset-from-event id-number)}]
           [:span.error (:id_number @errors "")]]
          [:li.c-field-inline--small
           [:label (highlighted-by-fin-cen-id @fin-cen-id) "ID Country: "]
           [country-chooser {:value-atom id-country
                             :allow-empty true
                             :on-change-cb (fn [country]
                                             (when-not (= country "United States")
                                               (reset! id-state nil)))
                             :countries @id-countries}]
           [:span.error (:id_country @errors "")]]
          (when (and (= @id-country "United States") (not= @id-type model/id-type-passport))
            [:li.c-field-inline--small
             [:label (highlighted-by-fin-cen-id @fin-cen-id) "ID State: "]
             [us-states-chooser {:state-atom id-state :allow-empty true}]
             [:span.error (:id_state @errors "")]])
          [:li.c-field-inline--small
           [:label (highlighted-by-fin-cen-id @fin-cen-id) "ID Document: "]
           [:div.c-form--edit [document-component/upload nil upload-id errors]]
           [:span.error (:upload_id @errors "")]]]
         [:div.o-margin-elements--xs
          [:button {:on-click (util/handler (fn [] (swap! show-form not) (clear-form!)))} "Cancel"]
          [:button {:on-click (util/handler (fn []
                                              (->> (model/group-admin-contact-user-add group-id {:first_name @first-name
                                                                                                 :middle_name @middle-name
                                                                                                 :last_name @last-name
                                                                                                 :suffix @suffix
                                                                                                 :email @email
                                                                                                 :phone_number @phone-number
                                                                                                 :company_name @company-name
                                                                                                 :title @title
                                                                                                 :physical_address_line_1 @physical-address-line-1
                                                                                                 :physical_address_line_2 @physical-address-line-2
                                                                                                 :physical_address_city @physical-address-city
                                                                                                 :physical_address_state @physical-address-state
                                                                                                 :physical_address_zip @physical-address-zip
                                                                                                 :physical_address_country @physical-address-country
                                                                                                 :physical_address_type @physical-address-type
                                                                                                 :ssn_ein @ssn-ein
                                                                                                 :citizenship_status @citizenship-status
                                                                                                 :fin_cen_id @fin-cen-id
                                                                                                 :birth_date (and @birth-date (util/local-date-time-to-date-string @birth-date))
                                                                                                 :minor_child @minor-child
                                                                                                 :exempt_entity @exempt-entity
                                                                                                 :legal_name @legal-name
                                                                                                 :id_type @id-type
                                                                                                 :id_country @id-country
                                                                                                 :id_state @id-state
                                                                                                 :id_number @id-number
                                                                                                 :upload_id @upload-id})
                                                   (p/map (fn [user]
                                                            (swap! permitted-users-atom conj user)
                                                            (swap! show-form not)
                                                            (clear-form!)))
                                                   (process-error errors))))}
           "Save contact"]]]
        [:button {:on-click (util/handler #(swap! show-form not))} "+ Add New Contact"]))))

(defn set-flag [state key]
  (swap! state assoc key (not (get @state key))))

(defn- collection-tree-id-set [tree]
  (loop [items [tree]
         ids #{}]
    (let [item (first items)
          new-items (concat (:subitems item) (rest items))
          ids (if-let [item-id (get-in item  [:item_data :id])]
                (conj ids item-id)
                ids)]
      (if (seq new-items)
        (recur new-items ids)
        ids))))

(defn group-collections [user user-groups group edit-state _]
  (let [group-id                                                        (:id group)
        edit-state-mode #(@edit-state :mode)
        is-disabled                                                     #(not= (edit-state-mode) :none)
        reset-edit-state                                                #(reset! edit-state {:mode :none})
        set-edited                                                      #(reset! edit-state {:id group-id
                                                                                             :mode :permissions})
        set-nomination #(reset! edit-state {:id group-id
                                            :mode :nomination})
        collection-tree                                                 (atom nil)
        temporary-new-group-id                                          (atom nil)
        timeout                                                         (atom nil)
        show-spinner                                                    (atom false)
        collection-types                                                (atom nil)
        aname                                                           (atom nil)
        collection-type                                                 (atom nil)
        preview                                                         (atom false)
        filter-state                                                    (atom
                                                                         {:added    false
                                                                          :deleted  false
                                                                          :selected false})
        filter-state-backup                                             (atom {})
        filtered-collections                                            (atom #{})
        selected-tree-item-id                                           (atom nil)
        load-collection-tree                                            (fn []
                                                                          (->>
                                                                           (collection-model/collection-tree group-id false true
                                                                                                             (merge
                                                                                                              {:name    @aname
                                                                                                               :type_id (util/to-value @collection-type)
                                                                                                               :ids     @filtered-collections}
                                                                                                              (when (some (fn [[_ v]] v) @filter-state) {:filter_by_id 1})))
                                                                           (p/map
                                                                            (fn [response]
                                                                              (reset! collection-tree response)
                                                                              (reset! selected-tree-item-id nil)))
                                                                           (process-error)))
        permissions                                                     (atom #{})
        primary-reviewer-id                                             (atom nil)
        secondary-reviewer-id                                           (atom nil)
        family-users                                                    (atom [])
        load-family-users                                               (fn []
                                                                          (->> (model/group-admin-permitted-users {:regular-only true} [group-id])
                                                                               (p/map #(reset! family-users %))
                                                                               (process-error)))
        initial-permitted-collections                                   (atom #{})
        permitted-collections                                           (atom #{})
        added-collections                                               (fn []
                                                                          (clojure.set/difference @permitted-collections @initial-permitted-collections))
        added-active                                                    (fn []
                                                                          (and (seq (added-collections)) (not (:selected @filter-state))))
        deleted-collections                                             (fn []
                                                                          (clojure.set/difference @initial-permitted-collections @permitted-collections))
        deleted-active                                                  (fn []
                                                                          (seq (deleted-collections)))
        selected-active                                                 (fn []
                                                                          (seq @permitted-collections))
        filtered-collections-func                                       (fn []
                                                                          (clojure.set/union #{} (when (:added @filter-state) (added-collections))
                                                                                             (when (:selected @filter-state) @permitted-collections)
                                                                                             (when (:deleted @filter-state) (deleted-collections))))
        load-permitted-collection-ids                                   (fn []
                                                                          (->> (model/group-admin-user-collection-ids (:id @user) group-id)
                                                                               (p/map
                                                                                (fn [response]
                                                                                  (let [id-set (into #{} (:collection_ids response))]
                                                                                    (reset! permissions (into #{} (:permissions response)))
                                                                                    (reset! primary-reviewer-id (:primary_reviewer_id response))
                                                                                    (reset! secondary-reviewer-id (:secondary_reviewer_id response))
                                                                                    (reset! initial-permitted-collections id-set)
                                                                                    (reset! permitted-collections id-set))))))
        changes-made                                                    (atom false)
        confirm-cancel                                                  #(.confirm js/window "You've made some changes, are you sure you want to cancel?")
        clear-state-filter                                              (fn []
                                                                          (swap! filter-state assoc :added false :selected false :deleted false))
        reload                                                          (fn []
                                                                          (reset! permitted-collections @initial-permitted-collections)
                                                                          (reset! changes-made false)
                                                                          (reset! aname nil)
                                                                          (reset! collection-type nil)
                                                                          (clear-state-filter)
                                                                          (reset! preview false)
                                                                          (reset! filtered-collections (filtered-collections-func))
                                                                          (reset-edit-state)
                                                                          (when @temporary-new-group-id
                                                                            (swap! user-groups disj @temporary-new-group-id)
                                                                            (reset! temporary-new-group-id nil)))
        cancel                                                          (util/handler (fn []
                                                                                        (if @changes-made
                                                                                          (when (confirm-cancel)
                                                                                            (reload))
                                                                                          (reload))))
        default-collapsed                                               (atom true)
        collapsed                                                       (atom {})
        load-collection-types                                           (fn []
                                                                          (->> (coltype-model/collection-types group-id nil)
                                                                               (p/map #(reset! collection-types %))
                                                                               (process-error)))
        expand-all                                                      (fn []
                                                                          (reset! collapsed {})
                                                                          (reset! default-collapsed false))
        collapse-all                                                    (fn []
                                                                          (reset! collapsed {})
                                                                          (reset! default-collapsed true))
        filter-set-to-elements-to-save                                  (fn []
                                                                          (reset! aname nil)
                                                                          (reset! collection-type nil)
                                                                          (swap! filter-state merge
                                                                                 (when (added-active) {:added true})
                                                                                 (when (selected-active) {:selected true})
                                                                                 (when (deleted-active) {:deleted true})))]
    (add-watch filtered-collections :filtered-collections-watch
               (fn [& _] (when (seq @filtered-collections) (expand-all))
                 (load-collection-tree)))
    (fn [user user-groups group edit-state _]
      [:div.u-shadow--bottom
       [:div.o-media.o-space-between
        [:h3
         [:input
          (set-checked
           (contains? @user-groups group-id)
           (merge
            {:on-click (fn [ev]
                         (let [selected (-> ev .-target .-checked)]
                           (if selected
                             (do
                               (swap! user-groups conj group-id)
                               (reset! temporary-new-group-id group-id)
                               (set-edited)
                               (load-collection-tree)
                               (load-permitted-collection-ids)
                               (load-collection-types)
                               (load-family-users))
                             (if (or (> (count @user-groups) 1) (> (:additional_group_count @user) 0))
                               (when
                                (.confirm js/window
                                          (str "Are you sure you want to remove all of the user's permissions in "
                                               (:name group) "?"))
                                 (->>
                                  (model/group-admin-user-group-access-remove
                                   (:id @user) group-id)
                                  (p/map
                                   (fn [_]
                                     (load-permitted-collection-ids)
                                     (reload)
                                     (set-flash :success "Permissions updated")
                                     (swap! user-groups disj (:id group))
                                     (when (zero? (count @user-groups))
                                       (util/set-location "#/admin/user/list"))))
                                  (process-error)))
                               (js/alert "User has to have access to at least one group.")))))}
            (when (is-disabled)
              {:disabled "disabled"})))]
         (collection-model/collection-name group)]
        [:div
         (condp = @edit-state
           {:mode :nomination
            :id group-id} [:button.c-button {:href "#" :on-click cancel} "Close"]
           {:mode :permissions
            :id group-id} [:button.c-button {:href "#" :on-click cancel} "Cancel edit"]
           [:div
            [:button.c-button
             {:href "#" :on-click (util/handler #(set-nomination))}
             "Admin nomination"]
            [:button.c-button
             {:href "#" :on-click (util/handler (fn []
                                                  (set-edited)
                                                  (load-collection-tree)
                                                  (load-permitted-collection-ids)
                                                  (load-collection-types)
                                                  (load-family-users)))}
             "Edit permissions"]])]]

       (condp = @edit-state
         {:mode :permissions
          :id group-id} [:div
                         [permissions-edit permissions changes-made group-id
                          primary-reviewer-id secondary-reviewer-id family-users user]

                         (when @collection-tree
                           [:div
                            [:h2.o-media--margin "Assigned collections"]

                            (let [selection-root-id (or @selected-tree-item-id group-id)
                                  include-self      (boolean @selected-tree-item-id)]
                              [:section.o-media--margin.o-margin-elements--xs
                               [:button
                                {:on-click (fn [_] (expand-all))}
                                "Expand All"]
                               [:button
                                {:on-click (fn [_] (collapse-all))}
                                "Collapse All"]
                               [:button
                                {:on-click (fn [_]
                                             (->> (model/group-admin-descendants selection-root-id include-self)
                                                  (p/map
                                                   (fn [response]
                                                     (swap!
                                                      permitted-collections clojure.set/union
                                                      (set/intersection
                                                       (into #{} (map #(:id %) response))
                                                       (collection-tree-id-set @collection-tree)))
                                                     (reset! changes-made true)))))}
                                "Select"
                                (if @selected-tree-item-id [:span [:br] "Subcollections"] " All")]

                               [:button
                                {:on-click (fn [_]
                                             (->> (model/group-admin-descendants selection-root-id include-self)
                                                  (p/map
                                                   (fn [response]
                                                     (swap!
                                                      permitted-collections clojure.set/difference
                                                      (set/intersection
                                                       (into #{} (map #(:id %) response))
                                                       (collection-tree-id-set @collection-tree)))
                                                     (reset! changes-made true)))))}
                                "Deselect"
                                (if @selected-tree-item-id [:span [:br] "Subcollections"] " All")]])

                            [:section.o-media--margin
                             [:section.o-main-aside
                              [:main
                               [tree
                                {:default-collapsed     default-collapsed
                                 :collapsed             collapsed
                                 :permitted             permitted-collections
                                 :added-collections     (added-collections)
                                 :deleted-collections   (deleted-collections)
                                 :changes-made          changes-made
                                 :selected-tree-item-id selected-tree-item-id
                                 :on-click-cb           nil
                                 :disabled              @preview}
                                @collection-tree]]
                              (when (not @preview)
                                [sidebar
                                 [:div.filter-item.u-margin-top.c-form--edit
                                  [:h3.u-margin-bottom.u-border-bottom.u-cursor--pointer
                                   "Filter by name"]
                                  [:div.u-flex
                                   {:svaluetyle {:flex-warap "nowrap"}}
                                   [:input.u-width--full
                                    {:on-change    (fn [ev]
                                                     (reset! aname (-> ev .-target .-value))
                                                     (when (let [cnt (count @aname)] (or (zero? cnt) (> cnt 2)))
                                                       (when @timeout
                                                         (reset! show-spinner false)
                                                         (js/clearTimeout @timeout)
                                                         (reset! timeout nil))
                                                       (reset! show-spinner true)
                                                       (reset! timeout
                                                               (js/setTimeout
                                                                (fn []
                                                                  (load-collection-tree)
                                                                  (expand-all))
                                                                1000)))
                                                     (.preventDefault ev))
                                     :value        @aname
                                     :autocomplete :off}]
                                   [:button.c-round-button
                                    {:style    {:margin "0.5em 0.5em"}
                                     :on-click (util/handler
                                                (fn []
                                                  (reset! aname nil)
                                                  (load-collection-tree)))}
                                    "×"]]]
                                 [:div.filter-item.u-margin-top.c-form--edit
                                  [:h3.u-margin-bottom.u-border-bottom.u-cursor--pointer
                                   "Filter by type"]
                                  [:div.u-flex
                                   {:style {:flex-warap "nowrap"}}
                                   [:select.c-field-inline__field
                                    {:on-change (fn [ev]
                                                  ((reset-from-event collection-type) ev)
                                                  (load-collection-tree))}
                                    [:option {:value ""} "Not selected"]
                                    (doall
                                     (for [coltype @collection-types]
                                       [:option
                                        (set-selected @collection-type (:id coltype)
                                                      {:key   (:id coltype)
                                                       :value (:id coltype)})
                                        (get-in coltype [:asset_type :name])
                                        ": "
                                        (:name coltype)]))]
                                   [:button.c-round-button
                                    {:style    {:margin "0.5em 0.5em"}
                                     :on-click (util/handler
                                                (fn []
                                                  (reset! collection-type nil)
                                                  (load-collection-tree)))}
                                    "×"]]]
                                 [:div.filter-item.u-margin-top.c-form--edit
                                  [:h3.u-margin-bottom.u-border-bottom.u-cursor--pointer
                                   "Filter by state"]
                                  [:div.u-flex
                                   [:label
                                    [:input
                                     (set-checked (get @filter-state :added)
                                                  {:on-click (fn [_]
                                                               (set-flag filter-state :added)
                                                               (reset! filtered-collections (filtered-collections-func)))})]
                                    "Added"]
                                   [:label
                                    [:input
                                     (set-checked (:selected @filter-state)
                                                  {:on-click (fn [_]
                                                               (set-flag filter-state :selected)
                                                               (reset! filtered-collections (filtered-collections-func)))})]
                                    "Selected"]
                                   [:label
                                    [:input
                                     (set-checked (:deleted @filter-state)
                                                  {:on-change (fn [_]
                                                                (set-flag filter-state :deleted)
                                                                (reset! filtered-collections (filtered-collections-func)))})]
                                    "Deleted"]
                                   [:button.c-round-button
                                    {:style    {:position "relative" :left "0.4em" :top "0.2em"}
                                     :on-click (util/handler
                                                (fn []
                                                  (clear-state-filter)
                                                  (reset! filtered-collections (filtered-collections-func))))}
                                    "×"]]]])]]

                            [:section.o-media.u-flex.u-flex--justify-content-space-between
                             [:button {:type :button :on-click cancel} "Cancel"]
                             [:label.o-space-between
                              (if @preview
                                [:label
                                 [:button
                                  {:on-click (fn [_]
                                               (reset! aname (:aname @filter-state-backup))
                                               (reset! collection-type (:collection-type @filter-state-backup))
                                               (swap! filter-state merge (:state @filter-state-backup))
                                               (reset! preview false)
                                               (reset! filtered-collections (filtered-collections-func)))}
                                  "Cancel preview"]
                                 [:button
                                  {:on-click (fn [_]
                                               (->>
                                (model/group-admin-user-set-group-perms
                                 (:id @user)
                                 group-id
                                 {:collection_id         (into [] @permitted-collections)
                                  :permissions           (into [] @permissions)
                                  :primary_reviewer_id   @primary-reviewer-id
                                  :secondary_reviewer_id @secondary-reviewer-id})
                                                (p/map
                                                 (fn [_]
                                                   (swap! user-groups conj group-id)
                                                   (reset! preview false)
                                                   (clear-state-filter)
                                                   (reset! temporary-new-group-id nil)
                                                   (load-permitted-collection-ids)
                                                   (reload)
                                                   (reset! filtered-collections (filtered-collections-func))
                                                   (set-flash :success "Permissions updated")))
                                                (process-error)))
                                   :type     :submit}
                                  "Save"]]
                                (when @changes-made
                                  [:button
                                   {:on-click (util/handler
                                               (fn []
                                                 (swap! filter-state-backup assoc
                                                        :aname @aname :collection-type @collection-type :state @filter-state)
                                                 (filter-set-to-elements-to-save)
                                                 (reset! filtered-collections (filtered-collections-func))
                                                 (reset! preview true)))}
                                   "Preview selections"]))]]])]
         {:mode :nomination
          :id group-id} [nomination-edit {:cancel-cb cancel} group @user]
         nil)])))

(defn tree [options tree-item]
  (let [default-collapsed               (:default-collapsed options)
        collapsed                       (:collapsed options)
        permitted                       (:permitted options)
        added                           (:added-collections options)
        deleted                         (:deleted-collections options)
        changes-made                    (:changes-made options)
        selected-tree-item-id           (:selected-tree-item-id options)
        item-id                         (get-in tree-item [:item_data :id])
        is-collapsed                    (fn [item-id] (get @collapsed item-id @default-collapsed))
        is-added                        (fn [item-id]
                                          (contains? added item-id))
        is-deleted                      (fn [item-id] (contains? deleted item-id))
        disabled                        (:disabled options)]
    (if (:item_data tree-item)
      ^{:key item-id}
      [tree-view
       {:nodeLabel (reagent/create-element
                    "span" #js{}
                    (reagent/create-element
                     "input"
                     (clj->js
                      (set-checked (contains? @permitted item-id)
                                   (merge
                                    {:onChange (fn [ev]
                                                 (if (checked? ev)
                                                   (swap! permitted conj item-id)
                                                   (swap! permitted disj item-id))
                                                 (reset! changes-made true))}
                                    (when disabled {:disabled "disabled"})))))
                    (reagent/create-element
                     "a"
                     (clj->js
                      (merge
                       {:onClick (fn [e]
                                   (if (= @selected-tree-item-id item-id)
                                     (reset! selected-tree-item-id nil)
                                     (reset! selected-tree-item-id item-id))
                                   (.preventDefault e))
                        :href    "#"}
                       (when (= item-id @selected-tree-item-id)
                         {:className "u-bold"})
                       (when (is-deleted item-id) {:style {:color "red"}})
                       (when (is-added item-id) {:style {:color "green"}})))
                     (get-in tree-item [:item_data :name])))
        :collapsed (is-collapsed item-id)
        :key       item-id
        :on-click  (util/handler
                    (fn [] (swap! collapsed assoc item-id (not (is-collapsed item-id)))))}
       (doall
        (for [subitem (:subitems tree-item)]
          ^{:key (:id subitem)} (tree options subitem)))]
      [:div
       {:key (str "tree-" item-id)}
       (doall
        (for [subitem (:subitems tree-item)]
          ^{:key (:id subitem)} (tree options subitem)))])))


(def edit-grid
  [[nil "Can view" "Can modify" "Can add" "Can remove"]
   ["Tasks" "can_view_task" "can_modify_task" "can_add_task" "can_delete_task"]
   ["Compliance" "can_view_compliance" "can_modify_compliance" "can_add_compliance" "can_delete_compliance"]
   ["Events" "can_view_event" "can_modify_event" "can_add_event" "can_delete_event"]
   ["Documents" "can_view_document" "can_modify_document" "can_add_document" "can_delete_document"]
   ["Collection details" "can_view_collection_details" nil nil nil]
   ["Collection chart" "can_view_collection_chart" nil nil nil]
   ["Bulk operations" "can_do_bulk_operations" nil nil nil] 
   ["Review collection" "can_review_collection" nil nil nil]
   ["Mobile app access" "mobile_access" nil nil nil]
   ["Novice" "is_novice" nil nil nil]])

;; Restrictions, not privileges (#3107): Select all never grants them and
;; Deselect all never clears them -- only their own checkbox does.
(def restriction-perms #{"is_novice"})

(defn permissions-edit [permissions changes-made family-id
                        primary-reviewer-id secondary-reviewer-id family-users user]
  (let [collection-review-enabled (collection-model/has-collection-review-enabled family-id)
        active-grid (cond-> edit-grid
                      (not collection-review-enabled)
                      (->> (filterv #(not= (first %) "Review collection")))

                      ;; #3008: no mobile app, no point granting access to it
                      (not (enabled "mobile-app"))
                      (->> (filterv #(not= (first %) "Mobile app access")))

                      (not (enabled "novice"))
                      (->> (filterv #(not= (first %) "Novice"))))
        ;; #3107: novice can only be enabled for a single-family user; like the
        ;; server rule, deactivated families do not count. Saving in a family the
        ;; user is not a member of yet adds that family, hence the union with
        ;; family-id.
        multi-family-user? (or (:has_additional_active_groups @user)
                               (> (count (into #{family-id} (:active_group_ids @user))) 1))
        all-perms (difference (into #{} (filter identity (flatten (map #(rest %) (rest active-grid)))))
                              restriction-perms)
        comment-permissions-atoms (into {}
                                        (map (fn [k]
                                               [k (atom (contains? @permissions k))])
                                             ["can_comment" "can_notify_with_content" "can_enable_email_reply"]))
        toggle-perm (fn [column]
                      (fn [ev]
                        (reset! changes-made true)
                        (if (checked? ev)
                          (swap! permissions conj column)
                          (swap! permissions disj column))))
        blocked-checkbox (fn [column blocked? title]
                           [:span
                            (when blocked? {:title title})
                            [:input (set-checked (contains? @permissions column)
                                                 (cond-> {:on-change (toggle-perm column)}
                                                   blocked? (assoc :disabled true)))]])
        render-perm-input (fn [column]
                            (cond
                              (= column "can_review_collection")
                              [:input (set-checked (contains? @permissions column)
                                                   {:on-change (fn [ev]
                                                                 (reset! changes-made true)
                                                                 (if (checked? ev)
                                                                   (swap! permissions #(conj % "can_review_collection" "can_add_task" "can_add_compliance"))
                                                                   (swap! permissions disj "can_review_collection")))})]

                              (= column "can_add_task")
                              (blocked-checkbox column (contains? @permissions "can_review_collection")
                                                "Can add task is required to complete Collection Reviews. Remove the Collection Review permission to disable the Add Task permission.")

                              (= column "is_novice")
                              (blocked-checkbox column (and multi-family-user?
                                                            (not (contains? @permissions column)))
                                                "Novice can only be enabled for a user with access to a single family.")

                              (= column "can_add_compliance")
                              (blocked-checkbox column (contains? @permissions "can_review_collection")
                                                "Can add compliance is required to create cadence compliance reminders for Collection Reviews. Remove the Collection Review permission to disable the Add Compliance permission.")

                              :else
                              [:input (set-checked (contains? @permissions column)
                                                   {:on-change (toggle-perm column)})]))]
    [:div.permissions-grid
     [:h2.o-media--margin "Family permissions"]
     [:table.o-media--margin
      [:tbody
       [:tr
        [:th " "]
        (doall (for [column (rest (first active-grid))]
                 [:th column]))]
       (doall (for [row (rest active-grid)]
                [:tr.u-text-align-center
                 {:key (first row)}
                 [:th (first row)]
                 (doall (for [column (rest row)]
                          [:td
                           (when column
                             (render-perm-input column))]))]))]]
     (when (contains? @permissions "can_review_collection")
       [:div.o-media--margin.u-color--danger-red.u-font-size--smaller
        "ⓘ Warning: Review collection permission may gain user access to SmartRecord data or collection information beyond their standard permissions."])

     [:h3.o-media--margin "Messages permissions"]
     [:table.o-media--margin
      [:tbody
       [:tr.u-text-align-center
        [:th "Comments"]
        [:td
         [:input (set-checked @(get comment-permissions-atoms "can_comment")
                              {:on-change (fn [ev]
                                            (reset! changes-made true)
                                            (if (checked? ev)
                                              (swap! permissions conj "can_comment")
                                              (swap! permissions disj "can_comment" "can_notify_with_content" "can_enable_email_reply")))})]]]
       [:tr.u-text-align-center
        [:th "Notify with content"]
        [:td
         [:input (set-checked @(get comment-permissions-atoms "can_notify_with_content")
                              (merge
                               {:on-change (fn [ev]
                                             (reset! changes-made true)
                                             (if (checked? ev)
                                               (swap! permissions conj "can_notify_with_content")
                                               (swap! permissions disj "can_notify_with_content" "can_enable_email_reply")))}
                               {:disabled (not @(get comment-permissions-atoms "can_comment"))}))]]]
       [:tr.u-text-align-center
        [:th "Enable email reply"]
        [:td
         [:input (set-checked @(get comment-permissions-atoms "can_enable_email_reply")
                              (merge
                               {:on-change (fn [ev]
                                             (reset! changes-made true)
                                             (if (checked? ev)
                                               (swap! permissions conj "can_enable_email_reply")
                                               (swap! permissions disj "can_enable_email_reply")))}
                               {:disabled (not @(get comment-permissions-atoms "can_notify_with_content"))}))]]]]]
     ;; #3008: reviewer designation only matters for the ingestion queue, so it
     ;; is hidden with it. Already-stored reviewer ids keep round-tripping
     ;; through the save below untouched.
     (when (document-queue-enabled?)
       (let [reviewer-select (fn [label id-atom]
                               [:tr
                                [:th label]
                                [:td
                                 [:select
                                  {:value     (or @id-atom "")
                                   :on-change (fn [ev]
                                                (let [v (.-value (.-target ev))]
                                                  (reset! id-atom
                                                          (when (not (blank? v)) (js/parseInt v 10)))
                                                  (reset! changes-made true)))}
                                  [:option {:value ""} "— None —"]
                                  (doall
                                   (for [u (sort-by #(str (:last_name %) (:first_name %)) @family-users)]
                                     [:option {:key (:id u) :value (:id u)}
                                      (auth-model/get-full-name u)]))]]])]
         [:<>
          [:h3.o-media--margin "Document reviewer designation"]
          [:table.o-media--margin
           [:tbody
            (reviewer-select "Primary reviewer" primary-reviewer-id)
            (reviewer-select "Secondary reviewer" secondary-reviewer-id)]]
          (when (or @primary-reviewer-id @secondary-reviewer-id)
            [:div.o-media--margin.u-color--danger-red.u-font-size--smaller
             "ⓘ Warning: Designated reviewers will be able to view the AARK chat history for documents they review, which may include information beyond their standard permissions."])]))

     [:div.controls.o-media--margin
      [:button {:on-click (fn [_]
                            ;; Adds only: a message permission or hidden row dropped here is lost
                            ;; on save, and a principal without can_comment cannot decline (#3142).
                            (swap! permissions #(union % all-perms))
                            (reset! changes-made true))} "Select all"] " "
      [:button {:on-click (fn [_]
                            (swap! permissions #(set/intersection % restriction-perms))
                            (reset! changes-made true))} "Deselect all"]]]))

(defn nomination-edit [options group user]
  (let [nomination (atom nil)
        cancel-cb (:cancel-cb options)
        operation (atom nil)
        process-nomination-response (fn [response]
                                      (reset! nomination response)
                                      (reset! operation
                                              (if (some #(= (:status @nomination) %) ["r", "a"]) "n" (:status @nomination))))
        load-nomination (fn []
                          (->> (model/group-admin-nomination (:id group) (:id user))
                               (p/map
                                (fn [response]
                                  (process-nomination-response response)))
                               (p/error
                                (fn [err]
                                  (case (:status err)
                                    404 (reset! operation "n")
                                    (throw err))))
                               (process-error)))]
    (load-nomination)
    (fn [_ group user]
      [:div.o-media
       (when (and @nomination (= (:status @nomination) "r"))
         [:h3.u-margin-bottom
          "This nomination was rejected at: "
          (-> (:updated_at @nomination)
              (util/parse-datetime) (tz/to-browser-time) (util/date-format-date-hour-minute))
          "."])
       [:h2.u-margin-bottom "Upgrade User to Administrator"]
       (case  @operation
         "n" [:div.spaced {:style {:max-width "600px"}}
              [:p "Upgrading a regular user to an Administrator will endow the user with full Admin privileges for the selected family. They will have full access to view all information and full permission rights to modify and delete information within your subscription."]
              [:p "Also, in order for your Admin Nomination to be completed, it must be accepted by an iPaladin License Admin. If the update is urgent, please contact " [:a {:href "mailto:SubscriberSupport@ipaladin.com"} "‘SubscriberSupport@ipaladin.com’"] " to complete the nomination process. Otherwise, your nomination will be completed within 24 hours of initial request."]
              [:p "There may be additional cost for the addition of a new Admin to your subscription package. Applicable charges will be prorated based on your subscription term. Please contact " [:a {:href "mailto:SubscriberSupport@ipaladin.com"} "‘SubscriberSupport@ipaladin.com’"] " for questions."]
              [:p "Do you want to continue with the nomination?"]
              [:p.u-margin-top
               [:button {:on-click (util/handler (fn []
                                                   (->> (model/group-admin-nominate (:id group) (:id user))
                                                        (p/map (fn [response]
                                                                 (process-nomination-response response)
                                                                 (set-flash :success "Nomination sent")))
                                                        (process-error))))} "Yes, proceed with my nomination"]
               [:button {:on-click cancel-cb} "No, cancel my nomination"]]]
         "p" [:div "Nomination is pending acceptance."]
         "r" [:div "Nomination has been rejected." (when-let [reason (not-empty (:reason @nomination))] (str " Reason: " reason))]
         [:div])])))

(defn collection-details-form [{errors :errors
                                description :description
                                account_number :account_number
                                filing_type :filing_type
                                office_number :office_number
                                fax_number :fax_number
                                address_1 :address_1
                                address_2 :address_2
                                city :city
                                state :state
                                zip :zip
                                website :website}]

  (fn []
    [:div
     [:dl
      [:dt "Description"]
      [:dd [:textarea {:value @description
                       :rows 8
                       :on-change (reset-from-event description)}]
       [:span.error (:description @errors "")]]]
     [:dl
      [:dt "Tax ID / Acct No"]
      [:dd [:input {:type "text"
                    :value @account_number
                    :on-change (reset-from-event account_number)}]
       [:span.error (:account_number @errors "")]]]
     [:dl
      [:dt "Tax Filing Type"]
      [:dd [:input {:type "text"
                    :value @filing_type
                    :on-change (reset-from-event filing_type)}]
       [:span.error (:filing_type @errors "")]]]
     [:dl
      [:dt "Preferred Contact Number"]
      [:dd [:input {:type "text"
                    :value @office_number
                    :on-change (reset-from-event office_number)}]
       [:span.error (:account_number @errors "")]]]
     [:dl
      [:dt "Fax Number"]
      [:dd [:input {:type "text"
                    :value @fax_number
                    :on-change (reset-from-event fax_number)}]
       [:span.error (:fax_number @errors "")]]]
     [:dl
      [:dt "Address Line 1"]
      [:dd [:input {:type "text"
                    :value @address_1
                    :on-change (reset-from-event address_1)}]
       [:span.error (:address_1 @errors "")]]]
     [:dl
      [:dt "Address Line 2"]
      [:dd [:input {:type "text"
                    :value @address_2
                    :on-change (reset-from-event address_2)}]
       [:span.error (:address_2 @errors "")]]]
     [:dl
      [:dt "City"]
      [:dd [:input {:type "text"
                    :value @city
                    :on-change (reset-from-event city)}]
       [:span.error (:city @errors "")]]]
     [:dl
      [:dt "State"]
      [:dd [:input {:type "text"
                    :value @state
                    :on-change (reset-from-event state)}]
       [:span.error (:state @errors "")]]]
     [:dl
      [:dt "Zip Code"]
      [:dd [:input {:type "text"
                    :value @zip
                    :on-change (reset-from-event zip)}]
       [:span.error (:zip @errors "")]]]
     [:dl
      [:dt "Website"]
      [:dd [:input {:type "text"
                    :value @website
                    :on-change (reset-from-event website)}]
       [:span.error (:website @errors "")]]]]))

(defn collection-permissions-edit [options collection permitted-users]
  (let [group-permitted-users (atom nil)
        permitted-user-ids (atom nil)
        permitted-user-ids-to-remove (atom #{})
        changed-forms (:forms-change-status-atom options)


        set-user-ids (fn [group-permitted-ids permitted-ids]
                       (reset! permitted-user-ids (into #{} (filterv #(contains? group-permitted-ids %) permitted-ids)))
                       (reset! permitted-user-ids-to-remove (into #{} (filterv #(not (contains? @permitted-user-ids %)) group-permitted-ids))))
        load-group-permitted-regular-users (fn [group-id new-permitted-users]
                                             (->> (collection-model/permitted-users {:regular-only true} group-id)
                                                  (p/map (fn [response]
                                                           (reset! group-permitted-users response)
                                                           (set-user-ids (into #{} (mapv #(:id %) response)) (mapv #(:id %) new-permitted-users))))
                                                  (process-error)))]
    (load-group-permitted-regular-users (:group_id collection) @permitted-users)

    (add-watch permitted-users nil
               (fn [_ _ _ new-permitted-users]
                 (load-group-permitted-regular-users (:group_id collection) new-permitted-users)))

    (fn [options collection _]
      [:section {:class (str "u-display--" (if (= (:active-form options) :permissions) "block" "none"))}
       [:h1 {:style {:height (str (:header-height options) "px")}} "Edit Permissions"]
       [:form.c-collection-template-roadmap__form.o-margin-elements--md-vertical {:on-submit (util/handler (fn []
                                                                                                             (->> (model/group-admin-collection-set-perms
                                                                                                                   (:id collection)
                                                                                                                   (into [] @permitted-user-ids)
                                                                                                                   (into [] @permitted-user-ids-to-remove))
                                                                                                                  (p/map (fn [_]
                                                                                                                           (set-flash :success "Permissions applied")
                                                                                                                           (swap! changed-forms
                                                                                                                                  assoc :coltype-form-permissions false)
                                                                                                                           (when-let [cb (:success-cb options)]
                                                                                                                             (cb))))
                                                                                                                  (process-error))))}
        [:ul
         (doall
          (for [{user-id :id
                 :as user} @group-permitted-users]
            [:li {:key (:id user)}
             [:label
              [:input (set-checked
                       (contains? @permitted-user-ids user-id)
                       {:on-click (fn [ev]
                                    (let [selected (-> ev .-target .-checked)]
                                      (swap! changed-forms assoc :coltype-form-permissions true)
                                      (if selected
                                        (do
                                          (swap! permitted-user-ids conj user-id)
                                          (swap! permitted-user-ids-to-remove disj user-id))
                                        (do
                                          (swap! permitted-user-ids disj user-id)
                                          (swap! permitted-user-ids-to-remove conj user-id)))))})]
              (auth-model/get-full-name user)]]))]
        [:div.o-margin-elements--xs
         [:button {:on-click (util/handler
                              (fn []
                                (->> (collection-model/permitted-users {:include-subcollections false
                                                                        :regular-only true} (:parent_id collection))
                                     (p/map (fn [response]
                                              (set-user-ids (into #{} (mapv #(:id %) @group-permitted-users)) (mapv #(:id %) response))))
                                     (process-error))))} "Populate from parent"]
         [:button "Apply"]]]])))

(defn collection-form
  "Container for collection templates"
  [header-content content]
  [:div
   [:div.form-header header-content]
   [:div.collection-template content]])

(defn collection-form-roadmap
  "Container for collection template with roadmap"
  [roadmap collection-template]
  [:div.collection-template-roadmap.redesign.o-main-aside.c-collection-template-roadmap
   roadmap
   collection-template])

(defn collection-header
  "Renders collection header and set atom with its height "
  [_ _ [header-height-atom collection-type]]
  (let [dom-node (clojure.core/atom nil)
        update-height #(reset! header-height-atom (.-clientHeight @dom-node))]
    (reagent/create-class

     {:display-name "collection-header"
      :component-did-mount (fn [_]
                             (update-height))

      :component-did-update (fn []
                              (update-height))

      :reagent-render (fn [collection ancestor-list _]
                        (let [type-name (if (= "gr" collection-type) "family" "collection")]

                          [:header.c-collection-template-roadmap__header {:ref (fn [elem] (reset! dom-node elem))}

                           [:h4 (str (if collection (str "Edit "  (if (= "gr" collection-type) "family" "collection"))
                                         (str "New " (if (= "gr" collection-type) "family" "collection"))))]

                          ;breadcrumb
                           (when (> (count ancestor-list) 1) [collection/breadcrumb ancestor-list false])

                           [:h2 (if collection (collection-name collection) (str "New " type-name))]

                           (when collection
                             [:div.collection (str (get-in collection [:collection_type :asset_type :name]) ": ")
                              [:span (get-in collection [:collection_type :name])]])]))})))

(defn collection-nav
  "Render collection nav with anchors for roadmap"
  [{collection-id :id
    :as collection} forms forms-change-status active-form-atom [show-details? show-permissions?]]

  [:nav.c-collection-template-roadmap__nav
   (when show-details? [:a.c-collection-template-roadmap__anchor {:class (when (= @active-form-atom :details) "is-active")
                                                                  :on-click (util/handler #(reset! active-form-atom :details))}
                        [:mark.save-status {:class (when (:coltype-form-details  forms-change-status) "is-unsaved")}]
                        [:span "Details"]])

   (when (not-empty forms)
     (doall (map (fn [form]  [:a.c-collection-template-roadmap__anchor {:key (:index form)
                                                                        :class (when (= @active-form-atom (:index form)) "is-active")
                                                                        :on-click #(reset! active-form-atom (:index form))}
                              [:mark.save-status {:class (when ((keyword (str "coltype-form-" (:index form))) forms-change-status)
                                                           "is-unsaved")}]
                              [:span (:label form)]]) forms)))

   (when show-permissions? [:a.c-collection-template-roadmap__anchor {:class (when (= @active-form-atom :permissions) "is-active")
                                                                      :on-click (util/handler #(reset! active-form-atom :permissions))}
                            [:mark.save-status {:class (when (:coltype-form-permissions  forms-change-status)
                                                         "is-unsaved")}]
                            [:span "Edit Permissions"]])

   (when (and collection (collection-model/is-boir-collection collection) (collection-model/has-boir-efile-enabled (:group_id collection)))
     [:a.c-collection-template-roadmap__anchor {:class (when (= @active-form-atom :boir-preview) "is-active")
                                                :on-click (util/handler #(reset! active-form-atom :boir-preview))}
      [:mark.save-status {:class (when (:coltype-form-permissions  forms-change-status)
                                   "is-unsaved")}]
      [:span "BOIR"]])

   [:button {:on-click (util/handler
                        (fn []
                          (let [cb #(go-to-deletion-waypoint :collection-details :id collection-id)]
                            (if (some true? (vals forms-change-status))
                              (common/show-confirmation-modal
                               {:title "Unsaved changes"
                                :text "There are unsaved changes that will be lost. Are you sure you want to go back?"
                                :ok-cb cb})
                              (cb)))))} "Back"]])

(defn show-task-choice-modal! [options]
  (common/show-action-modal
   (merge
    {:title   "Have you made edits that impact notice
requirements or regulatory updates?"
     :content [:div
               [:p.u-margin-top.u-margin-bottom "If yes, add a custom or template Task."]
               [:p.u-margin-top.u-margin-bottom
                "If uncertain, select Task Template \"Legal Review of Changes For
                                  Potential Notice Requirements or Regulatory Updates\""]
               [:p.u-margin-top.u-margin-bottom
                "Your response will be recorded in the Collection's audit log."]]
     :actions [{:text      "Save without adding Task"
                :action-cb (fn [] ((:save-fn options)))}
               {:text      "Save and add Task"
                :action-cb (fn [] ((:add-task-and-save-fn options)))}]}
    options)))

(defn collection-edit [options collection parent-id ancestor-list]
  (let [options (merge {:add-func model/group-admin-collection-add
                        :update-func model/group-admin-collection-update
                        :success-url-func (fn [id] (str "/#/collection/details/" id))}
                       options)
        errors (atom {})
        collection-type-form-def (atom nil)

        permitted-users (atom nil)
        group-permitted-users (atom nil)
        roles (atom nil)

        collection-atom (atom collection)
        collection-data (atom (:data collection))
        ancestor-list-atom (atom ancestor-list)
        active-form (atom (or (:tab options) :details))
        form-task-group-id (atom {})
        forms-change-status (atom {})
        header-height (atom 200)

        load-collection-type-form-def (fn [collection-type-id]
                                        (->> (coltype-model/collection-type-form-def collection-type-id)
                                             (p/map #(reset! collection-type-form-def %))
                                             (process-error)))

        load-permitted-users (fn [users-atom collection-id]
                               (->> (model/group-admin-permitted-users {:include-contacts true} collection-id)
                                    (p/map (fn [response]
                                             (reset! users-atom response)))
                                    (process-error)))
        load-roles (fn []
                     (->> (collection-model/role-list)
                          (p/map #(reset! roles %))
                          (process-error)))
        add-task-modal-confirmation? (fn [] (:regulatory_oversight (:collection_type collection)))
        task-add-action-type (atom :apply)
        validate-collection-data (fn [form-data]
                                   (model/group-admin-collection-data-update
                                    (:id @collection-atom)
                                    (merge form-data {:validate_only true})))
        no-task-selected (atom nil)
        save-collection-data (fn [form-data]
                               (model/group-admin-collection-data-update (:id @collection-atom)
                                                                         (merge form-data {:no_task_selected @no-task-selected})))
        save-collection-data-and-add-task (fn [form-data task-form-data]
                                            (model/group-admin-collection-data-update (:id @collection-atom)
                                                                                      (merge form-data
                                                                                             {:task_add_type (name @task-add-action-type)}
                                                                                             (update-keys task-form-data
                                                                                                          (fn [akey] (keyword (str "task_add_" (name akey))))))))
        edit-service (atom nil)
        control-phrase (atom "")
        edit-fsm (fsm/machine
                  {:id :collection-edit-state
                   :initial :edit
                   :states {:edit {:on {:continue (if (add-task-modal-confirmation?) :validating :saving)}}
                            :validating {:entry (fn [_ opts]
                                                  (->>
                                                   (validate-collection-data (:form-data opts))
                                                   (p/map (fn [_]
                                                            (common/hide-controled-confirmation-modal)
                                                            (fsm/send @edit-service (merge opts {:type :success}))))
                                                   (p/error (fn [error-response]
                                                              (if (and
                                                                   (= 400 (:status error-response))
                                                                   (= "asset_deactivate" (get-in error-response [:response :body :type])))
                                                                (fsm/send @edit-service (merge opts {:type :asset-deactivate
                                                                                                     :asset-collections (get-in error-response [:response :body :data])}))
                                                                (throw error-response))))
                                                   (p/error #(fsm/send @edit-service (merge opts {:type :fail
                                                                                                  :response %})))))
                                         :on {:fail {:target :edit
                                                     :actions (fn [_ opts] (handle-error-response errors (:response opts)))}
                                              :success {:target :task-choice-modal
                                                        :actions #(reset! errors {})}
                                              :asset-deactivate :asset-deactivate-modal}}
                            :task-choice-modal {:entry (fn [_ opts]
                                                         (show-task-choice-modal!
                                                          {:close-cb #(fsm/send @edit-service {:type :cancel})
                                                           :save-fn #(fsm/send @edit-service (merge opts {:type :choose-just-save}))
                                                           :add-task-and-save-fn #(fsm/send @edit-service (merge opts {:type :choose-add-task-and-save}))}))
                                                :on {:cancel {:target :edit}
                                                     :choose-just-save {:target :saving
                                                                        :actions #(reset! no-task-selected true)}
                                                     :choose-add-task-and-save :task-add-modal}}
                            :task-add-modal {:entry (fn [_ opts] (show-task-add-modal-preselected-collection
                                                                  {:submit-fn (fn [task-form-data task-errors-atom]
                                                                                (fsm/send @edit-service
                                                                                          (merge opts
                                                                                                 {:type :save
                                                                                                  :task-form-data task-form-data
                                                                                                  :task-form-errors task-errors-atom})))
                                                                   :action-type-atom task-add-action-type
                                                                   :success-cb nil
                                                                   :close-cb #(fsm/send @edit-service (merge opts {:type :cancel}))
                                                                   :back-cb (fn []
                                                                              (fsm/send @edit-service (merge opts {:type :cancel})))}
                                                                  (:id @collection-atom)))
                                             :on {:cancel {:target :edit
                                                           :actions #(hide-task-add-modal)}
                                                  :save :saving-with-task}}
                            :saving {:entry (fn [_ opts]
                                              (->>
                                               (save-collection-data (:form-data opts))
                                               (p/map (fn [response]
                                                        (common/hide-controled-confirmation-modal)
                                                        (fsm/send @edit-service (merge opts {:type :success
                                                                                             :response response}))))
                                               (p/error (fn [error-response]
                                                          (if (and
                                                               (= 400 (:status error-response))
                                                               (= "asset_deactivate" (get-in error-response [:response :body :type])))
                                                            (fsm/send @edit-service (merge opts {:type :asset-deactivate
                                                                                                 :asset-collections (get-in error-response [:response :body :data])}))
                                                            (throw error-response))))
                                               (p/error #(fsm/send @edit-service (merge opts {:type :fail
                                                                                              :response %})))))
                                     :on {:success {:target :edit
                                                    :actions (fn [_ {:keys [response] :as opts}]
                                                               (reset! errors {})
                                                               (set-flash :success "Collection data saved.")
                                                               ((:reset-changed-status-fn opts))
                                                               (->>
                                                                (collection-model/collection-full-details (:id response))
                                                                (p/map #(reset! collection-atom %))
                                                                (process-error)))}
                                          :fail {:target :edit
                                                 :actions (fn [_ {:keys [response]}]
                                                            (handle-error-response errors response))}
                                          :asset-deactivate :asset-deactivate-modal}}
                            :asset-deactivate-modal {:entry (fn [_ {:keys [form-data] :as opts}]
                                                              (let [asset-collections (:asset-collections opts)]
                                                                (common/show-controled-confirmation-modal
                                                                 {:title         "Ownership Change"
                                                                  :text           (if (= 1 (count asset-collections))
                                                                                    [:div
                                                                                     "You are deleting an owner that has an active asset: "
                                                                                     [:a
                                                                                      {:href (path-for :collection-details :id (:id (first asset-collections)))
                                                                                       :target :_blank}
                                                                                      (collection-model/collection-name (first asset-collections))]
                                                                                     ". Do you want this owner’s asset account marked inactive?"]
                                                                                    [:div "You are deleting owners that have active assets:"
                                                                                     [:ul.u-disc-list
                                                                                      (doall
                                                                                       (for [col asset-collections]
                                                                                         [:li [:a
                                                                                               {:href (path-for :collection-details :id (:id col))
                                                                                                :target :_blank}
                                                                                               (collection-model/collection-name col)]]))]
                                                                                     "Do you want those asset accounts marked inactive?"])
                                                                  :required-phrase "inactive"
                                                                  :ok-cb          (fn []
                                                                                    (fsm/send @edit-service
                                                                                              (merge opts {:type :continue
                                                                                                           :form-data (assoc
                                                                                                                       form-data
                                                                                                                       :control_phrase @control-phrase)})))
                                                                  :close-cb #(fsm/send @edit-service (merge opts {:type :cancel}))
                                                                  :errors         errors
                                                                  :control-phrase control-phrase})))
                                                     :on {:cancel :edit
                                                          :continue {:target (if (add-task-modal-confirmation?) :validating :saving)}}}
                            :saving-with-task {:entry (fn [_ opts]
                                                        (->>
                                                         (save-collection-data-and-add-task (:form-data opts) (:task-form-data opts))
                                                         (p/map (fn [response]
                                                                  (fsm/send @edit-service (merge opts {:type :success
                                                                                                       :response response}))
                                                                  (swap! form-task-group-id assoc @active-form (:task_group_id response))))
                                                         (p/error #(fsm/send @edit-service (merge opts {:type :fail
                                                                                                        :response %})))))
                                               :on {:success {:target :edit
                                                              :actions (fn [_ {:keys [response] :as opts}]
                                                                         (reset! errors {})
                                                                         (set-flash :success "Collection data saved.")
                                                                         ((:reset-changed-status-fn opts))
                                                                         (hide-task-add-modal)
                                                                         (->>
                                                                          (collection-model/collection-full-details (:id response))
                                                                          (p/map #(reset! collection-atom %))
                                                                          (process-error)))}
                                                    :fail {:target :task-add-modal
                                                           :actions (fn [_ {:keys [response task-form-errors]}]
                                                                      (handle-error-response task-form-errors response))}}}}})]
    (reset! edit-service (fsm/service edit-fsm))
    (fsm/start @edit-service)
    (when collection
      (load-collection-type-form-def (:collection_type_id collection))
      (load-permitted-users group-permitted-users (:group_id collection))
      (load-permitted-users permitted-users (:id collection))
      (load-roles))

    (add-watch collection-atom :collection-changed (fn [_ _ _ updated-collection] (load-collection-type-form-def (:collection_type_id updated-collection))))

    (fn []
      [collection-form-roadmap
       [:aside.c-collection-template-roadmap__aside

        [collection-header @collection-atom @ancestor-list-atom [header-height
                                                                 (get-in options [:permitted-groups 0 :type])]]
          ;Render anchors for each collection form
        [collection-nav @collection-atom (filterv identity (:forms @collection-type-form-def)) @forms-change-status active-form [true (not-empty @collection-atom)]]]

       [:main.c-collection-template-roadmap__main
        (when @collection-atom
          [collection-permissions-edit {:success-cb #(load-permitted-users permitted-users (:id @collection-atom))
                                        :forms-change-status-atom forms-change-status
                                        :active-form @active-form
                                        :header-height @header-height}
           @collection-atom permitted-users])

        [collection/collection-details-edit
         (merge
          (assoc options :forms-change-status-atom forms-change-status
                 :active-form @active-form
                 :header-height @header-height
                 :collection-atom collection-atom
                 :ancestor-list-atom ancestor-list-atom
                 ;; :collection-atom-pre-change-cb -- form-def set to nil to prevent form re-rendering
                 ;; before new form-def is loaded (which is triggered by a watch on the collection atom)
                 ;; otherwise, the form would attempt to render with missing object data
                 ;; TODO: investigate whether the better way would be to make the form resistant to
                 ;; the cases of missing data.
                 :collection-atom-pre-change-cb (fn [] (reset! collection-type-form-def nil)))
          ;; If has entity (is asset collection in some ownership), make the name field disabled:
          (when (get-in @collection-atom [:data :entity])
            {:fixed-name (:name @collection-atom)})) @collection-atom (atom parent-id) nil]

        (when-not (:hide-details options)
          (when (and (not-empty @collection-type-form-def) @group-permitted-users)
            [coltype/collection-type-form
             {:data-sources (coltype/coltype-template-data-sources collection-atom group-permitted-users roles)
              :add_contact_user (partial contact-user-add group-permitted-users (:group_id @collection-atom))
              :modal-confirmation (add-task-modal-confirmation?)
              :save-func (fn [options] (fsm/send @edit-service (merge options {:type :continue
                                                                               :action-type-atom task-add-action-type})))
              :errors-atom errors
              :permitted-groups (:permitted-groups options)
              :collection @collection-atom
              :active-form @active-form
              :form-task-group-id @form-task-group-id
              :form-controls (update-vals
                              @form-task-group-id
                              (fn [task-group-id]
                                (when task-group-id
                                  [:button {:on-click (util/handler
                                                       #(.open js/window
                                                               (path-for :task-group-details :id task-group-id)
                                                               "_blank"))}
                                   "Open task"])))
              :forms-change-status-atom forms-change-status
              :header-height @header-height}
             @collection-type-form-def
             collection-data]))
        (when (= :boir-preview @active-form)
          [collection/boir-preview {:header-height @header-height} @collection-atom])]])))

(defn collection-family-details-edit [_ collection]
  (let [errors (atom {})
        collection-type-form-def (atom nil)
        permitted-users (atom nil)
        roles (atom nil)
        active-form (atom 0)
        forms-change-status (atom {})
        header-height (atom 200)

        load-collection-type-form-def (fn [collection-type-id]
                                        (->> (coltype-model/collection-type-form-def collection-type-id)
                                             (p/map #(reset! collection-type-form-def %))
                                             (process-error)))
        load-permitted-users (fn [collection-id]
                               (->> (collection-model/permitted-users {:include-contacts true} collection-id)
                                    (p/map (fn [response]
                                             (reset! permitted-users response)))
                                    (process-error)))
        load-roles (fn []
                     (->> (collection-model/role-list)
                          (p/map #(reset! roles %))
                          (process-error)))]
    (load-collection-type-form-def (:collection_type_id collection))
    (load-permitted-users (:id collection))
    (load-roles)

    (fn [options _]
      [collection-form-roadmap
       [:aside.c-collection-template-roadmap__aside

        [collection-header collection nil [header-height "gr"]]
        [collection-nav collection (:forms @collection-type-form-def) @forms-change-status active-form [false false]]]

       [:main.c-collection-template-roadmap__main
        (when (not-empty (and @collection-type-form-def @permitted-users))
          [coltype/collection-type-form
           {:data-sources (coltype/coltype-template-data-sources (catom collection) permitted-users roles)
            :add_contact_user (partial contact-user-add permitted-users (:group_id collection))
            :save-func (fn [{:keys [form-data reset-changed-status-fn]}]
                         (->> (model/group-admin-collection-data-update (:id collection) form-data)
                              (p/map (fn [_]
                                       (set-flash :success "Family data saved.")
                                       (reset-changed-status-fn)
                                       (reset! errors {})))
                              (p/error (fn [response]
                                         (handle-error-response errors response)
                                         (throw response)))))
            :errors-atom errors
            :permitted-groups (:permitted-groups options)
            :collection collection
            :active-form @active-form
            :forms-change-status-atom forms-change-status
            :header-height @header-height}

           @collection-type-form-def
           (atom (:data collection))])]])))

(defn group-list [groups]
  (let [active (atom "active")]
    (fn []
      [:div.groups
       [common/active-filter-item nil active]
       (if (seq groups)
         [:table.t-table-redesign
          [:thead
           [:tr
            [:th {:style {:width "15%"}} "ID"]
            [:th "Name"]
            [:th "Subscription"]]]
          [:tbody (doall
                   (for [group (filter #(case @active
                                          "active" (:active %)
                                          "inactive" (not (:active %))
                                          some?) groups)]
                     [:tr {:key (:id group)}
                      [:td.u-text-align--center {:style {:white-space "nowrap" :padding-right "1em"}} [:a {:href (str "#/admin/group/" (:id group) "/edit")} (:id group)]]
                      [:td [:a {:href (str "#/admin/group/" (:id group) "/edit")} (collection-model/collection-name group)]]
                      [:td [:a {:href (path-for :settings-subscriber-details :id (get-in group [:subscriber :id]))} (model/subscriber-name (:subscriber group))]]]))]]
         [:div.o-media
          [:p "No families. Use Add button to add first family."]])])))

(defn family-delete-modal-content [delete-state delete-errors collection]
  (let [{:keys [stage data]} (or @delete-state {})]
    [:div
     [:h1 "Delete family " [:span.u-color--green (:name collection)]  ]
     (case stage
       :loading  [:div [:p "Loading family objects to delete..."] [progressbar/progress-bar]]
       :deleting [:div [:p "Deleting family..."] [progressbar/progress-bar]]
       :preview  (let [objects-by-type    (group-by :type (:objects data))
                       tg-objects         (get objects-by-type "tg" [])
                       task-objects       (filter #(not (:compliance %)) tg-objects)
                       compliance-objects (filter :compliance tg-objects)
                       steps-by-group     (group-by :group_id (concat (get objects-by-type "t" [])
                                                                      (get objects-by-type "to" [])))
                       comments-by-conv   (group-by :conversation_id (get objects-by-type "com" []))
                       render-item        (fn [{:keys [type id name created_at]} & [show-date?]]
                                            [:li
                                             (if (seq name)
                                               [:span.c-family-delete-object-list__obj-name name [:span.c-family-delete-object-list__monospace " (" type "-" id ")"]]
                                               [:span [:span.c-family-delete-object-list__obj-untitled "Untitled"] [:span.c-family-delete-object-list__monospace " (" type "-" id ")"]])
                                             (when (and show-date? created_at)
                                               [:span.c-family-delete-object-list__created-at " created: " (.slice created_at 0 10)])])
                       render-items       (fn [items]
                                            (when (seq items)
                                              [:ul.c-family-delete-object-list
                                               (for [{:keys [id] :as item} items]
                                                 ^{:key (str (:type item) "-" id)}
                                                 (let [steps    (when (= "tg" (:type item)) (get steps-by-group id))
                                                       comments (when (#{"conv" "dconv" "tconv"} (:type item)) (get comments-by-conv id))]
                                                   [:div
                                                    [render-item item true]
                                                    (when (seq steps)
                                                      [:ul.c-family-delete-object-list.c-family-delete-object-list--steps
                                                       (for [step steps]
                                                         ^{:key (str (:type step) "-" (:id step))}
                                                         [render-item step false])])
                                                    (when (seq comments)
                                                      [:ul.c-family-delete-object-list.c-family-delete-object-list--steps
                                                       (for [comment comments]
                                                         ^{:key (str (:type comment) "-" (:id comment))}
                                                         [render-item comment false])])]))]))
                       obj-list           (fn [types]
                                            (render-items (mapcat #(get objects-by-type % []) types)))]
                   [:div
                    [:div.warning "Warning: The following objects belonging to this family will be permanently deleted"]
                    [:ul.c-family-delete-summary
                     [:li
                      [:details
                       [:summary [:div.cs-expander [:img {:src "/static/img/icons/arrow-expand.svg"}]] [:img.tab-header {:src "/static/img/icons/family-blue.svg"}] " Collections: " [:h4 (:collections data)]]
                       [obj-list ["col"]]]]
                     [:li
                      [:details
                       [:summary [:div.cs-expander [:img {:src "/static/img/icons/arrow-expand.svg"}]] [:img.tab-header {:src "/static/img/icons/document-blue.svg"}] " Documents: " [:h4 (:documents data)]]
                       [obj-list ["d" "n"]]]]
                     [:li
                      [:details
                       [:summary [:div.cs-expander [:img {:src "/static/img/icons/arrow-expand.svg"}]] [:img.tab-header {:src "/static/img/icons/compliance-blue.svg"}] " Compliances: " [:h4 (:compliances data)]]
                       [render-items compliance-objects]]]
                     [:li
                      [:details
                       [:summary [:div.cs-expander [:img {:src "/static/img/icons/arrow-expand.svg"}]] [:img.tab-header.tab-header--task {:src "/static/img/icons/task-blue.svg"}] " Tasks: " [:h4 (:task_groups data)]]
                       [render-items task-objects]]]
                     [:li
                      [:details
                       [:summary [:div.cs-expander [:img {:src "/static/img/icons/arrow-expand.svg"}]] [:img.tab-header {:src "/static/img/icons/event-blue.svg"}] " Events: " [:h4 (:events data)]]
                       [obj-list ["e" "eo"]]]]
                     [:li
                      [:details
                       [:summary [:div.cs-expander [:img {:src "/static/img/icons/arrow-expand.svg"}]] [:img.tab-header.tab-header--task {:src "/static/img/icons/task-blue.svg"}] " Templates: " [:h4 (:task_template_groups data)]]
                       [obj-list ["ttg" "ttgdel"]]]]
                     [:li
                      [:details
                       [:summary [:div.cs-expander [:img {:src "/static/img/icons/arrow-expand.svg"}]] [:img.tab-header {:src "/static/img/icons/chat-blue.svg"}] " Conversations: " [:h4 (:conversations data)]]
                       [obj-list ["conv" "dconv" "tconv"]]]]]
                    [:footer.o-space-between
                     [:button {:type :button :on-click (util/handler #(controller/dispatch :family-delete :clear))} "Cancel"]
                     [:button {:type     :button
                               :on-click (util/handler #(controller/dispatch :family-delete :show-confirm))}
                      "Go to summary"]]])
       :confirm (with-let [confirm-input          (atom "")
                           log-downloaded         (atom false)
                           generate-csv-log-file  (fn []
                                                    (let [rows (map (fn [{:keys [name id type created_at]}]
                                                                      (str type "-" id "," (some-> name (str/replace "," "")) "," (or (some-> created_at (.slice 0 10)) "")))
                                                                    (:objects data))
                                                          csv  (str/join "\n" (cons "id,name,created" rows))
                                                          blob (js/Blob. #js [csv] #js {:type "text/csv"})
                                                          url  (js/URL.createObjectURL blob)
                                                          a    (.createElement js/document "a")]
                                                      (set! (.-href a) url)
                                                      (set! (.-download a) (str (str/replace (:family_name data) " " "-") "_" (:family_id data) "_delete_log_" (.toISOString (js/Date.)) ".csv"))
                                                      (.click a)
                                                      (js/URL.revokeObjectURL url)
                                                      (reset! log-downloaded true)))]
                  [:div.u-padding-left--lg
                   [:div.c-family-delete-confirm__total
                    [:strong "Total objects to delete: " (:total data)]]
                   [:ol.c-family-delete-steps
                    [:li.c-family-delete-steps__item {:class (when @log-downloaded "c-family-delete-steps__item--disabled")}
                     [:span.c-family-delete-steps__item-number "1"]
                     [:div.c-family-delete-steps__item-body
                      [:a.c-family-delete-confirm__download {:title    "Delete Log"
                                                          :on-click (util/handler generate-csv-log-file)}
                       [:img.c-family-delete-steps__item-icon {:src "/static/img/icons/download.svg"}]
                       [:span.c-family-delete-steps__item-label "Download delete family log"]]]]
                    [:li.c-family-delete-steps__item {:class (when-not @log-downloaded "c-family-delete-steps__item--disabled")}
                     [:span.c-family-delete-steps__item-number "2"]
                     [:div.c-family-delete-steps__item-body
                      [:p.c-family-delete-steps__item-label "Type " [:strong "delete"] " to permanently remove the family and all related objects"]
                      [:input.c-family-delete-confirm__input {:type        :text
                                                           :disabled    (not @log-downloaded)
                                                           :value       @confirm-input
                                                           :placeholder ""
                                                           :on-change   #(reset! confirm-input (.. % -target -value))}]]]]
                   [:footer.o-space-between
                    [:button {:type     :button
                              :on-click (util/handler #(controller/dispatch :family-delete :clear))}
                     "Cancel"]
                    [:button.c-button--danger {:type     :button
                                               :disabled (not= @confirm-input "delete")
                                               :on-click (util/handler
                                                          (fn []
                                                            (controller/dispatch :family-delete :delete
                                                                                 {:family-id  (:id collection)
                                                                                  :errors     delete-errors
                                                                                  :on-success (fn []
                                                                                                (set-flash :success "Family deleted")
                                                                                                (util/set-location "#/admin/group/list"))})))}
                     "Delete Family"]]])
       [:div])]))

(defn group-edit [collection]
  (let [aname (atom (:name collection))
        atype (atom (:collection_type_id collection))
        active (atom (:active collection))
        subscribers (atom nil)
        subscriber-id (atom (:subscriber_id collection))
        document-import (atom (:document_import collection))
        boir-efile (atom (:boir_efile collection))
        prevent-object-deletion (atom (:prevent_object_deletion collection))
        report-mode (atom (:report_mode collection))
        collection-chart (atom (:collection_chart collection))
        aark (atom (:aark collection))
        collection-review (atom (:collection_review collection))
        ;; A new family has no record to read, and chat is on unless an admin
        ;; turns it off, so the box starts ticked.
        chat (atom (not (:chat_disabled collection)))
        chat-export-from (atom nil)
        chat-export-to (atom nil)
        errors (atom nil)
        delete-errors (atom nil)
        delete-state (subscribe :family-delete)
        load-subscribers (fn []
                           (->> (model/license-admin-subscribers true nil)
                                (p/map (fn [response]
                                         (reset! subscribers response)))
                                (process-error)))]
    (when (is-user-license-admin)
      (load-subscribers))
    (fn []
      [:<>
       [:form.o-media--bottom-shadow.c-form--edit.c-form--spreaded
        {:on-submit (util/handler (fn []
                                    (->> ((if collection
                                            (partial model/license-admin-group-update (:id collection))
                                            model/license-admin-group-add)
                                          {:name @aname
                                           :collection_type_id (if (= @atype "<NONE>") nil @atype)
                                           :active @active
                                           :document_import @document-import
                                           :subscriber_id (if (= @subscriber-id "<NONE>") nil @subscriber-id)
                                           :prevent_object_deletion @prevent-object-deletion
                                           :boir_efile @boir-efile
                                           :report_mode @report-mode
                                           :collection_chart @collection-chart
                                           :aark @aark
                                           :collection_review @collection-review
                                           :chat @chat})
                                         (p/map (fn [_]
                                                  (set-flash :success "Family saved")
                                                  (util/set-location "#/admin/group/list")))
                                         (process-error errors))))}

        [:dl
         [:dt "Name"]
         [:dd [:input {:value @aname
                       :on-change (reset-from-event aname)}]
          [:span.error (:name @errors "")]]]
        [:dl
         [:dt "Type"]
         [:dd [collection-type-chooser {:order "name"} (:group_id collection) atype]
          [:span.error (:collection_type_id @errors "")]]]
        (when (is-user-license-admin)
          [:dl
           [:dt "Subscriber"]
           [:dd
            [:select {:on-change (reset-from-event subscriber-id)}
             [:option {:value "<NONE>"} "Choose..."]
             (for [subscriber @subscribers]
               [:option (set-selected @subscriber-id (:id subscriber) {:value (:id subscriber) :key (:id subscriber)}) (util/add-inactive-to-name subscriber)])]
            [:span.error (:subscriber_id @errors "")]]])
        [:dl
         [:dt]
         [:dd [:label [:input (set-checked @active {:on-click #(reset! active (checked? %))})] " Active?"]
          [:span.error (:active @errors "")]]
         [:dt]
         [:dd [:label [:input (set-checked @document-import {:on-click #(reset! document-import (checked? %))})] " Enable document automation?"]
          [:span.error (:document_import @errors "")]]
         (when (and @document-import collection)
           [:dl
            [:dt "UUID"]
            [:dd [:input {:value (:uuid collection)
                          :size 32
                          :disabled :disabled}]
             [:button.u-margin-left.u-margin-right {:on-click (util/handler (fn [_]
                                                                              (util/toggle-class "span-copied" "u-display--none" "none")
                                                                              (util/copy-to-clipboard (:uuid collection))))} "Copy to clipboard"]
             [:span.u-display--none {:id "span-copied"} "Copied"]]])
         [:dt]
         [:dd [:label [:input (set-checked @boir-efile {:on-click #(reset! boir-efile (checked? %))})] " Enable BOIR E-Filing?"]
          [:span.error (:boir_efile @errors "")]]
         [:dt]
         [:dd [:label [:input (set-checked @prevent-object-deletion {:on-click #(reset! prevent-object-deletion (checked? %))})] " Prevent object deletion?"]
          [:span.error (:prevent_object_deletion @errors "")]]
         [:dd [:label [:input (set-checked @report-mode {:on-click #(reset! report-mode (checked? %))})] " Enable report mode?"]
          [:span.error (:report_mode @errors "")]]
         [:dd [:label [:input (set-checked @collection-chart {:on-click #(reset! collection-chart (checked? %))})] " Enable collection chart?"]
          [:span.error (:collection_chart @errors "")]]
         [:dd [:label [:input (set-checked @aark {:on-click (fn [e]
                                                               (let [checked (checked? e)]
                                                                 (reset! aark checked)
                                                                 (when-not checked
                                                                   (reset! collection-review false))))})] " Enable " [:span.cs-brand "AARK"] "?"]
          [:span.error (:collection_chart @errors "")]]
         [:dd [util/disable-tool {:disabled (not @aark)
                                  :message "AARK must be enabled first"
                                  :component [:label [:input (set-checked @collection-review {:disabled (not @aark)
                                                                                              :on-click #(reset! collection-review (checked? %))})]
                                              " Enable collection review?"]}]
          [:span.error (:collection_review @errors "")]]
         [:dd [:label [:input (set-checked @chat {:on-click #(reset! chat (checked? %))})] " Enable chat?"]
          [:span.error (:chat @errors "")]]]
        (when collection
          [:dl
           [:dt "Chat export"]
           [:dd
            [:label "From " [pikaday/date-selector {:date-atom chat-export-from}]]
            [:label.u-margin-left "To " [pikaday/date-selector {:date-atom chat-export-to}]]
            ;; The date selector clears its atom only on Backspace, so an input emptied
            ;; any other way would keep filtering.
            (when (or @chat-export-from @chat-export-to)
              [:button.u-margin-left {:type :button
                                      :on-click (util/handler #(do (reset! chat-export-from nil)
                                                                   (reset! chat-export-to nil)))}
               "Clear dates"])
            ;; download-button cannot show a 400 from its text response, so a reversed
            ;; range is refused here instead of surfacing as "Network error".
            (if (and @chat-export-from @chat-export-to (> @chat-export-from @chat-export-to))
              [:<>
               [:button.u-margin-left {:type :button :disabled true} "Download CSV"]
               [:span.error.u-margin-left "From must not be after To"]]
              [:span.u-margin-left
               [common/download-button
                {:ajax-url (str "/licenseadmin/group/" (:id collection) "/chat-export/")
                 ;; cljs-ajax sends a nil param as the string "null"
                 :ajax-options {:params (cond-> {}
                                          @chat-export-from (assoc :from (util/local-date-time-to-date-string
                                                                          @chat-export-from))
                                          @chat-export-to (assoc :to (util/local-date-time-to-date-string
                                                                      @chat-export-to)))
                                :response-format (ajax.core/ring-response-format {:format (text-response-format)})}}
                "Download CSV"]])]])
        [:footer.u-flex.u-flex--justify-content-space-between
         [:button {:on-click (util/handler #(util/set-location "#/admin/group/list"))} "Back"]
         [:div.u-flex.u-flex--gap
          (when collection
            [:button.c-button--danger {:type     :button
                                       :disabled (or 
                                                  (not (:deletable collection)) 
                                                  (boolean (#{:loading :deleting} (:stage @delete-state))))
                                       :on-click (util/handler #(controller/dispatch :family-delete :load-preview {:family-id (:id collection) :errors delete-errors}))}
             "Delete"])
          [:button.u-margin-left--xs {:type :submit} "Save"]]]]
       [modal-window
        [family-delete-modal-content delete-state delete-errors collection]
        {:close-cb      #(controller/dispatch :family-delete :clear)
         :is-enabled-fn #(boolean @delete-state)}]])))

(defn family-details [family users]
  [:div
   [group-edit family]
   [:h2.o-media--medium "Family users"]
   [user-list users (:id family) (fn [family-id active order page] (model/license-admin-user-list active order page family-id))]])

(defn user-profile-edit []
  (let [user (atom nil)
        errors (atom {})
        timezones (atom nil)
        current-password (atom "")
        password (atom "")
        password-confirm (atom "")
        alert-hour (atom nil)
        alert-minute (atom nil)

        load-timezones (fn [] (->> (auth-model/timezone-list)
                                   (p/map #(reset! timezones %))
                                   (process-error)))
        load-user (fn []
                    (->> (auth-model/profile-details)
                         (p/map (fn [response]
                                  (reset! user response)
                                  (reset! alert-hour (:alert_hour @user))
                                  (reset! alert-minute (:alert_minute @user))))
                         (process-error)))]
    (load-timezones)
    (load-user)

    (fn []
      (when @user
        [:div
         [:div.o-media--bottom-shadow
          [:h2 "Settings"]
          [:form.c-form--edit.c-form--input-wide {:on-submit (util/handler (fn []
                                                                             (cond
                                                                               (not= @password @password-confirm)
                                                                               (reset! errors {:password-confirm "Passwords don't match"})

                                                                               ;; The server refuses this anyway (sec#153); asking
                                                                               ;; here saves the round trip.
                                                                               (and (not-empty @password) (empty? @current-password))
                                                                               (reset! errors {:current_password "Enter your current password"})

                                                                               :else
                                                                               (do
                                                                                 (reset! errors {})
                                                                                 (->> (auth-model/profile-update
                                                                                       (cond-> {:timezone (:timezone @user)
                                                                                                :password @password
                                                                                                :alert_hour @alert-hour
                                                                                                :alert_minute @alert-minute}
                                                                                         ;; Only a password change needs it, and the
                                                                                         ;; browser may have filled the field, so a
                                                                                         ;; timezone-only save must not carry it.
                                                                                         (not-empty @password)
                                                                                         (assoc :current_password @current-password)))
                                                                                      (p/map (fn [response]
                                                                                               (api/set-auth-info :timezone (not-empty (:timezone response)))
                                                                                               ;; Clear the password fields: the saved one is no
                                                                                               ;; longer current, so a second Save would send a
                                                                                               ;; stale current_password and be refused.
                                                                                               (reset! current-password "")
                                                                                               (reset! password "")
                                                                                               (reset! password-confirm "")
                                                                                               (load-user)
                                                                                               (set-flash :success "Profile updated")))
                                                                                      ;; The server rejects the whole submission, so
                                                                                      ;; re-read the user: otherwise the timezone select
                                                                                      ;; keeps showing a value the server does not hold.
                                                                                      (p/error (fn [err]
                                                                                                 (load-user)
                                                                                                 (throw err)))
                                                                                      (process-error errors [:current_password]))))))}
           [:dl
            [:dt "Time Zone"]
            [:dd
             [:select {:on-change (swap-from-event user assoc :timezone)}
              [:option {:value ""} "Choose..."]
              (doall (for [tz @timezones]
                       [:option (set-selected (:timezone @user) tz {:value tz :key tz}) tz]))]
             [:span.error (:timezone @errors "")]]]
           [:dl
            [:dt "Current Password" " (required to set a new password)"]
            [:dd
             ;; autocomplete tells the browser which field is which; without it
             ;; it fills the first password input with the stored login password.
             [:input {:type "password" :autocomplete "current-password"
                      :value @current-password :on-change (reset-from-event current-password)}]
             [:span.error (:current_password @errors "")]]]
           [:dl
            [:dt "Password" (when user " (leave empty to keep the old password)")]
            [:dd
             [:input {:type "password" :autocomplete "new-password"
                      :value @password :on-change (reset-from-event password)}]
             [:span.error (:password @errors "")]]]
           [:dl
            [:dt "Confirm Password"]
            [:dd
             [:input {:type "password" :autocomplete "new-password"
                      :value @password-confirm :on-change (reset-from-event password-confirm)}]
             [:span.error (:password-confirm @errors "")]]]
           [:dl
            [:dt "Alert email notifications time"]
            [hour-minute-picker {:hour-atom alert-hour
                                 :minute-atom alert-minute}]
            [:span.error (:alert_hour @errors "")]
            [:span.error (:alert_minute @errors "")]]

           [:footer.u-flex.u-flex--justify-content-space-between
            ;; Not a submit button: Enter in any field activates the first one,
            ;; so an untyped Back navigates away instead of saving.
            [:button {:type :button :on-click util/back} "Back"]
            [:button "Save"]]]]

         [mfa-settings user]]))))

(defn mfa-settings [user-atom]
  (let [mfa-setup-state (atom :info)
        is-reset #(:uses_mfa @user-atom)]
    (fn [user-atom]
      [:div.o-media
       [:h2 "Multi-factor authentication"]
       [:form.c-form--edit.u-margin-top.u-margin-bottom
        [:p "Multi-factor authentication is " (if (is-reset) "enabled." "currently disabled.")]]
       (case @mfa-setup-state
         :mfa-setup [mfa-setup {:success-cb (fn [_]
                                              (set-flash :success "Multi-factor authentication is now configured")
                                              (reset! mfa-setup-state :info)
                                              (reset! user-atom (assoc @user-atom :uses_mfa true)))
                                :cancel-cb #(reset! mfa-setup-state :info)} (is-reset)]

         :info [:footer.u-flex.u-flex--justify-content-space-between
                [:button {:on-click util/back} "Back"]
                [:button {:on-click (util/handler #(reset! mfa-setup-state :mfa-setup))}
                 (if (is-reset) "Reset" "Enable")]])])))

(defn mfa-setup [{:keys [success-cb cancel-cb]} is-reset]
  (let [mfa-init-data (atom nil)
        current-token (atom nil)
        errors (atom nil)
        load-mfa-init-data (fn [current-token]
                             (->> (auth-model/mfa-reset-init current-token)
                                  (p/map #(reset! mfa-init-data %))
                                  (process-error errors)))]
    (when-not is-reset (load-mfa-init-data nil))
    (fn [_]
      (if (and is-reset (not @mfa-init-data))
        [:div
         [:form.c-form--edit {:on-submit (util/handler #(load-mfa-init-data @current-token))}
          [:dl
           [:dt "Current authentication token:"]
           [:dd
            [:input {:type :text
                     :value @current-token
                     :required "required"
                     :auto-focus "autofocus"
                     :on-change (reset-from-event current-token)}]
            [:span.error.u-margin-left (:code @errors "")]]]
          [:footer.u-flex.u-flex--justify-content-space-between
           [:button {:type :submit
                     :style {:width 0 :height 0 :margin 0 :padding 0 :position :absolute :opacity 0}} "Verify"]
           [:button {:on-click (util/handler cancel-cb)} "Back"]
           [:button {:type :submit} "Verify"]]]]
        [:div
         (when @mfa-init-data
           [auth-component/mfa {:classes {:input ""
                                          :form "c-form--edit u-text-align-center u-padding-top"
                                          :image "u-text-align-center"
                                          :description "c-form--edit"}
                                :cancel-cb cancel-cb
                                :success-cb (fn [code-url code errors-atom]
                                              (->> (auth-model/mfa-reset-submit code-url code)
                                                   (p/map success-cb)
                                                   (process-error errors-atom)))} (:code_url @mfa-init-data) (:qrcode @mfa-init-data)])]))))

(defn user-invitation [invitation]
  (fn []
    (let [many (> (count (:invited_groups invitation)) 1)]
      [:div.invitation.o-media
       [:p "You have been invited by " [:span.admin (auth-model/get-full-name (:admin invitation))] " to " (if many
                                                                                                             "the following families: "
                                                                                                             "a family: ") (clojure.string/join ", " (mapv #(:name %) (:invited_groups invitation))) "."]
       [:p "Would you like to join " (if many "these families?" "this family?")]
       [:p
        [:button {:on-click (fn [_]
                              (->> (auth-model/invitation-accept (:uid invitation))
                                   (p/map (fn [_]
                                            (set-flash :success "Invitation accepted")
                                            (util/set-location "#/")))
                                   (process-error)))} "Yes"] " "
        [:button {:on-click (fn [_]
                              (->> (auth-model/invitation-reject (:uid invitation))
                                   (p/map (fn [_]
                                            (set-flash :notice "Invitation declined")
                                            (util/set-location "#/")))
                                   (process-error)))} "No"]]])))

(defn user-password-reset-form [token]
  (let [password (atom nil)
        repassword (atom nil)
        form-state (atom :display-form)
        errors (atom {})
        go-to-login (util/handler (fn []
                                    (api/set-auth-info :auth-state :logged-out)
                                    (util/set-location "#/")
                                    (api/delete-auth-info :password-reset-token)))
        submit (util/handler (fn []
                               (reset! errors {})
                               (if-not (= @password @repassword)
                                 (swap! errors assoc :password "Passwords do not match.")
                                 (->> (auth-model/password-reset token @password)
                                      (p/map (fn [_]
                                               (reset! form-state :updated)
                                               (api/delete-auth-info :password-reset-token)))
                                      (p/error (fn [err]
                                                 (if (= 401 (:status err))
                                                   (reset! form-state :token-invalid)
                                                   (throw err))))
                                      (process-error)))))]
    (fn []
      (condp = @form-state
        :updated [:div.o-media.u-text-align--center
                  [:p "Your password has been updated."]
                  [:button.u-margin-top {:on-click go-to-login} "Go to login page"]]

        :display-form [:form {:on-submit submit}
                       [:p "Enter your new password."]
                       [:dl
                        [:dd
                         [:input.c-login__input {:type "password" :required "required" :value @password
                                                 :on-change (util/reset-from-event password)
                                                 :placeholder "Password"}]
                         [:span.error (:password @errors "")]]]

                       [:dl
                        [:dd [:input.c-login__input {:type "password" :required "required" :value @repassword
                                                     :on-change (util/reset-from-event repassword)
                                                     :placeholder "Password (repeat)"}]
                         [:span.error (:repassword @errors "")]]]
                       [:footer.o-margin-elements--xs.c-login__footer
                        [:button.c-button {:on-click go-to-login :type :button} "Cancel"]
                        [:button.c-button {:type :submit} "Change password"]]]

        :token-invalid [:div.o-media.u-text-align--center
                        [:p "Your password reset request is no longer valid, try resetting your password again."]
                        [:button.u-margin-top {:on-click go-to-login} "Go to login page"]]))))

(defn value-if-not-none [value] (when-not (= "<NONE>" value) value))

(defn show-template-copy-modal [options]
  (reset! state/template-copy-modal (merge options {:enabled true})))

(defn hide-template-copy-modal []
  (reset! state/template-copy-modal {:enabled false}))

(defn template-copy-modal []
  (let [{:keys [title
                template-group
                subscriber-id group-id copy-type errors done-cb hide-original can-be-hidden]} @state/template-copy-modal
        is-subscriber-to-subscriber-copy? (and (= copy-type "subscriber") (:subscriber_id template-group))]
    [modal
     [:div
      [:h3 title]
      [:form.c-form--edit
       [:fieldset
        (when can-be-hidden
          [:div
           [:label.u-margin-right--xs
            [:input
             (set-checked (if (some? hide-original) @hide-original false)
                          {:on-click #(reset! hide-original (checked? %))})]
            "Hide original"]])
        [:div
         (when (some? copy-type)
           (case copy-type
             "subscriber"   [subscriber-chooser
                             {:allow-empty     false
                              :subscriber-atom subscriber-id
                              :group-atom      group-id
                              :admin-only      true
                              :disabled (or (:collection_id template-group) is-subscriber-to-subscriber-copy?)}
                             nil]
             "group"        [:div
                             [group-chooser
                              {:allow-empty     false
                               :group-atom      group-id
                               :subscriber-atom subscriber-id
                               ;; :admin-only set to true -- template management
                               ;; in destination only for effective family admins
                               :admin-only      true}
                              nil]
                             (when (= (str (:collection_id template-group)) (str @group-id))
                               [:span "The selected family is the same as source family."])]))]]

       [:footer.o-space-between
        [:button
         {:type     :button
          :on-click (handler #(hide-template-copy-modal))}
         "Cancel"]
        [:button
         {:type     :submit
          :on-click (handler
                     (fn []
                       (->> (model/templategroup-add
                             (merge
                              {:source_id     (:id template-group)
                               :hide_original @hide-original}
                              (cond
                                (= copy-type "group")      {:collection_id @group-id}
                                (= copy-type "subscriber") {:subscriber_id @subscriber-id})))
                            (p/map (fn [_]
                                     (hide-template-copy-modal)
                                     (set-flash :success (str
                                                          "Template group saved to "
                                                          (cond
                                                            (= copy-type "group") "family"
                                                            (= copy-type "subscriber") "subscriber")))
                                     (some-> done-cb (apply []))))
                            (p/error (fn [err]
                                       (hide-template-copy-modal)
                                       (throw err)))
                            (process-error errors))))}
         "OK"]]]]
     state/template-copy-modal]))

(defn templategroup-list-controls [options]
  (let [group-id (and (:selected-group-atom options) @(:selected-group-atom options))
        subscriber-id (and (:selected-subscriber-atom options) @(:selected-subscriber-atom options))]
    [:span
     (when (or
            (some-> group-id is-user-group-admin)
            (some-> subscriber-id  is-user-subscriber-admin)
            (is-user-license-admin))
       [:button {:on-click (fn [_]
                             (util/set-location
                              (str
                               "#/admin/templategroup/add?"
                               (util/make-params
                                (util/remove-nil-values
                                 (merge
                                  {:type (if @(:compliance-atom options) "compliance" "task")
                                   :filter_active @(:filter-active options)
                                   :order         @(:order options)
                                   :group_id (value-if-not-none group-id)
                                   :subscriber_id (value-if-not-none subscriber-id)}
                                  (when @(:show-hidden options) {:show_hidden "yes"})))))))} "Add Template Group"])]))


(defn can-copy-to-family []
  (or (auth-model/is-user-any-subscriber-admin) (auth-model/is-user-any-group-admin)))

(defn can-copy-to-any-subscriber [templategroup get-family-subscriber-id]
  (let [tg-scope (task-model/templategroup-scope
                  (:collection_id templategroup)
                  (:subscriber_id templategroup))]
    (and
     (is-user-any-subscriber-admin)
     (or
      (not= tg-scope task-model/template-scope-family)
      (is-user-subscriber-admin (get-family-subscriber-id (:collection_id templategroup)))))))

(defn template-actions [_ _ can-copy-to-any-subscriber?]
  (let [show-menu (atom false)
        ref       (atom nil)]

    (reagent/create-class
     {:display-name        "template-actions"
      :component-did-mount #(-> (js/$ "div.outer-container")
                                (.click
                                 (fn [e]
                                   (when-not (= (-> e .-target) @ref)
                                     (reset! show-menu false)
                                     (-> (js/$ "ul.dropdown-menu.dropdown-select") (.removeClass "show"))))))
      :reagent-render      (fn [{:keys [collection-id collection-id-atom subscriber-id subscriber-id-atom type filter-active order] :as options} templategroup _]
                             [:div.dropdown {:style {:display :inline} :key :add}
                              [:div.dropdown-container
                               (when (:can-view-more options)
                                 [:span
                                  [:button
                                   {:ref (fn [com] (reset! ref com)) :on-click #(swap! show-menu not)}
                                   "More"]])
                               [:ul.dropdown-menu.dropdown-select
                                (when @show-menu {:class "show" :style {:left "-2em"}})
                                (when (:can-edit options)
                                  [:li
                                   {:on-click (util/handler
                                               #(util/set-location
                                                 (str (path-for :settings-templategroup-edit :id (:id templategroup)) "?"
                                                      (util/make-params
                                                       (util/remove-nil-values
                                                        {:group_id (value-if-not-none @collection-id-atom)
                                                         :subscriber_id (value-if-not-none @subscriber-id-atom)
                                                         :type type
                                                         :filter_active filter-active
                                                         :order order})))))}
                                   "Edit"])
                                (when can-copy-to-any-subscriber?
                                  [:li
                                   {:on-click
                                    (fn [_]
                                      (let [errors                     (atom {})]
                                        (show-template-copy-modal
                                         {:title         (str "Save template \"" (:name templategroup) "\" to:")
                                          :can-be-hidden (model/can-templategroup-be-hidden templategroup)
                                          :copy-type     "subscriber"
                                          :template-group   templategroup
                                          :subscriber-id (atom @subscriber-id-atom)
                                          :group-id      (atom @collection-id-atom)
                                          :errors        errors
                                          :done-cb (:done-cb options)
                                          :hide-original (atom false)})))}
                                   "Save to Subscriber As"])
                                (when (can-copy-to-family)
                                  [:li
                                   {:on-click (fn [_]
                                                (let [errors                     (atom {})]
                                                  (show-template-copy-modal
                                                   {:title         (str "Save template \"" (:name templategroup) "\" to:")
                                                    :can-be-hidden (model/can-templategroup-be-hidden templategroup)
                                                    :copy-type     "group"
                                                    :template-group templategroup
                                                    :subscriber-id (atom @subscriber-id-atom)
                                                    :group-id      (atom nil)
                                                    :errors        errors
                                                    :done-cb (:done-cb options)
                                                    :hide-original (atom false)})))}
                                   "Save to Family As"])
                                (when-not  (or (and collection-id (:collection_id templategroup)) ;; family context and family template
                                               (and subscriber-id (not collection-id) (:subscriber_id templategroup)) ;; subscriber context and subscriber template
                                               (and subscriber-id (not collection-id) (not (:subscriber_id templategroup)) (not (:collection_id templategroup)) (not (is-user-subscriber-admin subscriber-id))) ;; subscriber context global template not a subscriber admin
                                               (and (not subscriber-id) (not collection-id))) ;; global context
                                  [:li
                                   {:on-click (fn [_]
                                                (->> (if (:task_template_group_deleted_id templategroup)
                                                       (model/templategroupdeleted-delete
                                                        (:task_template_group_deleted_id templategroup))
                                                       (model/templategroupdeleted-add
                                                        (merge {:template_group_id (:id templategroup)}
                                                               (cond
                                                                 collection-id {:collection_id collection-id}
                                                                 subscriber-id {:subscriber_id subscriber-id}))))
                                                     (p/map (fn [_] (some-> (:done-cb options) (apply []))))
                                                     (process-error)))}
                                   (if (:task_template_group_deleted_id templategroup) "Unhide" "Hide")])]]])})))

(defn template-group-type [templategroup]
  (cond
    (:subscriber_id templategroup) "Subscription"
    (:collection_id templategroup) "Family"
    :else                          "Global"))


(defn templategroup-list [options]
  (let [group (or (:selected-group-atom options) (atom nil))
        subscriber (or (:selected-subscriber-atom options) (atom nil))
        subscriber-id-map (atom nil)
        all-families (atom nil)
        all-families-id-map (clojure.core/atom nil)
        group-id-map (atom nil)
        compliance (:compliance-atom options)
        filter-active (or (:filter-active options) (atom "active"))
        template-type #(if @compliance "compliance" "task")
        show-hidden (or (:show-hidden options) (atom nil))
        templategroups (atom nil)
        order (or (:order options) (atom "name"))
        load-template-groups (fn [subscriber-id group-id]
                               (->>
                                (model/templategroups (value-if-not-none subscriber-id) (value-if-not-none group-id) (template-type) @order @show-hidden @filter-active)
                                (p/map
                                 #(reset! templategroups %))
                                (process-error)))
        update-url (fn []
                     (util/set-location-params
                      (merge
                       (when (value-if-not-none @subscriber) {:subscriber_id @subscriber})
                       (when (value-if-not-none @group) {:group_id @group})
                       (when order {:order @order})
                       (when filter-active {:filter_active @filter-active})
                       (when @show-hidden {:show_hidden "yes"})
                       {:type (template-type)})
                      true))
        load-labels #(controller/dispatch :label-list :load {:family-id @group
                                                             :object-type model/object-type-task-template-group})
        uncheck-show-hidden-or-load-template-groups (fn [subscriber-id group-id]
                                                      (update-url)
                                                      (if (and (not (value-if-not-none subscriber-id)) (not (value-if-not-none group-id)))
                                                        (reset! show-hidden false)
                                                        (load-template-groups subscriber-id group-id))
                                                      (when group-id
                                                        (load-labels)))
        show-template-group-list? (fn []
                                    ;; Non- license admins should not see global templates
                                    (or
                                     (is-user-license-admin)
                                     (value-if-not-none @subscriber)
                                     (value-if-not-none @group)))
        edit-label-atom (atom nil)
        edit-label-state? #(= % @edit-label-atom)
        edit-label-key (fn [templategroup-id label-id]
                         (str templategroup-id "-" label-id))
        set-edit-label-state! (fn [edit-label-key]
                          (reset! edit-label-atom edit-label-key))
        set-label-cb (fn [templategroup old-label _ new-label]
                       (let [errors (atom nil)
                             current-label-id-set (set (map :id (:labels templategroup)))]
                         (->> 
                          (model/templategroup-update (:id templategroup)
                                                      {:name (:name templategroup)
                                                       :rule_id (:rule_id templategroup)
                                                       :category_id (get-in templategroup [:category :id])
                                                       :active (:active templategroup)
                                                       :type (template-type)
                                                       :collection_id @group
                                                       :label_name (when (:new @new-label)
                                                                     (:name @new-label))
                                                       :label_id (filterv identity
                                                                   (if (:new @new-label)
                                                                     (disj current-label-id-set (:id old-label))
                                                                     (conj
                                                                       (disj current-label-id-set (:id old-label))
                                                                       (:id @new-label))))})
                          (p/map (fn [_]
                                   (reset! new-label nil)
                                   (reset! edit-label-atom nil)
                                   (load-labels)
                                   (load-template-groups @subscriber @group)))
                          (process-error errors))))]
    (when
     (and
      (show-template-group-list?)
      (or @group (is-user-any-admin)))
      (load-template-groups @subscriber @group))
    (when-not (is-user-license-admin)
      (load-all-families all-families all-families-id-map))
    (when @group (load-labels))
    (add-watch compliance :type-change (fn [& _] (update-url) (load-template-groups @subscriber @group)))
    (add-watch order :changed-order (fn [& _] (update-url) (load-template-groups @subscriber @group)))
    (add-watch show-hidden :type-change (fn [& _] (update-url) (load-template-groups @subscriber @group)))
    (fn [_]
      [:div.groups
       [:div.filter.user-filter
        [:div.filter-items
         [list-options
          (when-not (is-user-license-admin)
            [:div
             ;; @all-families -- subscriber filtering depends on inspection of the list of families
             ;; for each subscriber, and confronting them with permissions to view templates
             (when (and (is-user-any-admin) @all-families)
               [subscriber-chooser
                {:subscriber-changed-cb uncheck-show-hidden-or-load-template-groups
                 :allow-empty           true
                 :subscriber-atom       subscriber
                 :group-atom            group
                 :admin-only            false
                 :preselect-if-one      true
                 :load-cb (fn [subscribers] (reset! subscriber-id-map (into {} (map (fn [sub] [(str (:id sub)) sub]) subscribers))))
                 :reload-on-change compliance
                 :filter-pred (fn [subscriber]
                                (let [subscriber-families (filter
                                                           #(= (:subscriber_id %) (:id subscriber))
                                                           @all-families)
                                      can-view-any (some
                                                    (fn [family] (model/can-view-family-template-list @compliance (:id family)))
                                                    subscriber-families)]
                                  (or
                                   (auth-model/is-user-subscriber-admin (:id subscriber))
                                   can-view-any)))}
                @(:selected-subscriber-atom options)])
             ;; @all-families -- subscriber filtering needs this; passed to group-chooser to avoid redundant API call.
             ;; The "when" condition makes sure that the chooser waits for all-fmailies, and skips calling for them.
             (when @all-families
               [group-chooser
                (merge
                 {:group-changed-cb uncheck-show-hidden-or-load-template-groups
                  :group-atom       group
                  :admin-only       false
                  :preselect-if-one true
                  :filter-pred      #(model/can-view-family-template-list @compliance (:id %))
                  :reload-on-change compliance
                  :all-families     @all-families
                  :load-cb          (fn [_ groups]
                                      (reset! group-id-map (into {} (map (fn [gr] [(str (:id gr)) gr]) groups))))}
                 (when (is-user-any-admin)
                   {:allow-empty     true
                    :subscriber-atom subscriber}))
                nil])])
          [:div
           [:ul [:li "Active status"]]
           [:select {:on-change (fn [ev]
                                  ((reset-from-event filter-active) ev)
                                  (update-url)
                                  (load-template-groups @subscriber @group))}
            [:option (option-value @filter-active "active") "Active"]
            [:option (option-value @filter-active "inactive") "Inactive"]
            [:option (option-value @filter-active "all") "All"]]]
          [:div
           [:ul [:li "Type"]]
           [:div
            [:label.u-margin-right--xs {:style {:line-height "2em"}}
             [:input (set-checked @compliance
                                  (merge
                                   {:on-change #(reset! compliance true)}
                                   (when-not (model/can-view-template-list true) {:disabled :disabled})))]
             "Compliance"]
            [:label.u-margin-right--xs
             [:input (set-checked (not @compliance)
                                  (merge
                                   {:on-change #(reset! compliance false)}
                                   (when-not (model/can-view-template-list false) {:disabled :disabled})))]
             "Task"]
            (when (or (value-if-not-none @group) (value-if-not-none @subscriber))
              [:label
               [:input (set-checked @show-hidden {:on-change #(reset! show-hidden (checked? %))})] "Show hidden"])]]]]]
       (if (is-user-license-admin)
         [:h2.o-media--medium "Global templates"]
         (cond
           (value-if-not-none @group)      [:h2.o-media--medium
                                            (when @group-id-map
                                              [:span "Family templates for " (collection-model/collection-name (@group-id-map (str @group)))])]
           (value-if-not-none @subscriber) [:h2.o-media--medium
                                            (when @subscriber-id-map
                                              [:span
                                               "Subscriber templates for "
                                               (model/subscriber-name (get-in @subscriber-id-map [(str @subscriber)]))])]
           :else                           [:h3.o-media--medium "Select family or subscriber"]))

       (when (show-template-group-list?)
         (if (seq @templategroups)
           [:table.t-table-redesign
            [:thead
             [:tr
              [:th (orderer order "Name" "name")]
              [:th (orderer order "Origin" "type")]
              [:th "Active"]
              [:th (orderer order "Category" "category_name")]
              [:th "Label"]
              [:th ""]]]
            [:tbody
             (doall
              (for [templategroup @templategroups]
                (let [can-edit (or
                                (some-> (:collection_id templategroup) is-user-group-admin)
                                (some-> (:subscriber_id templategroup) is-user-subscriber-admin)
                                (is-user-license-admin))]
                  [:tr
                   (merge {:key (:id templategroup)}
                          (when (:task_template_group_deleted_id templategroup)
                            {:class :u-text-line-through
                             :title (str "Hidden " (clojure.string/lower-case (template-group-type templategroup)) " " (:name templategroup) " template")}))
                   [:td
                    [:a
                     {:href (str (path-for (if can-edit :settings-templategroup-edit :settings-templategroup-preview) :id (:id templategroup))
                                 "?"
                                 (util/make-params
                                  (util/remove-nil-values
                                   (merge
                                    {:group_id      (value-if-not-none @group)
                                     :subscriber_id (value-if-not-none @subscriber)
                                     :type          (template-type)
                                     :filter_active @filter-active,
                                     :order @order}
                                    (when @show-hidden {:show_hidden "yes"})))))}
                     (:name templategroup)]]
                   [:td.u-text-align-center
                    (template-group-type templategroup)]
                   [:td.u-text-align-center (if (:active templategroup) "yes" "no")]
                   [:td (get-in templategroup [:category :name])]
                   [:td
                    (when (= (template-group-type templategroup) "Family")
                      (let [label-filter-pred (fn [label label-list-label]
                                                (or
                                                  (= (:id label-list-label) (:id label))
                                                  (not (contains? (set (map :id (:labels templategroup))) (:id label-list-label)))))]
                        [:div.c-disposition-list {:class :editable}
                         (doall (for [label (sort-by :name (:labels templategroup))]
                                  
                                  (if (edit-label-state? (edit-label-key (:id templategroup) (:id label)))
                                    [:div.u-margin-top--xs.u-margin-bottom--xs
                                     [label/label-inline-chooser {:set-label-cb (partial set-label-cb templategroup label)
                                                                  :family-id @group
                                                                  :filter-pred (partial label-filter-pred label)}
                                      {:labels [label]} edit-label-atom]]
                                    [:span {:key (:id label)
                                          :on-click
                                          (util/handler (fn [] 
                                                          (set-edit-label-state! (edit-label-key (:id templategroup) (:id label)))))}
                                     [label/label (:name label)]])))
                         
                         (if (edit-label-state? (edit-label-key (:id templategroup) :new))
                           [:div.u-margin-top--xs.u-margin-bottom--xs
                            [label/label-inline-chooser {:new true
                                                         :set-label-cb (partial set-label-cb templategroup nil) #_set-label-cb
                                                         :family-id @group
                                                         :filter-pred (partial label-filter-pred nil)}
                             templategroup edit-label-atom]]
                           [:span.c-disposition-new {:key :new
                                                   :on-click (util/handler #(set-edit-label-state! (edit-label-key (:id templategroup) :new)))}
                            [:button.c-round-button "+"]])]))]
                    [:td.u-text-align-center
                     [:div.o-margin-elements--md
                      (when (and
                              (:active templategroup)
                              (has-perm :can_do_bulk_operations)
                              (value-if-not-none @group)
                              (not (:task_template_group_deleted_id templategroup)))
                        [:button
                         {:on-click (util/handler
                                      #(util/set-location
                                         (str (path-for :task-add-bulk) "?"
                                           (util/make-params
                                            (merge
                                             {:group_id          @group
                                              :template_group_id (:id templategroup)
                                              :type              (template-type)
                                              :subscriber_id @subscriber
                                              :filter_active @filter-active
                                              :order @order}
                                             (when @show-hidden {:show_hidden "yes"}))))))}
                        "Apply"])
                     (when @all-families
                       [template-actions {:subscriber-id      (value-if-not-none @subscriber)
                                          :subscriber-id-atom subscriber
                                          :collection-id      (value-if-not-none @group)
                                          :collection-id-atom group
                                          :done-cb            #(load-template-groups @subscriber @group)
                                          :can-edit           can-edit
                                          :can-view-more      (is-user-any-admin)
                                          :type          (template-type)
                                          :filter-active @filter-active
                                          :order @order}
                        templategroup
                        (can-copy-to-any-subscriber
                         templategroup
                         (fn [family-id] (get-in
                                          @all-families-id-map
                                          [family-id :subscriber_id])))])]]])))]]
           [:p.o-media "No template groups. " (when (is-user-group-admin @group) "Use Add button to add first group.")]))])))

(defn- has-changes [changed]
  (some true? (vals changed)))

(defn templategroup-edit-form [{:keys [preview] :as options} group-id subscriber-id templategroup changed-atom]
  (let [errors (atom {})
        aname (atom (:name templategroup))
        description (atom (:description templategroup))
        rule (atom (:rule_id templategroup))
        category (atom (:category_id templategroup))
        categories (clojure.core/atom nil)
        active (atom (:active templategroup))
        task-type-string (if (or (:compliance options) (:compliance templategroup)) "compliance" "task")
        disable (partial with-disabled preview)
        label (atom (:labels templategroup))
        ttg-family-scope? (if templategroup
                            (= (task-model/templategroup-scope (:collection_id templategroup) (:subscriber_id templategroup)) task-model/template-scope-family)
                            (= (task-model/templategroup-scope group-id subscriber-id) task-model/template-scope-family))
        load-labels (fn []
                      (controller/dispatch :label-list :load {:family-id group-id
                                                              :object-type model/object-type-task-template-group
                                                              :errors-atom errors}))]

    (when ttg-family-scope?
      (load-labels))
    (doall
     (for [atm [aname rule category active]]
       (add-watch atm :templategroup-edit-watch (fn [_ _ olds news]
                                                  (when (not= olds news)
                                                    (swap! changed-atom assoc :group true))))))
    (fn [{:keys [preview] :as options} group-id subscriber-id templategroup changed-atom]
      [:form.c-form--edit {:on-submit (when-not preview
                                        (util/handler
                                         (fn [_]
                                           (let [submit-func (if templategroup
                                                               (partial (if (is-user-license-admin)
                                                                          model/license-admin-templategroup-update
                                                                          model/templategroup-update) (:id templategroup))
                                                               (if (is-user-license-admin)
                                                                 model/license-admin-templategroup-add
                                                                 model/templategroup-add))]
                                             (->> (submit-func
                                                   (merge {:name @aname
                                                           :description @description
                                                           :rule_id @rule
                                                           ;; Deficient code-level backend constraints could cause category that is no longer
                                                           ;; available to be still attached to the template group. The backend constraints
                                                           ;; are now improved. The below filtering (to only pass a value present in the list)
                                                           ;; is in place in order to "fix" existing data on edits.
                                                           :category_id (:id (first (filter #(= (str @category) (str (:id %))) @categories)))
                                                           :active @active
                                                           :type task-type-string
                                                           :collection_id group-id}
                                                          (when-not group-id {:subscriber_id subscriber-id})
                                                          (when ttg-family-scope?
                                                            {:label_id (vec (for [lb @label :when (not (:new lb))] (:id lb)))
                                                             :label_name (vec (for [lb @label :when (:new lb)] (:name lb)))})))
                                                  (p/map (fn [response]
                                                           (set-flash :success "Template group saved")
                                                           (if templategroup
                                                             (swap! changed-atom assoc :group false)
                                                             (util/set-location
                                                              (str
                                                               (path-for :settings-templategroup-edit :id (:id response))
                                                               "?"
                                                               (util/make-params (util/remove-nil-values (:waypoint-params options))))))))
                                                  (process-error errors [:subscriber_id]))))))}
       [:dl
        [:dt "Name"]
        [:dd [:input.u-full-width (disable {:value @aname :on-change (util/reset-from-event aname)})]]
        [:span.error (:name @errors "")]]
       [:dl
        [:dt "Description"]
        [:dd
         [:textarea (disable {:value @description :on-change (util/reset-from-event description)})]
         [:span.error (:description @errors "")]]]
       [:dl
        [:dt "Category"]
        [:dd (if preview
               [:select {:disabled :disabled} [:option (get-in templategroup [:category :name])]]
               [category-component/category-chooser
                {:categories-loaded-cb (fn [category-list] (reset! categories category-list))
                 :disabled preview}
                (clojure.core/atom
                 (if templategroup
                   (get-scope (:subscriber_id templategroup) (:collection_id templategroup))
                   (get-scope (not-empty subscriber-id) (not-empty group-id))))
                category "s"])
         [:span.error (:category_id @errors "")]]]

       (when (= task-type-string "compliance")
         [:dl
          [:dt "Repeat"]
          [:dd [rule-chooser {:recurring-object-type :task
                              :disabled preview
                              :allow-no-choice true
                              :allow-no-choice-label "-- Choose --"
                              :must-repeat true} rule] [:span.error (:rule_id @errors "")]]])
       [:dl
        [:dd [:label [:input (disable (set-checked @active {:on-click #(reset! active (checked? %))}))] "Is Active?"]
         [:span.error (:is_active @errors "")]]]


       (when ttg-family-scope?
         [:dl
          [:dt "Assign label"]
          [:dd
           [label/label-chooser-multi {:allow-empty true
                                       :allow-create-new true} group-id label]
           [:span.error (:label-chooser @errors "")]]])

       [:footer.u-flex.u-flex--justify-content-space-between
        [:span
         [:button.c-button {:on-click (util/handler
                                       (fn []
                                         (let [back-fn #(util/set-location
                                                         (str (path-for :settings-templategroup-list) "?" (util/make-params (util/remove-nil-values (:waypoint-params options)))))]
                                           (if (has-changes @changed-atom)
                                             (common/show-confirmation-modal
                                              {:title "Unsaved changes"
                                               :text "There are unsaved changes that will be lost. Are you sure you want to go back?"
                                               :ok-cb back-fn})
                                             (back-fn)))))}
          "Back"]
         (when (and templategroup (has-changes @changed-atom)) [:mark.save-status.is-unsaved])]
        (when-not preview [:button.c-button "Save"])]])))

(defn disposition-static-view [{:keys [click-cb]
                                :as _} disp]
  [:span.u-cursor--pointer {:style {:line-height "2.5em"
                                    :vertical-align :middle}
                            :on-click (util/handler click-cb)} (:uid disp)])

(defn template-dispositions-edit [{:keys [change-cb
                                          load-options-fn]} template-dispositions-id-map disposition-atoms]
  (let [template-dispositions-id-map-atom (atom template-dispositions-id-map)
        edited-disposition-id (atom nil)]
    (fn []
      [:div
       (doall
        (map-indexed
         (fn [index disposition-atom]
           (let [disposition-id (:id @disposition-atom)]
             [:div.c-field-inline-column__field {:key (str index "-" disposition-id) :style {}}
              [:div {:style {:white-space :nowrap :position "relative"}}
               (when (seq (filter (comp :id deref) @disposition-atoms))
                 [:button.c-assignments-edit-button.c-round-button
                  {:on-click (util/handler
                              (fn []
                                (if (> (count @disposition-atoms) 1)
                                  (swap! disposition-atoms util/vec-remove index)
                                  (reset! (nth @disposition-atoms index) {:id nil :new false}))))}
                  [:span "×"]])
               (if (= @edited-disposition-id disposition-id)
                 [:div.u-width--full {:style {:display "inline-block"}}
                  [automation/disposition-chooser-fuzzy
                   {:async true
                    :load-options-fn load-options-fn
                    :react-select-options {:openMenuOnClick false}
                    :allow-empty true
                    :allow-create-new false
                    :blur-cb (fn []
                               (reset! edited-disposition-id nil))
                    :mount-cb (fn [el]
                                ;; Originally introduced in #2335 for reason unclear.
                                ;; Disabled due to #2700
                                #_(when el (.focus el)))
                    :change-cb (fn [value]
                                 (swap! template-dispositions-id-map-atom assoc (:id value) {:id (:id value) :uid (:label value)})
                                 (swap! disposition-atom merge value)
                                 (change-cb value))
                    :filter-pred (fn [disposition]
                                   (not (contains? (set (map (comp :id deref) (util/vec-remove @disposition-atoms index))) (:id disposition))))}
                   disposition-atom]]

                 (let [disp (@template-dispositions-id-map-atom disposition-id)]
                   [disposition-static-view {:click-cb #(reset! edited-disposition-id disposition-id)} disp]))]]))
         @disposition-atoms))])))

(defn- reload-templategroup [options template-group-id]
  (->>
   (if (is-user-license-admin)
     (model/license-admin-templategroup template-group-id)
     (model/templategroup-get template-group-id))
   (p/map
    (fn [response]
      ((:set-template-group-fn options) response)
      (when-let [add-new (:add-new options)]
        (reset! add-new false))))
   (process-error)))

(defn template-edit [{:keys [preview] :as options} group-id _ _ _ _ _]
  (let [errors (atom {})
        users (:users options)
        disable (partial with-disabled preview)
        dispositions-collapsed? (atom (> (count @(get-in options [:form-data :assigned-dispositions])) 3))]

    (fn [{:keys [other-templates-have-dispositions
                 group-mode
                 group-setup-cb
                 is-independent-step
                 allow-independent-steps] :as options} group-id subscriber-id template index before-id changed-atom]
      (let [aname (get-in options [:form-data :name])
            description (get-in options [:form-data :description])
            signature-scope (get-in options [:form-data :signature-scope])
            assign-to (get-in options [:form-data :assign-to])
            interval (get-in options [:form-data :interval])
            before-id (clojure.core/atom before-id)
            templategroup (:templategroup options)
            assigned-dispositions (get-in options [:form-data :assigned-dispositions])
            is-first (= index 0)
            is-last (= index (- (count (:task_templates @(:templategroup options))) 1))
            alert-options {:on? (get-in options [:form-data :alert-enabled])
                           :enabled (get-in options [:form-data :alert-enabled])
                           :before-due-days (get-in options [:form-data :before-due-days])
                           :past-due-days (get-in options [:form-data :past-due-days])}
            keep-document-date (get-in options [:form-data :keep-document-date])
            submit (fn []
                     (->>
                      (let [submit-func (if template
                                          (partial
                                           (if (is-user-license-admin)
                                             model/license-admin-template-update
                                             model/template-update)
                                           (:id template))
                                          (if (is-user-license-admin)
                                            model/license-admin-template-add
                                            model/template-add))]
                        (submit-func
                         (merge
                          (when
                           (or (is-user-group-admin group-id) (is-user-subscriber-admin subscriber-id))
                            {:user_id (to-value @assign-to)})
                          (when (is-user-group-admin group-id)
                            {:disposition_id (filterv identity (mapv (comp to-value :id deref) @assigned-dispositions))})
                          {:template_group_id   (:group-id options)
                           :collection_id       group-id
                           :subscriber_id       subscriber-id
                           :name                @aname
                           :description         @description
                           :signature_scope     @signature-scope
                           :before_template_id  @before-id
                           :days_after_previous @interval
                           :alert_enabled @(:enabled alert-options)
                           :before_due_days @(:before-due-days alert-options)
                           :past_due_days @(:past-due-days alert-options)
                           :keep_document_date @keep-document-date})))
                      (p/map
                       (fn [_]
                         (reload-templategroup options (:group-id options))
                         (set-flash :success "Template saved")
                         (swap! changed-atom assoc (:id template) false)
                         (reset! errors nil)))
                      (process-error errors)))]
        (doall
         (for [atm (concat
                    [aname description signature-scope assign-to interval assigned-dispositions]
                    @assigned-dispositions
                    (vals alert-options))]
           (add-watch atm :templategroup-edit-watch (fn [_ _ olds news]
                                                      (when (not= olds news)
                                                        (swap! changed-atom assoc (:id template) true))))))
        [:div.o-media.u-shadow--bottom {:class (util/classes
                                                (when (@changed-atom (:id template)) :u-has-changes)
                                                (if is-independent-step :is-independent :is-dependent))
                                        :style {:padding-left "12px"}}
         [:h3
          (when (and template (not preview))
            [:span
             (when (and
                    allow-independent-steps
                    (not @(:enabled alert-options))
                    (not (:is-alert-orphan options))
                    (not (contains? task-model/nondependent-group-forbidden-step-types @signature-scope)))
               [:span {:on-click (util/handler (fn [] (group-setup-cb)))
                       :style {:vertical-align :middle
                               :margin-right "0.2em"}}
                [:img {:src "/static/img/icons/group-steps.svg"
                       :style {:width "0.8em"
                               :heifght "0.8em"}}]])
             (when-not is-last [:a {:href "#"
                                    :on-click (util/handler (fn []
                                                              (when-not group-mode
                                                                (reset! before-id (:id (nth (:task_templates @(:templategroup options)) (+ 2 index) nil)))
                                                                (submit))))
                                    :class (when group-mode :u-non-clickable)} "▼"])
             (when-not is-first [:a {:href "#"
                                     :on-click (util/handler (fn []
                                                               (when-not group-mode
                                                                 (reset! before-id (:id (nth (:task_templates @(:templategroup options)) (- index 1))))
                                                                 (submit))))
                                     :class (when group-mode :u-non-clickable)} "▲"])])
          (task-model/step-name index @aname)]
         [:form.c-form--edit {:on-submit (util/handler submit)}
          [:dl
           [:dt "Title"]
           [:dd
            [:input.u-full-width (disable {:value @aname
                                           :on-change (util/reset-from-event aname)})]
            [:span.error (:name @errors "")]]]
          [:dl
           [:dt "Description"]
           [:dd
            [:textarea (disable {:value @description :on-change (util/reset-from-event description)})]
            [:span.error (:description @errors "")]]]
          (when-not is-first
            [:dl
             [:dt "Date offset"]
             [:dd
              [:select (disable {:on-change (reset-from-event interval)})
               (doall
                (for [anum (take 365 (range))]
                  [:option (option-value @interval anum) anum]))] " day(s)"
              [:span.error (:days_after_previous @errors "")]]])
          [:dl
           [:dt "Step Type"]
           [:dd [signature-scope-chooser (disable {:compliance (:compliance @(:templategroup options))}) group-id signature-scope]
            (when (task-model/is-dropbox-sign-signature-scope @signature-scope)
              [task-component/keep-document-date-checker {:keep-document-date-atom keep-document-date :errors-atom errors}])
            [:span.error (:signature_scope @errors "")]]]
          (when
           (and
            (or (not preview) (not-empty (str @assign-to)))
            (not=
             (task-model/templategroup-scope (:collection_id @templategroup) (:subscriber_id @templategroup))
             task-model/template-scope-global))
            [:dl
             [:dt "Assign to (template)"]
             [:dd
              [auth-component/user-chooser-fuzzy
               (disable {:allow-empty true})
               (let [user (:user template)]
                 (if (and user (not (contains? (set (map :id @users)) (:id user))))
                   (conj @users (update user :last_name (fn [aname] (str aname " <invalid>"))))
                   @users))
               assign-to]
              [:span.error (:user_id @errors "")]]])
          (when
           (and (is-user-group-admin group-id)
                (= (task-model/templategroup-scope (:collection_id @templategroup) (:subscriber_id @templategroup)) task-model/template-scope-family)
                (not (:compliance @templategroup))
                (not other-templates-have-dispositions))
            [:dl.o-collapsable {:class (when @dispositions-collapsed? "is-collapsed ")}
             [:dt.u-cursor--pointer.u-flex {:on-click #(swap! dispositions-collapsed? not)}
              [:span {:style {:display "inline-block"}} "Assign dispositions" (when @dispositions-collapsed? [:span " (" (count @assigned-dispositions) ")"])]
              [:a.o-collapsable__expander]]
             [:dd
              [:div
               [template-dispositions-edit
                {:change-cb #{}
                 :load-options-fn (:load-disposition-options options)}
                (get-in options [:form-data :disposition-id-map])
                assigned-dispositions]

               (let [last-assignment (some-> assigned-dispositions deref seq last deref util/to-value)]
                 (when (or
                         (:id last-assignment)
                         (:new last-assignment))
                   [:button.c-field-inline__button (with-disabled group-mode
                                                     {:on-click (util/handler
                                                                  (fn []
                                                                    (swap! assigned-dispositions conj (atom nil))))}) "Add new"]))]

              [:span.error (:disposition-chooser-fuzzy @errors "")]]])
          (when-not (:non_dependent template)
            [:dl
             [alert-edit (merge {:disabled preview :errors-atom errors} alert-options) (:id template)]
             [:p.error (:alert_enabled @errors)]
             [:p.error (:before_due_days @errors)]
             [:p.error (:past_due_days @errors)]])
          (let [add-new (:add-new options)]
            (if preview
              (when (@changed-atom (:id template))
                [:footer.u-flex [:button.c-button.u-flex__element-to-right "Save"]])
              [:footer.u-flex
               (when add-new [:button.c-button (with-disabled group-mode
                                                 {:type :button
                                                  :on-click (util/handler (fn []
                                                                            (swap! changed-atom assoc (:id template) false)
                                                                            (swap! add-new not)
                                                                            ((:clear-new-template-form-data options))
                                                                            false))}) "Cancel"])
               (when-not add-new
                 [:button.c-button (with-disabled group-mode
                                     {:on-click (util/handler
                                                 (fn []
                                                   (when (.confirm js/window "Are you sure you want to delete the template?")
                                                     (->> ((if (is-user-license-admin)
                                                             model/license-admin-template-delete
                                                             model/template-delete) (:id template))
                                                          (p/map (fn [_]
                                                                   (reload-templategroup options (:group-id options))
                                                                   (set-flash :success "Template has been deleted")))
                                                          (process-error)))))}) "Delete"])
               [:button.c-button.u-flex__element-to-right (with-disabled group-mode {}) "Save"]]))]]))))

(defn can-choose-user [preview group-id subscriber-id has-templates]
  (cond
    (not has-templates) false
    (not (or subscriber-id group-id)) false
    (not preview) true
    (is-user-license-admin) false
    (and (is-user-subscriber-admin subscriber-id) (or group-id subscriber-id)) true
    (and (is-user-group-admin group-id) group-id) true
    (and (is-user-regular group-id) group-id) true
    :else false))

(defn template-header [_ family-id subscriber-id]
  (let [scope-obj (atom nil)]
    (cond
      family-id (->>
                 (collection-model/collection-details family-id)
                 (p/map #(reset! scope-obj %))
                 (process-error))
      subscriber-id (->>
                     (model/subscriber subscriber-id)
                     (p/map #(reset! scope-obj %))
                     (process-error)))
    (fn [mode family-id subscriber-id]
      ;; When not global, wait for the scope object to be loaded
      ;; Otherwise, the line might get broken for an unclear reason
      (let [scope (task-model/templategroup-scope family-id subscriber-id)]
        (when (or (= scope task-model/template-scope-global) @scope-obj)
          [:span
           (case mode
             :edit "Edit template group "
             :add "Add template group "
             :preview "Template group ")
           (when-not (= scope task-model/template-scope-global)
             [:span
              "for "
              (condp = scope
                task-model/template-scope-family (model/subscriber-name @scope-obj)
                task-model/template-scope-subscriber (collection-model/collection-name @scope-obj))
              " "])
           (task-model/templategroup-scope-name family-id subscriber-id)])))))

(defn load-all-families [all-families-atom all-families-id-map-atom]
  (->>
   (collection-model/permitted-groups nil)
   (p/map (fn [families]
            (reset! all-families-atom families)
            (reset!
             all-families-id-map-atom
             (into {} (map (fn [family] [(:id family) family]) families)))))
   (process-error)))


(defn templategroup-details [{:keys [preview] :as options} group-id subscriber-id tg]
  (let [add-new (atom false)
        templategroup (atom tg)
        template-users (subscribe :template-users)
        all-families (atom nil)
        all-families-id-map (clojure.core/atom nil)
        changed (atom {})
        users (subscribe :template-user-choices)
        new-template-form-data (fn []
                                 {:name (atom nil)
                                  :description (atom nil)
                                  :signature-scope (atom nil)
                                  :assign-to (atom nil)
                                  :assigned-dispositions (atom [])
                                  :disposition-id-map (atom nil)
                                  :interval (atom nil)
                                  :alert-enabled (atom false)
                                  :before-due-days (atom 0)
                                  :past-due-days (atom 0)
                                  :keep-document-date (atom false)})
        build-template-form-data (fn [templategroup]
                                   (merge (into {} (map (fn [template] [(:id template) {:name (atom (task-model/task-name template))
                                                                                        :description (atom (:description template))
                                                                                        :signature-scope (atom (:signature_scope template))
                                                                                        :assign-to (atom (:user_id template))
                                                                                        :assigned-dispositions (atom (if-let [disposition-ids (seq (:disposition_ids template))]
                                                                                                                       (mapv (fn [id] (atom {:id id :new false})) disposition-ids)
                                                                                                                       [(atom {:id nil :new false})]))
                                                                                        :disposition-id-map (util/associate-by :id (:dispositions template))
                                                                                        :interval (atom (:days_after_previous template))
                                                                                        :alert-enabled (atom (:alert_enabled template))
                                                                                        :before-due-days (atom (or (:before_due_days template) 0))
                                                                                        :past-due-days (atom (or (:past_due_days template) 0))
                                                                                        :keep-document-date (atom (:keep_document_date template))}]) (:task_templates templategroup)))
                                          {:new (new-template-form-data)}))
        template-form-data (atom (build-template-form-data tg))


        allow-independent-steps (not (:compliance @templategroup))
        group-mode (atom false)
        group-step-indexes (atom nil)
        initial-group-step-indexes (atom nil)
        set-group-indexes! (fn []
                             (reset! group-step-indexes
                                     (set
                                      (for [[index tmpl] (map-indexed #(vec %&) (:task_templates @templategroup))
                                            :when (:non_dependent tmpl)]
                                        (inc index))))
                             (reset! initial-group-step-indexes @group-step-indexes))
        _ (set-group-indexes!)
        set-template-group! (fn [tg]
                              (reset! templategroup tg)
                              (set-group-indexes!)
                              (swap! template-form-data (fn [tf-data]
                                                          (merge (build-template-form-data tg) tf-data))))]

    (controller/dispatch :template-user-choices :clear)
    (when-not (or
               (is-user-license-admin)
               preview)
      (controller/dispatch :template-user-choices :load
                           {:collection-id (:collection_id @templategroup)
                            :subscriber-id (:subscriber_id @templategroup)
                            :compliance (:compliance @templategroup)}))
    (when-not (is-user-license-admin)
      (load-all-families all-families all-families-id-map))
    (when (can-choose-user preview group-id subscriber-id (seq (:task_templates @templategroup)))
      (add-watch template-users :template-users-watch (fn [_ _ _ new-users]
                                                        ;; For some reason, this watch sometimes gets triggerded with nil value,
                                                        ;; despite :template-users controller's :load code that resets the state
                                                        ;; (after receiving users from back-end) not getting called.
                                                        (when new-users
                                                          (reset!
                                                           template-form-data
                                                           (into {} (map
                                                                     (fn [[template-id template-data]]
                                                                       [template-id (assoc-in template-data [:assign-to] (atom (new-users template-id)))])
                                                                     @template-form-data)))))))
    (fn []
      (let [templates (:task_templates @templategroup)
            num-templates (count templates)
            index-nondependent-forbidden (map (fn [tmpl]
                                                (or
                                                 @(:alert-enabled (@template-form-data (:id tmpl)))
                                                 (contains?
                                                  task-model/nondependent-group-forbidden-step-types
                                                  @(:signature-scope (@template-form-data (:id tmpl))))))
                                              templates)
            is-orphan (fn [index]
                        (let [previous-index (dec index)
                              next-index (inc index)
                              previous-nondependent-forbidden (or (< previous-index 0) (nth index-nondependent-forbidden previous-index))
                              next-nondependent-forbidden (or (>= next-index (count templates)) (nth index-nondependent-forbidden next-index))]
                          (and previous-nondependent-forbidden next-nondependent-forbidden)))
            options (merge options {:group-id (:id @templategroup)
                                    :templategroup templategroup
                                    :set-template-group-fn set-template-group!
                                    :users users})]
        [common/header-tab-wrapper
         [template-header (if preview :preview :edit) (:collection_id @templategroup) (:subscriber_id @templategroup)]
         [:div.templategroup-details
          ;; without the wrapping div below, changing group-mode causes full recreation of template-edit
          ;; components, along with API calls
          [:div
           (when (and allow-independent-steps @group-mode)
             [task-component/group-independent-tasks
              {:group-mode group-mode
               :group-step-indexes group-step-indexes
               :save-group-fn (fn []
                                (let [submit-func (if (is-user-license-admin)
                                                    model/license-admin-templategroup-update
                                                    model/templategroup-update)]
                                  (->> (submit-func
                                        (:id @templategroup)
                                        {:step_group_edit "1"
                                         :group_step_indexes (vec @group-step-indexes)})
                                       (p/map (fn [response]
                                                (set-flash :success "Independent step groups saved")
                                                (reset! group-mode false)
                                                (reload-templategroup {:set-template-group-fn set-template-group!} (:id @templategroup))))
                                       (process-error (atom nil) [:group_step_indexes]))))
               :cancel-cb (fn []
                            (reset! group-step-indexes @initial-group-step-indexes)
                            (reset! group-mode false))} nil])]
          [:div.u-shadow--bottom.o-media [templategroup-edit-form options group-id subscriber-id @templategroup changed]]
          (doall
           (map-indexed (fn [index template]
                          ^{:key (:id template)}
                          [template-edit (merge options
                                                {:form-data (@template-form-data (:id template))
                                                 :load-disposition-options
                                                 (util/debounce-promise
                                                  (fn [partial-uid]
                                                    (when (>= (count partial-uid) 3)
                                                      (->>
                                                       (model/automation-disposition-list group-id nil nil nil nil partial-uid nil nil)
                                                       (p/map (fn [response]
                                                                (let [current-disposition-id-set (set
                                                                                                  (filter identity
                                                                                                          (map (comp :id deref)
                                                                                                               @(get-in @template-form-data
                                                                                                                        [(:id template) :assigned-dispositions]))))]
                                                                  (clj->js (automation/dispositions-format
                                                                            (remove
                                                                             (fn [disp] (contains? current-disposition-id-set (:id disp)))
                                                                             (:results response)))))))))) 1000)
                                                 ,
                                                 :is-alert-orphan (is-orphan index)
                                                 :other-templates-have-dispositions (some
                                                                                     seq
                                                                                     (filter
                                                                                      (fn [disposition-atoms]
                                                                                        (some (comp :id deref) disposition-atoms))
                                                                                      (map
                                                                                       (comp deref :assigned-dispositions)
                                                                                       (vals (dissoc @template-form-data (:id template))))))
                                                 :user-id (atom (some-> @template-users (apply [(:id template)])))
                                                 :allow-independent-steps allow-independent-steps
                                                 :group-mode @group-mode
                                                 :group-setup-cb (fn [] (task-component/independent-group-setup group-mode group-step-indexes (inc index)))
                                                 :is-independent-step (some #(= % (inc index)) @group-step-indexes)})
                           group-id subscriber-id template index (when (< (+ index 1) num-templates)
                                                                   (:id (nth templates (+ index 1)))) changed]) templates))
          (if @add-new
            (do
              [template-edit (merge options {:add-new add-new
                                             :form-data (new-template-form-data)}) group-id subscriber-id nil num-templates nil changed])

            [:footer.o-media.u-flex.u-flex--justify-content-space-between
             (when-not preview [:button.c-button {:on-click (fn [_]
                                                              (when (.confirm js/window "Are you sure you want to delete the template group?")
                                                                (->> ((if (is-user-license-admin)
                                                                        model/license-admin-templategroup-delete
                                                                        model/templategroup-delete) (:id @templategroup))
                                                                     (p/map (fn [_]
                                                                              (set-flash :success "Template group has been deleted")
                                                                              (util/set-location (str (path-for :settings-templategroup-list) "?group_id=" group-id))))
                                                                     (process-error))))} "Delete template group"])

             [:div.o-margin-elements--xs.u-flex__element-to-right
              (when-not preview [:button.c-button {:on-click #(swap! add-new not)} "Add new step"])
              (when (and
                     @all-families
                     (can-copy-to-any-subscriber @templategroup (fn [family-id] (get-in @all-families-id-map [family-id :subscriber_id])))
                     (not (has-changes @changed)))
                [:button.c-button {:on-click (util/handler (fn []
                                                             (show-template-copy-modal
                                                              {:title         (str "Save template \"" (:name @templategroup) "\" to:")
                                                               :can-be-hidden (model/can-templategroup-be-hidden @templategroup)
                                                               :copy-type     "subscriber"
                                                               :template-id   (:id @templategroup)
                                                               :template-group @templategroup
                                                               :subscriber-id (atom (if (:subscriber_id @templategroup)
                                                                                      (:subscriber_id @templategroup)
                                                                                      (when-let [family-id (:collection_id @templategroup)]
                                                                                        (get-in @all-families-id-map [family-id :subscriber_id]))))
                                                               :errors        (atom nil)
                                                               :done-cb (:done-cb options)
                                                               :hide-original (atom false)})))} "Save to Subscriber As"])
              (when
               (and
                (can-copy-to-family)
                (not (has-changes @changed)))
                [:button.c-button {:on-click (util/handler (fn []
                                                             (show-template-copy-modal
                                                              {:title         (str "Save template \"" (:name @templategroup) "\" to:")
                                                               :can-be-hidden (model/can-templategroup-be-hidden @templategroup)
                                                               :copy-type     "group"
                                                               :template-id   (:id @templategroup)
                                                               :template-group @templategroup
                                                               :subscriber-id (atom subscriber-id)
                                                               :group-id      (atom nil)
                                                               :errors        (atom nil)
                                                               :done-cb (:done-cb options)
                                                               :hide-original (atom false)})))} "Save to Family As"])]])]]))))

(defn templategroup-add [options group-id subscriber-id]
  (let [changed (atom {})]
    (fn []
      [common/header-tab-wrapper
       [template-header :add group-id subscriber-id]
       [:div.u-shadow--bottom.o-media [templategroup-edit-form options group-id subscriber-id nil changed]]])))

(defn asset-type-form [{:keys [success-cb cancel-cb is-add before-asset-type-id]} group-id values-atom]
  (let [original-values @values-atom
        changed #(not= original-values @values-atom)
        errors (atom nil)
        submit (fn []
                 (let [submit-func (condp = [(is-user-license-admin) (if (:id original-values) :update :add)]
                                     [false :add] (partial model/group-admin-asset-type-add group-id)
                                     [false :update] (partial model/group-admin-asset-type-update group-id (:id original-values))
                                     [true :add] model/license-admin-asset-type-add
                                     [true :update] (partial model/license-admin-asset-type-update (:id original-values)))]
                   (->> (submit-func (assoc
                                      (select-keys @values-atom [:name])
                                      :before_asset_type_id before-asset-type-id))
                        (p/map (fn [_]
                                 (set-flash :success "Collection type saved")
                                 (some-> success-cb (apply []))))
                        (process-error errors))))]
    (fn []
      [:div (when-not is-add {:class "o-media--small"})

       [:form.c-form--edit.c-form--edit--left.c-form--input-wide {:on-submit (util/handler submit)}
        [:h4.u-margin-bottom--small
         (if is-add
           "Add new collection type"
           (str "Edit " (:name original-values)))]

        [:dl
         [:dt "Name:"]
         [:dd [:input {:value (:name @values-atom)
                       :on-change (swap-from-event values-atom update :name #(not-empty %2))}]]] [:span.error (:name @errors)]

        [:footer.o-space-between
         [:div.o-margin-elements--xs
          (when cancel-cb
            [:button {:type :button :on-click #(cancel-cb)} "Cancel"])
          [:button
           {:on-click (util/handler
                       (fn []
                         (when (js/confirm "Are you sure you want to delete this collection type?")
                           (->> (if (is-user-license-admin)
                                  (model/license-admin-asset-type-delete (:id original-values))
                                  (model/group-admin-asset-type-delete group-id (:id original-values)))
                                (p/map (fn [_]
                                         (set-flash :success "Collection type deleted")
                                         (some-> success-cb (apply []))))
                                (p/error (fn [err]
                                           (if (= 405 (:status err))
                                             (set-flash :error "Cannot delete collection type, it is used by some of the subtypes.")
                                             (throw err))))
                                (process-error)))))
            :type :button} "Delete"]]
         [:button.c-button (when-not (changed) {:disabled :disabled :type :submit}) "Save"]]]])))

(defn collection-type-form [{:keys [success-cb cancel-cb is-add before-collection-type-id]} family-id values-atom]
  (let [original-values @values-atom
        changed #(not= original-values @values-atom)
        errors (atom nil)
        templates (subscribe :collection-template-list)
        template-choices (fn [templates]
                           (mapv (fn [template] {:label (:name template) :value (:ref template)})
                                 templates))
        ref-template-map (track! #(util/associate-by :ref @templates))
        load-templates  (fn []
                          (controller/dispatch :collection-template-list :load))
        submit (fn []
                 (let [submit-func (condp = [(is-user-license-admin) (if (:id original-values) :update :add)]
                                     [false :add] (partial model/group-admin-collection-type-add family-id)
                                     [false :update] (partial model/group-admin-collection-type-update family-id (:id original-values))
                                     [true :add] model/license-admin-collection-type-add
                                     [true :update] (partial model/license-admin-collection-type-update (:id original-values)))]
                   (->> (submit-func (assoc
                                      (select-keys @values-atom [:name
                                                                 :asset_type_id
                                                                 :ref
                                                                 :regulatory_oversight
                                                                 :cta_missing_warning
                                                                 :chart_subject
                                                                 :chart_include])
                                      :before_collection_type_id before-collection-type-id))
                        (p/map (fn [_]
                                 (set-flash :success "Collection subtype saved")
                                 (some-> success-cb (apply []))))
                        (process-error errors))))]
    (load-templates)
    (add-watch values-atom :chart-subject-include
               (fn [_ _ oldv newv]
                 (let [old-chart-subject (:chart_subject oldv)
                       new-chart-subject (:chart_subject newv)]
                   (when (and
                          new-chart-subject
                          (not= old-chart-subject new-chart-subject)
                          (not (:chart_include oldv)))
                     ;; Can be chart subject implies can be included.
                     (swap! values-atom assoc :chart_include true)))))
    (fn []
      [:div
       [:form.c-form--edit.c-form--edit--left {:on-submit (util/handler submit)}
        [:h4.u-margin-bottom--small
         (if is-add "Add new collection subtype" (str "Edit " (:name original-values)))]
        [:dl
         [:dt "Name:"]
         [:dd.c-form--input-wide [:input {:value (:name @values-atom)
                                          :on-change (swap-from-event values-atom update :name #(not-empty %2))}]
          [:span.error (:name @errors)]]
         [:dt "Template:"]
         [:dd
          [:div
           [:> Select
            (merge
             {:options     (template-choices @templates)
              :placeholder "Choose"
              :value       (filter (fn [template] (= (:ref @values-atom) (:value template)))
                                   (template-choices @templates))
              :isClearable true
              :on-change   (fn [e]
                             (let [value (-> (js->clj e :keywordize-keys true) :value)]
                               (swap! values-atom assoc :ref value)))}
             (:primary react-select-styles))]]
          [:span.error (:ref @errors)]]
         (when (some-> @values-atom :ref (@ref-template-map) :cta)
           [:div
            [:dt]
            [:dd [:label [:input (set-checked (:cta_missing_warning @values-atom)
                                              {:on-click (fn [ev]
                                                           (let [selected (-> ev .-target .-checked)]
                                                             (swap! values-atom assoc :cta_missing_warning selected)))})]
                  "Display a warning message on collection details panels when Corporate Transparency Act (CTA) or other regulatory requirements are missing or blank"]]])
         [:dt "Regulatory Review Prompt (RRP):"]
         [:dd [:label [:input (set-checked (:regulatory_oversight @values-atom)
                                           {:on-click (fn [ev]
                                                        (let [selected (-> ev .-target .-checked)]
                                                          (swap! values-atom assoc :regulatory_oversight selected)))})]
               "This feature prompts Admins to assess whether changes made to entity information requires notification or regulatory updates, ensuring adherence to Corporate Transparency Act requirements and other relevant laws."]
          [:span.error (:regulatory-oversight @errors "")]]

         (when (or
                (and (nil? family-id) (is-user-license-admin))
                (collection-model/has-collection-chart-enabled family-id))
           [:<>
            [:dt "Charts:"]
            [:dd [:label [:input (set-checked (:chart_subject @values-atom)
                                              {:on-click (fn [ev] (swap! values-atom assoc :chart_subject (checked? ev)))})]
                  "Can be a chart subject"]
             [:span.error (:regulatory-oversight @errors "")]]
            [:dd [:label [:input (set-checked (:chart_include @values-atom)
                                              (merge {:on-click (fn [ev]
                                                                  (swap! values-atom assoc :chart_include (checked? ev)))}
                                                     (when (:chart_subject @values-atom) {:disabled :disabled})))]
                  "Can appear in a chart"]
             [:span.error (:regulatory-oversight @errors "")]]])]

        [:footer.o-space-between.u-margin-top
         [:div.o-margin-elements--xs
          (when cancel-cb [:button {:on-click cancel-cb} "Cancel"])
          [:button
           {:on-click (util/handler (fn []
                                      (when (js/confirm "Are you sure you want to delete this collection subtype?")
                                        (->> (if (is-user-license-admin)
                                               (model/license-admin-collection-type-delete (:id original-values))
                                               (model/group-admin-collection-type-delete family-id (:id original-values)))
                                             (p/map (fn [_]
                                                      (set-flash :success "Collection subtype deleted")
                                                      (some-> success-cb (apply []))))
                                             (p/error (fn [err]
                                                        (if (= 405 (:status err))
                                                          (set-flash :error "Cannot delete collection subtype, it is used by some of the collections.")
                                                          (throw err))))
                                             (process-error)))))} "Delete"]]
         [:button (when-not (changed) {:disabled :disabled}) "Save"]]]])))

(def $ js/$)

(defn asset-type-list [options group-id]
  (let [group (:selected-group-atom options)
        group-obj (clojure.core/atom nil)
        asset-types (atom nil)
        asset-type-map (clojure.core/atom nil)
        selected-asset-type-id (atom nil)
        selected-asset-type-index (atom nil)
        selected-name #(get-in @asset-type-map [@selected-asset-type-id :name])
        items-elem (clojure.core/atom nil)

        add-new (atom false)
        aname (atom nil)
        sort-count (clojure.core/atom 0)

        load-asset-types (fn [_ group-id]
                           (->> (if (is-user-license-admin)
                                  (model/license-admin-asset-types)
                                  (model/group-admin-asset-types group-id))
                                (p/map (fn [%]
                                         (reset! state/recent-parent-children {})
                                         (reset! selected-asset-type-id nil)
                                         (reset! aname (selected-name))
                                         (reset! asset-types %)
                                         (reset! asset-type-map (into {} (mapv (fn [at] [(:id at) at]) %)))))
                                (process-error)))]
    (when (is-user-license-admin)
      (load-asset-types nil nil))
    (reagent/create-class
     {:component-did-update (fn []
                              (when @items-elem
                                (.sortable ($ @items-elem)
                                           #js {:start (fn [_ ui]
                                                         (aset ui "item" "startIndex" (-> ui .-item .index)))
                                                :cancel ".is-edited"
                                                :update (fn [_ ui]
                                                          (let [before-index (-> ui .-item .-startIndex)
                                                                after-index (-> ui .-item .index)
                                                                asset-type (nth @asset-types before-index)]
                                                            (swap! asset-types (fn [ats] (vec-insert (vec-remove ats before-index) after-index (nth ats before-index))))
                                                            (swap! sort-count inc)
                                                            (let [before-id (:id (nth @asset-types (inc after-index) nil))]
                                                              (->> ((if (is-user-license-admin)
                                                                      model/license-admin-asset-type-update
                                                                      (partial model/group-admin-asset-type-update @group))
                                                                    (:id asset-type)
                                                                    {:name (:name asset-type)
                                                                     :set_order true
                                                                     :before_asset_type_id before-id})
                                                                   (p/map #(load-asset-types nil @group))
                                                                   (process-error)))))})))
      :reagent-render (fn []
                        [:section
                         (when-not (is-user-license-admin)
                           [:div.filter.user-filter
                            [:div.filter-items
                             [list-options [group-chooser {:group-changed-cb load-asset-types
                                                           :group-atom group
                                                           :admin-only true
                                                           :group-obj-atom group-obj} group-id]]]])
                         (if (seq @asset-types)
                           [:div.asset-types
                            (when (is-user-group-admin @group)
                              [:h2.o-media "Types for " (:name @group-obj)])
                            [:table.list.t-table-redesign
                             [:tbody.items {:ref #(reset! items-elem %)}
                              (doall
                               (map-indexed
                                (fn [index asset-type]
                                  [:tr {:key (str (:id asset-type) "-" @sort-count)}
                                   [:td (when (= @selected-asset-type-id  (:id asset-type)) {:class "is-edited"})
                                    [:h3.u-cursor {:on-click (util/handler (fn []
                                                                             (reset! selected-asset-type-id (:id asset-type))
                                                                             (reset! selected-asset-type-index index)))} (:name asset-type)]

                                    (when (= @selected-asset-type-id  (:id asset-type))
                                      (reset! add-new false)
                                      [:div {:key @selected-asset-type-id}
                                       [asset-type-form
                                        {:success-cb #(load-asset-types nil @group)
                                         :cancel-cb #(reset! selected-asset-type-id nil)
                                         :before-asset-type-id (:id (nth @asset-types (inc @selected-asset-type-index) nil))}
                                        @group (atom (@asset-type-map @selected-asset-type-id))]])]]) @asset-types))]]

                            [:div.o-media--bottom-shadow
                             (when @add-new [asset-type-form {:cancel-cb (util/handler #(reset! add-new false))
                                                              :success-cb #(load-asset-types nil @group)
                                                              :is-add true} @group (atom {:name nil})])]]

                           [:div.o-media--bottom-shadow "No collection types. Use Add button to add the first type."])
                         [:div.o-media--bottom-shadow [:button {:on-click (util/handler (fn []
                                                                                          (reset! selected-asset-type-id nil)
                                                                                          (reset! add-new true)))} "Add new"]]
                         (when @selected-asset-type-id
                           [:section
                            [:h2.o-media "Subtypes for " (selected-name)]
                            [collection-type-list options group selected-asset-type-id]])])})))

(defn collection-type-list [_ group-id-atom asset-type-id-atom]
  (let [collection-types (atom nil)
        collection-type-map (clojure.core/atom nil)
        selected-collection-type-id (atom nil)
        selected-collection-type-index (atom nil)
        selected-name #(get-in @collection-type-map [@selected-collection-type-id :name])
        items-elem (clojure.core/atom nil)

        add-new (atom false)
        aname (atom nil)
        sort-count (clojure.core/atom 0)

        load-collection-types (fn []
                                (->> (if (is-user-license-admin)
                                       (model/license-admin-collection-types @asset-type-id-atom)
                                       (model/group-admin-collection-types @group-id-atom @asset-type-id-atom))
                                     (p/map (fn [%]
                                              (reset! state/recent-parent-children {})
                                              (reset! selected-collection-type-id nil)
                                              (reset! aname (selected-name))
                                              (reset! collection-types %)
                                              (reset! collection-type-map (into {} (mapv (fn [at] [(:id at) at]) %)))))
                                     (process-error)))]
    (add-watch asset-type-id-atom :load-collection-types-on-asset-type-change
               (fn [& _]
                 (if @asset-type-id-atom
                   (load-collection-types)
                   (reset! collection-types nil))))
    (when @asset-type-id-atom
      (load-collection-types))
    (reagent/create-class
     {:component-did-update
      (fn [_ _ _ _]
        (when @items-elem
          (.sortable ($ @items-elem)
                     #js {:start (fn [_ ui]
                                   (aset ui "item" "startIndex" (-> ui .-item .index)))
                          :cancel ".is-edited"
                          :update (fn [_ ui]
                                    (let [before-index (-> ui .-item .-startIndex)
                                          after-index (-> ui .-item .index)
                                          collection-type (nth @collection-types before-index)]
                                      (swap! collection-types (fn [ats] (vec-insert (vec-remove ats before-index) after-index (nth ats before-index))))
                                      (swap! sort-count inc)
                                      (let [before-id (:id (nth @collection-types (inc after-index) nil))]
                                        (->> ((if (is-user-license-admin)
                                                model/license-admin-collection-type-update
                                                (partial model/group-admin-collection-type-update @group-id-atom))
                                              (:id collection-type)
                                              {:name (:name collection-type)
                                               :set_order true
                                               :before_collection_type_id before-id
                                               :ref (:ref collection-type)})
                                             (p/map #(load-collection-types))
                                             (process-error)))))})))
      :reagent-render
      (fn [_ group-id-atom asset-type-id-atom]
        (when @asset-type-id-atom
          [:section
           [:article
            (if (seq @collection-types)
              [:table.t-table-redesign
               [:tbody {:ref #(reset! items-elem %)}
                (doall
                 (map-indexed
                  (fn [index collection-type]
                    [:tr {:key (str (:id collection-type) "-" @sort-count)}
                     [:td (when (= @selected-collection-type-id  (:id collection-type)) {:class "is-edited"})
                      [:h3.u-cursor {:href "#"
                                     :on-click (util/handler (fn []
                                                               (reset! selected-collection-type-id (:id collection-type))
                                                               (reset! selected-collection-type-index index)))} (:name collection-type)]

                      (when (= @selected-collection-type-id (:id collection-type))
                        (reset! add-new false)
                        [:div.o-media--small {:key @selected-collection-type-id} [collection-type-form {:success-cb load-collection-types
                                                                                                        :cancel-cb (util/handler #(reset! selected-collection-type-id nil))
                                                                                                        :before-collection-type-id (:id (nth @collection-types (inc @selected-collection-type-index) nil))}
                                                                                  @group-id-atom (atom (@collection-type-map @selected-collection-type-id))]])]]) @collection-types))]]
              [:div.o-media "No collection subtypes defined."])
            [:div.o-media--bottom-shadow
             (when @add-new
               [collection-type-form {:cancel-cb (util/handler #(reset! add-new false))
                                      :success-cb load-collection-types
                                      :is-add true} @group-id-atom (atom {:name nil
                                                                          :asset_type_id @asset-type-id-atom})])]]
           [:footer.o-media--bottom-shadow
            [:button {:on-click (util/handler (fn []
                                                (reset! selected-collection-type-id nil)
                                                (reset! add-new true)))} "Add new"]]]))})))

(defn disposition-controls [options]
  [:span
   (let [selected-family-atom (:selected-family-atom options)]
     (when-let [family-id (and selected-family-atom @selected-family-atom)]
       [:div.tab-controls.o-margin-elements--medium
        [:button {:on-click (util/handler #(.open js/window (str js/DAS_URL) "_blank"))} "DAS"]
        [:button {:on-click (fn [_] (util/set-location (str "#/disposition/add?family_id=" family-id)))} "Add"]
        [:button {:on-click (fn [_] (util/set-location (str "#/automation/disposition/list/family/" family-id "/import")))} "Import"]]))])

(defn admin-tab-bar [options tab-info-list tab-content active-tab]
  [:div.u-shadow--bottom
   [common/header
    :supertitle [:span
                 [:img {:src "/static/img/icons/settings-blue.svg"}]
                 [:a {:href (if (auth-model/is-user-any-family-admin)
                              "#/admin/user/list"
                              (path-for :settings-templategroup-list))} "Settings"]
                 (:header-additional-content options)]]
   (into [tabs/tabs]
         (for [[title tab-id is-active condition controls] (filterv identity tab-info-list)]
           (when condition
             ((if is-active tabs/tab tabs/inactive-tab)
              [:span title]
              tab-id
              (clojure.core/atom active-tab)
              (if (= active-tab (:id tab-id))
                [tab-content]
                [:div])
              (when controls
                [controls])))))])


(defn admin-tabs [options tab-content active-tab]
  (fn []
    (let [tab-list [["Users"
                     {:url "#/admin/user/list" :id :users}
                     true
                     (is-user-admin)
                     (partial user-list-controls)]
                    ["Admin Nominations"
                     {:url "#/admin/nomination/list" :id :nominations}
                     true
                     (is-user-license-admin)
                     nil]
                    ["Contacts"
                     {:url "#/admin/contact/list" :id :contacts}
                     true
                     (is-user-any-group-admin)
                     (partial contact-list-controls options)]
                    ["Invitations" {:url "#/admin/invitation/list" :id :invitations} true (is-user-any-group-admin) nil]
                    ["Templates"
                     {:url "#/task/templategroup/list"
                      :id :compliance-templates}
                     true
                     (or (is-user-license-admin) (model/can-view-any-family-template-list))
                     (when (is-user-admin) (partial templategroup-list-controls options))]
                    ["Categories"
                     {:url "#/admin/category/list" :id :categories}
                     true
                     (is-user-admin)
                     (partial category-list-controls options)]
                    ["Family"
                     {:url "#/admin/group/list" :id :groups} true (is-user-license-admin)
                     (when-not (:hide-controls options)
                       (fn [] [:div
                               [:span [:button {:on-click (fn [_] (util/set-location "#/admin/group/add"))} "Add Family"]] " "
                               [:span [:button {:on-click (util/handler
                                                           (fn []
                                                             (when (js/confirm "Would you like to generate the family object count and storage usage report?")
                                                               (->>
                                                                (api/ajaxp "/family/usage/" {:method :post})
                                                                (p/map (fn [_]
                                                                         (set-flash :success "You will be notified by email when the report is ready.")))
                                                                (process-error)))))} "Usage report"]]]))]
                    ["Collection types"
                     {:url "#/admin/assettype/list" :id :asset-types}
                     true
                     (is-user-admin)
                     nil]
                    (when (enabled "demo")
                      ["Demo" {:url (path-for :settings-demo-list) :id :demo} true (is-user-admin)])
                    ;; ["Groups" {:url "#/admin/group/list" :id :groups} true true]
                    ["Bulk operations" {:url "#/bulkoperations/list" :id :bulk-edits} true (not (is-user-license-admin))  nil]
                    ["Automation"
                     {:url (path-for :settings-disposition-list) :id :disposition-list}
                     true
                     (and
                      (is-user-any-group-admin)
                      (some collection-model/has-document-automation-enabled (keys @state/group-permissions)))
                     nil]
                    ["Metrics"
                     {:url "#/admin/metrics" :id :metrics}
                     true
                     (and 
                      (is-user-admin) 
                      (collection-model/has-aark-enabled-in-any-family))
                     nil]
                    [[:span.cs-brand "AARK"]
                     {:url (path-for :settings-ai) :id :settings-ai}
                     true
                     (is-user-license-admin)
                     nil]
                    ["Profile" {:url "#/profile" :id :profile} true true]
                    ;; ["Saml" {:url "#/admin/saml" :id :saml} true true]
                    (when false ;staticparam/license-management-enabled
                      ["App Licenses" {:url "#/admin/applicenses" :id :applicenses} true (is-user-license-admin)])
                    ["Subscribers" {:url "#/admin/subscribers/list" :id :subscribers-list} true (is-user-license-admin)
                     (partial subscribers-controls)]
                    ["Report"
                     {:url (path-for :settings-dropbox-sign-report) :id :dropbox-sign-report}
                     true
                     (is-user-license-admin)
                     nil]]]
      [admin-tab-bar options tab-list tab-content active-tab])))

(defn transaction-controls [options]
  (let [show-back-button (:show-back-button options)
        refresh-atom (:refresh-atom options)
        controls (some-> (:controls-atom options) deref)]
    [:span
     (when show-back-button
       [:button {:on-click util/back} "Back"])
     (when controls controls)
     (when (and
            (not (and controls show-back-button))
            refresh-atom)
       [:button {:on-click (util/handler #(swap! refresh-atom not))} "Refresh"])]))

(defn label-controls [options]
  (let [add (atom false)
        refresh-atom (:refresh-atom options)
        errors-atom (atom nil)
        name (atom "")]
    (fn []
      [:span
       (let [selected-family-atom (:selected-family-atom options)]
         (when (and selected-family-atom @selected-family-atom)
           [:div.tab-controls.o-margin-elements--medium
            (if (or @add (seq @errors-atom))
              [label-form {:error-left true
                           :on-cancel (fn []
                                        (reset! add false)
                                        (reset! errors-atom {})
                                        (reset! name nil))

                           :on-save (fn []
                                      (controller/dispatch :label-list :add {:family-id @selected-family-atom
                                                                             :name @name
                                                                             :object-type (:object-type options)
                                                                             :errors-atom errors-atom
                                                                             :on-success (fn [_]
                                                                                           (reset! add false)
                                                                                           (reset! name nil)
                                                                                           (reset! errors-atom nil)
                                                                                           (swap! refresh-atom not))}))}
               name errors-atom]

              [:button {:on-click (util/handler #(reset! add true))} "Add Label"])]))])))

(defn build-automation-filter-query [path options]
  (let [filter-params (update-vals
                       (select-keys options [:selected-family-atom :order :uid :collection_name :label_ids])
                       deref)
        filter-query (util/make-params
                      (util/remove-nil-values
                       {:family_id       (:selected-family-atom filter-params)
                        :order           (:order filter-params)
                        :uid             (:uid filter-params)
                        :collection_name (:collection_name filter-params)
                        :label_id        (:label_ids filter-params)}))]
    (str path (when filter-query (str "?" filter-query)))))



(defn automation-tabs [options tab-content active-tab]
  (fn []
    (let [tab-list [["Dispositions"
                     {:url-fn (fn [] (build-automation-filter-query (path-for :settings-disposition-list) options)) :id :disposition-list}
                     true
                     (is-user-any-group-admin)
                     (partial disposition-controls options)]
                    ["Collections"
                     {:url-fn (fn []
                                (build-automation-filter-query (path-for :settings-automation-collection-list) options))
                      :id  :automation-collection-list}
                     true
                     (is-user-any-group-admin)
                     nil]
                    ["Labels"
                     {:url (path-for :settings-label-list) :id :label-list}
                     true
                     (is-user-any-group-admin)
                     (partial label-controls options)]
                    ["Transactions"
                     {:url (path-for :settings-transaction-list) :id :transaction-list}
                     true
                     (is-user-any-group-admin)
                     (partial transaction-controls options)]]]
      [admin-tab-bar (assoc options
                            :header-additional-content
                            [:span " / " [:a {:href (path-for :settings-disposition-list)} "Automation"]])
       tab-list tab-content active-tab])))

(defn ai-settings []
  (with-let [settings (subscribe :global-setting)
             selected-ref (atom nil)
             ref-setting-map (atom nil)
             _ (controller/dispatch :global-setting :list {:stype "ai"})
             _ (add-watch settings :select-initial-setting
                          (fn [_ _ _ settings]
                            (reset! selected-ref (:key (first settings)))
                            (reset! ref-setting-map (util/associate-by :key settings))))]
    [:div.o-media
     [:select {:on-change (reset-from-event selected-ref)}
      (doall
       (for [setting @settings]
         [:option {:value (:key setting)}
          (str (:name setting) " (" (:key setting) ")")]))]
     (when @selected-ref
       [:div
        [:form {:on-submit (util/handler
                            (fn []
                              (controller/dispatch :global-setting :update {:key @selected-ref
                                                                            :stype "ai"
                                                                            :value (get-in @ref-setting-map [@selected-ref :value])})))}
         [:textarea.u-margin-top {:rows 20
                                  :autocorrect :off
                                  :spellcheck :false
                                  :value (:value (@ref-setting-map @selected-ref))
                                  :on-change (fn [event]
                                               (swap! ref-setting-map
                                                      assoc-in [@selected-ref :value] (util/event-value event)))}]
         [:button {:type :submit}
          "Save"]]])]))

(defn- validate-lmp-version [content]
  (let [lines (clojure.string/split-lines content)] 
    (when-not (re-matches #"### LMP Version \d+\.\d+(\.\d+)?" (or (get lines 1) ""))
      "Second line must match format: ### LMP Version X.Y or X.Y.Z")))

(defn ai-lmp []
  (with-let [settings (subscribe :global-setting)
             selected-ref (atom nil)
             ref-setting-map (atom nil)
             lmp-error (atom nil)
             _ (controller/dispatch :global-setting :list {:stype "ai_lmp"})
             _ (add-watch settings :select-initial-setting
                          (fn [_ _ _ settings]
                            (reset! selected-ref (:key (first settings)))
                            (reset! ref-setting-map (util/associate-by :key settings))))]
    [:div.o-media
     [:select {:on-change (fn [e]
                            (reset! lmp-error nil)
                            ((reset-from-event selected-ref) e))}
      (doall
       (for [setting @settings]
         [:option {:value (:key setting)}
          (str (:name setting) " (" (:key setting) ")")]))]
     (when @selected-ref
       [:div
        [:form {:on-submit (util/handler
                            (fn []
                              (let [value (get-in @ref-setting-map [@selected-ref :value])
                                    err   (validate-lmp-version value)]
                                (if err
                                  (reset! lmp-error err)
                                  (do
                                    (reset! lmp-error nil)
                                    (controller/dispatch :global-setting :update {:key @selected-ref
                                                                                  :stype "ai_lmp"
                                                                                  :value value}))))))}
         [:textarea.u-margin-top {:rows 20
                                  :autocorrect :off
                                  :spellcheck :false
                                  :value (:value (@ref-setting-map @selected-ref))
                                  :on-change (fn [event]
                                               (swap! ref-setting-map
                                                      assoc-in [@selected-ref :value] (util/event-value event)))}]
         [:div
          (when @lmp-error
            [:div.error @lmp-error])
          [:button {:type :submit}
           "Save"]]]])]))

(defn ai-skill []
  (with-let [settings (subscribe :global-setting)
             selected-ref (atom nil)
             ref-setting-map (atom nil)
             _ (controller/dispatch :global-setting :list {:stype "ai_skill"})
             _ (add-watch settings :select-initial-setting
                          (fn [_ _ _ settings]
                            (reset! selected-ref (:key (first settings)))
                            (reset! ref-setting-map (util/associate-by :key settings))))]
    [:div.o-media
     [:select {:on-change (reset-from-event selected-ref)}
      (doall
       (for [setting @settings]
         [:option {:value (:key setting)}
          (str (:name setting) " (" (:key setting) ")")]))]
     (when @selected-ref
       [:div
        [:form {:on-submit (util/handler
                            (fn []
                              (controller/dispatch :global-setting :update {:key @selected-ref
                                                                            :stype "ai_skill"
                                                                            :value (get-in @ref-setting-map [@selected-ref :value])})))}
         [:textarea.u-margin-top {:rows 20
                                  :autocorrect :off
                                  :spellcheck :false
                                  :value (:value (@ref-setting-map @selected-ref))
                                  :on-change (fn [event]
                                               (swap! ref-setting-map
                                                      assoc-in [@selected-ref :value] (util/event-value event)))}]
         [:button {:type :submit}
          "Save"]]])]))

(defn- generate-token
  "Generate a cryptographically random 48-character hex token."
  []
  (let [buf (js/Uint8Array. 24)]
    (.getRandomValues js/crypto buf)
    (.join (.from js/Array buf (fn [b] (.padStart (.toString b 16) 2 "0"))) "")))

(defn ai-billing []
  (with-let [settings (subscribe :global-setting)
             token-value (atom "")
             show-token (atom false)
             copied (atom false)
             docs-user (atom "")
             docs-pass (atom "")
             show-docs-pass (atom false)
             _ (controller/dispatch :global-setting :list {:stype "aark_billing"})
             _ (add-watch settings :init-billing-token
                          (fn [_ _ _ stgs]
                            (when-let [s (first (filter #(= "aark_api_token" (:key %)) stgs))]
                              (reset! token-value (:value s)))
                            (when-let [s (first (filter #(= "aark_docs_user" (:key %)) stgs))]
                              (reset! docs-user (:value s)))
                            (when-let [s (first (filter #(= "aark_docs_password" (:key %)) stgs))]
                              (reset! docs-pass (:value s)))))]
    [:div.o-media
     [:h3 "AARK Billing API Token"]
     [:p "This token authenticates the Hopper billing gateway (M2M). "
      "Share it securely with the gateway operator. Generating a new token invalidates the previous one."]
     [:div.u-margin-top
      [:label {:style {:font-weight :bold}} "Current Token"]
      [:div {:style {:display :flex :align-items :center :gap "8px" :margin-top "4px"}}
       [:input.text-field {:type (if @show-token "text" "password")
                           :read-only true
                           :value @token-value
                           :placeholder "(no token configured)"
                           :style {:width "420px" :font-family "monospace"}}]
       [:button {:type :button
                 :on-click (fn [] (swap! show-token not))}
        (if @show-token "Hide" "Show")]
       [:button {:type :button
                 :on-click (fn []
                             (when (seq @token-value)
                               (-> (.writeText js/navigator.clipboard @token-value)
                                   (.then (fn []
                                            (reset! copied true)
                                            (js/setTimeout #(reset! copied false) 2000))))))}
        (if @copied "Copied!" "Copy")]]]
     [:div.u-margin-top {:style {:display :flex :gap "8px"}}
      [:button {:type :button
                :on-click (fn []
                            (when (or (blank? @token-value)
                                      (js/confirm "Generate a new token? The current token will stop working once you save."))
                              (reset! token-value (generate-token))))}
       "Generate New Token"]
      [:button {:type :button
                :on-click (fn []
                            (controller/dispatch :global-setting :update {:key "aark_api_token"
                                                                          :stype "aark_billing"
                                                                          :value @token-value})
                            (set-flash :success "AARK billing API token saved."))}
       "Save"]]
     [:h3 {:style {:margin-top "2rem"}} "API Docs Credentials"]
     [:p "Basic auth credentials for the " [:code "/integration/aark/docs"] " page. "
      "Leave blank to keep the docs page open."]
     [:div.u-margin-top
      [:label {:style {:font-weight :bold}} "Username"]
      [:div {:style {:margin-top "4px"}}
       [:input.text-field {:type "text"
                           :value @docs-user
                           :placeholder "(no username configured)"
                           :style {:width "280px"}
                           :on-change #(reset! docs-user (util/event-value %))}]]]
     [:div.u-margin-top
      [:label {:style {:font-weight :bold}} "Password"]
      [:div {:style {:display :flex :align-items :center :gap "8px" :margin-top "4px"}}
       [:input.text-field {:type (if @show-docs-pass "text" "password")
                           :value @docs-pass
                           :placeholder "(no password configured)"
                           :style {:width "280px"}
                           :on-change #(reset! docs-pass (util/event-value %))}]
       [:button {:type :button
                 :on-click (fn [] (swap! show-docs-pass not))}
        (if @show-docs-pass "Hide" "Show")]]]
     [:div.u-margin-top {:style {:display :flex :gap "8px"}}
      [:button {:type :button
                :on-click (fn []
                            (controller/dispatch :global-setting :update {:key "aark_docs_user"
                                                                          :stype "aark_billing"
                                                                          :value @docs-user})
                            (controller/dispatch :global-setting :update {:key "aark_docs_password"
                                                                          :stype "aark_billing"
                                                                          :value @docs-pass})
                            (set-flash :success "API docs credentials saved."))}
       "Save Credentials"]]]))

(defn- ai-usage-navigate!
  "Navigate to ai-usage with the given params, omitting defaults."
  [params]
  (let [query-string (util/make-params
                      (cond-> {}
                        (:subscriber-id params) (assoc :subscriber_id (:subscriber-id params))
                        (:family-id params) (assoc :family_id (:family-id params))
                        (:year params) (assoc :year (:year params))
                        (:month params) (assoc :month (:month params))
                        (not (:non-zero params)) (assoc :non_zero "false")
                        (:family-breakdown params) (assoc :family_breakdown "true")
                        (and (:order params) (not= "subscriber_name" (:order params))) (assoc :order (:order params))
                        (and (:page params) (> (:page params) 1)) (assoc :page (:page params))))]
    (util/set-location (str (path-for :settings-ai-usage)
                            (when (seq query-string) (str "?" query-string))))))

(defn ai-usage [{:keys [subscriber-id family-id year month non-zero family-breakdown order page]
                 :or {non-zero true family-breakdown false order "subscriber_name" page 1}
                 :as options}]
  (let [report-data (subscribe :aark-usage-report)
        filter-options (subscribe :aark-usage-filters)
        month-names (into {} form/month-choices)
        family-filter-active (some? family-id)
        effective-breakdown (or family-breakdown family-filter-active)

        navigate-with (fn [overrides]
                        (ai-usage-navigate! (merge options overrides)))

        order-atom (atom order)
        _ (add-watch order-atom :order-navigate
            (fn [_ _ _ new-order] (navigate-with {:order new-order :page 1})))];;
    (controller/dispatch :aark-usage-filters :load
      {:subscriber-id subscriber-id :family-id family-id :year year :month month})
    (controller/dispatch :aark-usage-report :load
      {:subscriber-id subscriber-id :family-id family-id :year year :month month
       :non-zero non-zero :family-breakdown effective-breakdown :order order :page page})
    (fn []
      [:div
       [list-options
        [:span
         [:ul [:li "Subscriber"]]
         [:select {:value (or subscriber-id "all")
                   :on-change (fn [ev]
                                (let [v (util/to-value (-> ev .-target .-value))]
                                  (navigate-with {:subscriber-id (when (not= v "all") v)
                                                  :page 1})))}
          [:option {:value "all"} "All Subscribers"]
          (doall
           (for [{:keys [id name]} (:subscribers @filter-options)]
             [:option {:value (str id) :key id} name]))]]
        (when effective-breakdown
          [:span
           [:ul [:li "Family"]]
           [:select {:value (or family-id "all")
                     :on-change (fn [ev]
                                  (let [v (util/to-value (-> ev .-target .-value))]
                                    (navigate-with {:family-id (when (not= v "all") v)
                                                    :page 1})))}
            [:option {:value "all"} "All Families"]
            (doall
             (for [{:keys [id name]} (:families @filter-options)]
               [:option {:value (str id) :key id} name]))]])
        [:span
         [:ul [:li "Year"]]
         [:select {:value (or year "all")
                   :on-change (fn [ev]
                                (let [v (util/to-value (-> ev .-target .-value))]
                                  (navigate-with {:year (when (not= v "all") v)
                                                  :month nil
                                                  :page 1})))}
          [:option {:value "all"} "All Years"]
          (doall
           (for [y (:years @filter-options)]
             [:option {:value (str y) :key y} y]))]]
        [:span
         [:ul [:li "Month"]]
         [:select {:value (or month "all")
                   :disabled (nil? year)
                   :on-change (fn [ev]
                                (let [v (util/to-value (-> ev .-target .-value))]
                                  (navigate-with {:month (when (not= v "all") v)
                                                  :page 1})))}
          [:option {:value "all"} "All Months"]
          (doall
           (for [m (:months @filter-options)]
             [:option {:value (str m) :key m} (month-names m)]))]]
        [:label
         [:input (set-checked non-zero {:on-change #(navigate-with {:non-zero (checked? %)
                                                                    :page 1})})]
         " Non-zero only"]
        [:label
         [:input (set-checked effective-breakdown
                              (merge {:on-change #(navigate-with {:family-breakdown (checked? %)
                                                                  :page 1})}
                                     (when family-filter-active {:disabled :disabled})))]
         " Family breakdown"]
        [common/download-button {:ajax-url "/licenseadmin/aark-usage/"
                                 :ajax-options {:params {:subscriber_id subscriber-id
                                                         :family_id family-id
                                                         :year year
                                                         :month month
                                                         :non_zero non-zero
                                                         :family_breakdown effective-breakdown
                                                         :csv true}
                                                :response-format (ajax.core/ring-response-format {:format (text-response-format)})}}
         "CSV"]]
       (if (seq (:results @report-data))
         (let [meta-cols (+ 2 (if effective-breakdown 1 0))
               col-count (+ meta-cols 10)]
           [:div.c-aark-usage-report
            [:table.t-table-redesign
             [:thead
              [:tr.c-aark-usage-report__group-header
               [:th {:col-span meta-cols}]
               [:th.u-text-align--center.c-aark-usage-report__sep {:col-span 2} "Total"]
               [:th.u-text-align--center.c-aark-usage-report__sep {:col-span 4} "Client"]
               [:th.u-text-align--center.c-aark-usage-report__sep {:col-span 4} "iPaladin"]]
              [:tr
               [:th (orderer order-atom "Subscriber" "subscriber_name")]
               (when effective-breakdown
                 [:th (orderer order-atom "Family" "family_name")])
               [:th "Period"]
               ;; Total
               [:th.u-text-align--right.c-aark-usage-report__sep {:title "Total Input Tokens"} (orderer order-atom "Input" "total_input_tokens")]
               [:th.u-text-align--right {:title "Total Output Tokens"} (orderer order-atom "Output" "total_output_tokens")]
               ;; Client
               [:th.u-text-align--right.c-aark-usage-report__sep {:title "Client Input Tokens"} (orderer order-atom "Input" "client_input_tokens")]
               [:th.u-text-align--right {:title "Client Output Tokens"} (orderer order-atom "Output" "client_output_tokens")]
               [:th.u-text-align--right {:title "Client Cache Read Tokens"} (orderer order-atom "Cache Read" "client_cache_read")]
               [:th.u-text-align--right {:title "Client Cache Write Tokens"} (orderer order-atom "Cache Write" "client_cache_write")]
               ;; iPaladin
               [:th.u-text-align--right.c-aark-usage-report__sep {:title "iPaladin Input Tokens"} (orderer order-atom "Input" "ipaladin_input_tokens")]
               [:th.u-text-align--right {:title "iPaladin Output Tokens"} (orderer order-atom "Output" "ipaladin_output_tokens")]
               [:th.u-text-align--right {:title "iPaladin Cache Read Tokens"} (orderer order-atom "Cache Read" "ipaladin_cache_read")]
               [:th.u-text-align--right {:title "iPaladin Cache Write Tokens"} (orderer order-atom "Cache Write" "ipaladin_cache_write")]]]
             [:tbody
              (doall
               (for [row (:results @report-data)]
                 [:tr {:key (str (:subscription_id row) "-"
                                 (:family_id row) "-"
                                 (:year row) "-" (:month row))}
                  [:td [:a {:href (path-for :settings-subscriber-details :id (:subscription_id row))} (:subscriber_name row)]]
                  (when effective-breakdown
                    [:td (if (:family_id row)
                           [:a {:href (path-for :settings-family-edit :id (:family_id row))} (:family_name row)]
                           (or (:family_name row) ""))])
                  [:td (str (month-names (:month row)) " " (:year row))]
                  ;; Total
                  [:td.u-text-align--right.c-aark-usage-report__sep (:total_input_tokens row)]
                  [:td.u-text-align--right (:total_output_tokens row)]
                  ;; Client
                  [:td.u-text-align--right.c-aark-usage-report__sep (:client_input_tokens row)]
                  [:td.u-text-align--right (:client_output_tokens row)]
                  [:td.u-text-align--right (:client_cache_read row)]
                  [:td.u-text-align--right (:client_cache_write row)]
                  ;; iPaladin
                  [:td.u-text-align--right.c-aark-usage-report__sep (:ipaladin_input_tokens row)]
                  [:td.u-text-align--right (:ipaladin_output_tokens row)]
                  [:td.u-text-align--right (:ipaladin_cache_read row)]
                  [:td.u-text-align--right (:ipaladin_cache_write row)]]))]
             [tfoot-paginator
              [paginator
               (map (fn [p]
                      {:number p
                       :on-click (util/handler #(navigate-with {:page p}))})
                    (:page_numbers @report-data))
               page
               (when (:has_previous @report-data) (util/handler #(navigate-with {:page (dec page)})))
               (when (:has_next @report-data) (util/handler #(navigate-with {:page (inc page)})))]
              col-count
              (-> (:page_numbers @report-data) count (> 1))]]])
         [:p.o-media "No usage data found."])])))

(def feedback-default-order "-created_at")

(defn- ai-feedback-navigate!
  "Navigate to ai-feedback with the given params, omitting defaults."
  [{:keys [subscriber-id family-id time-range order page]}]
  (let [query-string (util/make-params
                      (util/remove-nil-values
                       {:subscriber_id subscriber-id
                        :family_id family-id
                        :time_range time-range
                        :order (when (not= feedback-default-order order) order)
                        :page (when (and page (> page 1)) page)}))]
    (util/set-location (str (path-for :settings-ai-feedback)
                            (when (seq query-string) (str "?" query-string))))))

(defn- feedback-conversation-url [feedback-id]
  (str "/licenseadmin/aark-feedback/" feedback-id "/conversation/"))

(defn- ai-feedback-conversation
  "The conversation a rating included, cut off where it stood at the rating."
  [feedback-id]
  (with-let [conversations (atom nil)
             _ (->> (api/ajaxp (feedback-conversation-url feedback-id) {})
                    (p/map #(reset! conversations %))
                    (process-error))]
    (if @conversations
      [conversation-dumps @conversations]
      [:p "Loading conversation…"])))

(defn- message-excerpt
  "The start of the rated reply on one line."
  [content]
  (let [text (str/trim (str/replace (or content "") #"\s+" " "))]
    (if (> (count text) 120) (str (util/truncate text 120) "…") text)))

(defn- ai-feedback-preview
  "The rated reply rendered as in the chat; the whole conversation on demand."
  [feedback-id content]
  (with-let [full (atom false)]
    [:div
     [:div.c-aark-feedback-report__message [markdown-message nil content]]
     [:div.c-aark-feedback-report__links
      [:a {:href "#" :on-click (util/handler #(swap! full not))}
       (if @full "Hide full conversation" "Show full conversation")]
      " | "
      [dump-download (feedback-conversation-url feedback-id)]]
     (when @full [ai-feedback-conversation feedback-id])]))

(defn ai-feedback
  "License-admin table of AARK message ratings (#3029)."
  [{:keys [subscriber-id family-id time-range order page] :as options}]
  (let [report-data (subscribe :aark-feedback-report)
        filter-options (subscribe :aark-feedback-filters)
        reason-labels (into {} chat-model/feedback-reasons)
        expanded-id (atom nil)
        col-count 8
        toggle! (fn [id] (swap! expanded-id #(when (not= % id) id)))
        navigate-with (fn [overrides] (ai-feedback-navigate! (merge options overrides)))
        order-atom (atom order)
        _ (add-watch order-atom :order-navigate
                     (fn [_ _ _ new-order] (navigate-with {:order new-order :page 1})))
        filter-select (fn [label all-label value options-key param]
                        [:span
                         [:ul [:li label]]
                         [:select {:value (or value "all")
                                   :on-change (fn [ev]
                                                (let [v (util/to-value (-> ev .-target .-value))]
                                                  ;; The family list depends on the subscriber, so a new subscriber drops the family.
                                                  (navigate-with (cond-> {param (when (not= v "all") v) :page 1}
                                                                   (= param :subscriber-id) (assoc :family-id nil)))))}
                          [:option {:value "all"} all-label]
                          (doall
                           (for [{:keys [id name]} (options-key @filter-options)]
                             [:option {:value (str id) :key id} name]))]])]
    (controller/dispatch :aark-feedback-filters :load {:subscriber-id subscriber-id})
    (controller/dispatch :aark-feedback-report :load {:subscriber-id subscriber-id :family-id family-id
                                                      :time-range time-range :timezone (tz/get-user-timezone)
                                                      :order order :page page})
    (fn []
      [:div
       [list-options
        (filter-select "Subscriber" "All Subscribers" subscriber-id :subscribers :subscriber-id)
        (filter-select "Family" "All Families" family-id :families :family-id)]
       [:div.u-padding-bottom
        [:div.metrics-box.metrics-box--wide
         [:div.o-flex-align--space-between
          [:div
           [:h2.u-margin-bottom "Feedback"]
           [:h4.u-color--secondary (or (:count @report-data) 0) " ratings"]]
          [:div
           [:select {:value (or time-range "")
                     :on-change #(navigate-with {:time-range (not-empty (.. % -target -value)) :page 1})}
            [:option {:value ""} "All time"]
            (for [[value label] model/time-range-choices]
              ^{:key value} [:option {:value value} label])]]]
         (if (seq (:results @report-data))
           [:div.u-margin-top.c-aark-feedback-report
            [:table.c-metrics-table
             [:thead
              [:tr
               [:th (orderer order-atom "Date" "created_at")]
               [:th (orderer order-atom "Sender" "sender_name")]
               [:th (orderer order-atom "Family" "family_name")]
               [:th (orderer order-atom "Subscriber" "subscriber_name")]
               [:th "Message"]
               [:th (orderer order-atom "Feedback" "rating")]
               [:th "Reasons"]
               [:th "Details"]]]
             [:tbody
              (doall
               ;; Destructuring family_id/subscriber_id here would clash with the munged family-id/subscriber-id
               ;; locals and break the release build (duplicate JS parameter names).
               (for [{:keys [id rating reasons detail sender_name sender_email family_name subscriber_name
                             include_conversation message_content created_at] :as row} (:results @report-data)
                     :let [row-family-id (:family_id row)
                           row-subscriber-id (:subscriber_id row)]]
                 [:<> {:key id}
                  [:tr
                   [:td.c-aark-feedback-report__date
                    (-> created_at (util/parse-datetime) (tz/to-browser-time) (util/date-format-date-hour-minute))]
                   [:td sender_name [:br] [:small sender_email]]
                   [:td (if row-family-id
                          [:a {:href (path-for :settings-family-edit :id row-family-id)} family_name]
                          "—")]
                   [:td (if row-subscriber-id
                          [:a {:href (path-for :settings-subscriber-details :id row-subscriber-id)} subscriber_name]
                          "—")]
                   ;; The reply is sent only when the user included the conversation.
                   [:td
                    (if include_conversation
                      [:a {:href "#" :on-click (util/handler #(toggle! id))} (message-excerpt message_content)]
                      "Not included")]
                   [:td
                    (let [positive (= rating "positive")
                          label (if positive "Positive" "Negative")]
                      [:span.c-aark-feedback-report__rating {:role "img" :title label :aria-label label}
                       [(if positive icons/thumbs-up icons/thumbs-down) {:width 16 :height 16} false]])]
                   [:td (str/join ", " (map #(get reason-labels % %) reasons))]
                   [:td.c-aark-feedback-report__detail detail]]
                  (when (= @expanded-id id)
                    [:tr.c-aark-feedback-report__preview
                     [:td {:col-span col-count} [ai-feedback-preview id message_content]]])]))]
             [tfoot-paginator
              [paginator
               (map (fn [p] {:number p :on-click (util/handler #(navigate-with {:page p}))})
                    (:page_numbers @report-data))
               page
               (when (:has_previous @report-data) (util/handler #(navigate-with {:page (dec page)})))
               (when (:has_next @report-data) (util/handler #(navigate-with {:page (inc page)})))
               false
               {:prev-label (icons/chevron-left {:width 16 :height 16})
                :next-label (icons/chevron-right {:width 16 :height 16})}]
              col-count
              (-> (:page_numbers @report-data) count (> 1))]]]
           [:p.u-margin-top "No feedback found."])]]])))

(defn ai-debug []
  (with-let [settings         (subscribe :global-setting)
             error-msg        (atom nil)
             server-errs      (atom nil)
             dl-link-el       (atom nil)
             full-history     (atom false)
             force-anthropic         (atom false)
             force-ipaladin          (atom false)
             force-timeout           (atom false)
             force-unknown           (atom false)
             force-confirm           (atom false)
             force-anthropic-outage  (atom false)
             force-anthropic-partial (atom false)
             force-ipaladin-outage   (atom false)
             force-slow-response     (atom false)
             force-prompt-too-long   (atom false)
             *json-data              (atom nil)
             _                (controller/dispatch :global-setting :list {:stype "ai"})
             _                (add-watch settings :init-debug-switches
                                         (fn [_ _ _ stgs]
                                           (letfn [(val-of [k] (= "true" (:value (first (filter #(= k (:key %)) stgs)))))]
                                             (reset! force-anthropic         (val-of "debug_force_anthropic_error"))
                                             (reset! force-ipaladin          (val-of "debug_force_ipaladin_error"))
                                             (reset! force-timeout           (val-of "debug_force_timeout_error"))
                                             (reset! force-unknown           (val-of "debug_force_unknown_error"))
                                             (reset! force-confirm           (val-of "debug_force_confirm_failure"))
                                             (reset! force-anthropic-outage  (val-of "debug_force_anthropic_outage"))
                                             (reset! force-anthropic-partial (val-of "debug_force_anthropic_partial"))
                                             (reset! force-ipaladin-outage   (val-of "debug_force_ipaladin_outage"))
                                             (reset! force-slow-response     (val-of "debug_force_slow_response"))
                                             (reset! force-prompt-too-long   (val-of "debug_force_prompt_too_long")))))
             _                (add-watch server-errs :token-err
                                         (fn [_ _ _ errs]
                                           (when-let [msg (:token errs)]
                                             (reset! error-msg msg))))]
    (letfn [(save! [key value]
              (controller/dispatch :global-setting :update {:stype "ai" :key key :value (str value)}))
            (set-status-switch! [target-atom key checked?]
              (reset! target-atom checked?)
              (save! key checked?)
              (when checked?
                (doseq [[a k] [[force-anthropic-outage  "debug_force_anthropic_outage"]
                               [force-anthropic-partial "debug_force_anthropic_partial"]
                               [force-ipaladin-outage   "debug_force_ipaladin_outage"]]
                        :when (not= a target-atom)]
                  (reset! a false)
                  (save! k false))))
            (set-llm-switch! [target-atom key checked?]
              (reset! target-atom checked?)
              (save! key checked?)
              (when checked?
                (doseq [[a k] [[force-anthropic      "debug_force_anthropic_error"]
                               [force-ipaladin        "debug_force_ipaladin_error"]
                               [force-timeout         "debug_force_timeout_error"]
                               [force-unknown         "debug_force_unknown_error"]
                               [force-slow-response   "debug_force_slow_response"]
                               [force-prompt-too-long "debug_force_prompt_too_long"]]
                        :when (not= a target-atom)]
                  (reset! a false)
                  (save! k false))))]
      (fn []
        [:div.o-media
         (when (enabled "aark-error-simulation")
           [:<>
            [:h3 "Error Simulation"]
            [:p.u-margin-bottom "Force specific error conditions for all users. The LLM error switches are mutually exclusive — only one LLM error mode can be active at a time."]
            [:div {:style {:display :flex :flex-direction :column :gap "8px" :margin-bottom "1.5rem"}}
             [:label
              [:input {:type      :checkbox
                       :checked   @force-anthropic
                       :on-change #(set-llm-switch! force-anthropic "debug_force_anthropic_error" (-> % .-target .-checked))}]
              " Force Anthropic-side error (service_overloaded)"]
             [:label
              [:input {:type      :checkbox
                       :checked   @force-ipaladin
                       :on-change #(set-llm-switch! force-ipaladin "debug_force_ipaladin_error" (-> % .-target .-checked))}]
              " Force iPaladin-side error (ipaladin_error)"]
             [:label
              [:input {:type      :checkbox
                       :checked   @force-timeout
                       :on-change #(set-llm-switch! force-timeout "debug_force_timeout_error" (-> % .-target .-checked))}]
              " Force timeout error (timeout_error)"]
             [:label
              [:input {:type      :checkbox
                       :checked   @force-unknown
                       :on-change #(set-llm-switch! force-unknown "debug_force_unknown_error" (-> % .-target .-checked))}]
              " Force an unrecognized error (unknown_error)"]
             [:label
              [:input {:type      :checkbox
                       :checked   @force-slow-response
                       :on-change #(set-llm-switch! force-slow-response "debug_force_slow_response" (-> % .-target .-checked))}]
              " Force slow response"]
             [:label
              [:input {:type      :checkbox
                       :checked   @force-confirm
                       :on-change (fn [e]
                                    (let [v (-> e .-target .-checked)]
                                      (reset! force-confirm v)
                                      (save! "debug_force_confirm_failure" v)))}]
              " Force ConfirmAction failure (HTTP 500)"]
             [:label
              [:input {:type      :checkbox
                       :checked   @force-prompt-too-long
                       :on-change #(set-llm-switch! force-prompt-too-long "debug_force_prompt_too_long" (-> % .-target .-checked))}]
              " Force context limit error on the first attempt (overflow recovery then runs; demotes one document block per turn)"]]

            [:h3 "Status Simulation"]
            [:p.u-margin-bottom "Force the health check to report a specific status. Takes effect on the next health check run (up to 15s). Only one status simulation can be active at a time."]
            [:div {:style {:display :flex :flex-direction :column :gap "8px" :margin-bottom "1.5rem"}}
             [:label
              [:input {:type      :checkbox
                       :checked   @force-anthropic-outage
                       :on-change #(set-status-switch! force-anthropic-outage "debug_force_anthropic_outage" (-> % .-target .-checked))}]
              " Force Anthropic outage (status: outage, source: anthropic)"]
             [:label
              [:input {:type      :checkbox
                       :checked   @force-anthropic-partial
                       :on-change #(set-status-switch! force-anthropic-partial "debug_force_anthropic_partial" (-> % .-target .-checked))}]
              " Force Anthropic partial restore (status: partial, source: anthropic)"]
             [:label
              [:input {:type      :checkbox
                       :checked   @force-ipaladin-outage
                       :on-change #(set-status-switch! force-ipaladin-outage "debug_force_ipaladin_outage" (-> % .-target .-checked))}]
              " Force iPaladin outage (status: outage, source: ipaladin)"]]])

         [:h3 "Prompt Dump"]
         [:p.u-margin-bottom "Download everything AARK sees -- preambles, LMPs, skills, and tool definitions -- as a single JSON file."]
         [:div {:style {:margin-bottom "1.5rem"}}
          [common/download-button {:ajax-url "/licenseadmin/ai-prompt-dump/"
                                   :ajax-options {:response-format (ajax.core/ring-response-format {:format (text-response-format)})}}
           "Download prompt dump (JSON)"]]

         [:h3 "Conversation Dump"]
         [:p.u-margin-bottom "Upload a token file (.itk) to download the conversation debug dump."]
         [:label
          [:input {:type      :file
                   :accept    ".itk"
                   :on-change (fn [e]
                                (let [file (-> e .-target .-files (aget 0))]
                                  (when file
                                    (let [reader (js/FileReader.)]
                                      (set! (.-onload reader)
                                            (fn [ev]
                                              (let [token (str/trim (-> ev .-target .-result))]
                                                (if (seq token)
                                                  (do (reset! error-msg nil)
                                                      (reset! server-errs nil)
                                                      (common/trigger-download
                                                       dl-link-el
                                                       "/licenseadmin/llmdebug/"
                                                       {:method :post
                                                        :params {:token token :full_history @full-history}}
                                                       server-errs))
                                                  (reset! error-msg "Empty key file")))))
                                      (.readAsText reader file)))))}]]
         [:label.u-margin-bottom
          [:input {:type      :checkbox
                   :checked   @full-history
                   :on-change #(swap! full-history not)}]
          " Download full history (ignore token timestamp)"]
         (when @error-msg
           [:p.u-margin-top.error @error-msg])
         [:a {:style {:display :none} :ref (fn [el] (when el (reset! dl-link-el el)))} ""]

         [:h3.u-margin-top "Debug JSON Viewer"]
         [:p.u-margin-bottom "Or upload a JSON file to view debug output:"]
         [:label
          [:input {:type      :file
                   :accept    ".json"
                   :on-change (fn [e]
                                (let [file (-> e .-target .-files (aget 0))]
                                  (when file
                                    (let [reader (js/FileReader.)]
                                      (set! (.-onload reader)
                                            (fn [ev]
                                              (let [json-str (-> ev .-target .-result)]
                                                (try
                                                  (let [json-data (util/to-clj (js/JSON.parse json-str))]
                                                    (reset! error-msg nil)
                                                    (reset! server-errs nil)
                                                    (reset! *json-data json-data))
                                                  (catch js/Error _
                                                    (reset! error-msg "Invalid JSON file"))))))
                                      (.readAsText reader file)))))}]]
         (when @*json-data
           [pfo.chat.debug/debug nil @*json-data])]))))


(defn ai-tabs [options tab-content active-tab]
  (fn []
    (let [tab-list [[[:span [:span.cs-brand "AARK"] " Settings"]
                     {:url (path-for :settings-ai) :id :settings-ai}
                     true
                     (is-user-license-admin)
                     nil]
                    ["LMPs"
                     {:url (path-for :settings-ai-lmp) :id :settings-ai-lmp}
                     true
                     (is-user-license-admin)
                     nil]
                    ["Skills"
                     {:url (path-for :settings-ai-skill) :id :settings-ai-skill}
                     true
                     (is-user-license-admin)
                     nil]
                    ["Billing"
                     {:url (path-for :settings-ai-billing) :id :settings-ai-billing}
                     true
                     (is-user-license-admin)
                     nil]
                    ["Debug"
                     {:url (path-for :settings-ai-debug) :id :settings-ai-debug}
                     true
                     (is-user-license-admin)
                     nil]
                    ["Feedback"
                     {:url (path-for :settings-ai-feedback) :id :settings-ai-feedback}
                     true
                     (is-user-license-admin)
                     nil]]]
      [admin-tab-bar (assoc options
                            :header-additional-content
                            [:span " / " [:a {:href (path-for :settings-ai)} [:span.cs-brand "AARK"]]])
       tab-list tab-content active-tab])))

(defn report-tabs [options tab-content active-tab]
  (fn []
    (let [tab-list [["Dropbox Sign Usage"
                     {:url-fn #(path-for :settings-dropbox-sign-report)
                      :id :dropbox-sign-report}
                     true
                     (is-user-license-admin)
                     nil]
                    ["AARK Usage"
                     {:url (path-for :settings-ai-usage) :id :settings-ai-usage}
                     true
                     (is-user-license-admin)
                     nil]]]
      [admin-tab-bar (assoc options
                       :header-additional-content
                       [:span " / " [:a {:href (path-for :settings-dropbox-sign-report)} "Reports"]])
       tab-list tab-content active-tab])))

(defn dots []
  (with-let [numdots (atom 0)
             interval-id (js/setInterval (fn [] (swap! numdots (comp #(mod % 4) inc))) 500)]
    [:span.dots (clojure.string/join (repeat @numdots "."))]
    (finally (js/clearInterval interval-id))))

(defn demo-form [{:keys [success-cb cancel-cb]} group-id]
  (let [demo-name (atom nil)
        demo-date (atom (time-coerce/to-date (tz/to-user-timezone (timepicker/get-default-start-time))))
        expiration-date (atom (time-coerce/to-date (plus (tz/at-midnight (time-coerce/from-date (timepicker/get-default-start-time))) (days demo-inactivity-limit))))
        image-set (atom nil)
        errors (atom nil)]
    (fn []
      [:p
       "New demo name: " [:span.error (:name @errors)]
       [:input {:value @demo-name
                :on-change (util/reset-from-event demo-name)}] " " [:br]
       "Current day in the demo: " [:span.error (:freeze_time @errors)]
       [datetimepicker {:time-atom demo-date
                        :show-time-picker false}] " " [:br]
       "Expiration date: " [:span.error (:expiration_time @errors)]
       [datetimepicker {:time-atom expiration-date
                        :show-time-picker false}] " " [:br]
       "Logo image set:" [:select {:on-change (reset-from-event image-set)}
                          [:option {:value "<NONE>"} "Default"]
                          [:option {:value "knight.ipaladin.com"} "Knight"]
                          [:option {:value "telemus.ipaladin.com"} "Telemus"]
                          [:option {:value "adolos.ipaladin.com"} "Adolos"]
                          [:option {:value "twinwood.ipaladin.com"} "Twinwood"]
                          [:option {:value "interchange.ipaladin.com"} "Interchange"]]
       [:button {:on-click (fn []
                             (->> (model/license-admin-demo-request
                                   group-id
                                   @demo-name
                                   (util/local-date-time-to-date-string @demo-date)
                                   (util/date-to-rfc3339
                                    (time-coerce/to-date
                                     (plus (time-coerce/from-date @expiration-date)
                                           (hours 23) (minutes 59))))
                                   (when-not (= @image-set "<NONE>") @image-set))
                                  (p/map (fn [_]
                                           (some-> success-cb (apply []))
                                           (reset! errors nil)))
                                  (process-error errors)))} "Request a demo"] " "
       [:button {:on-click #(some-> cancel-cb (apply []))} "Cancel"]])))

(defn demo-list []
  (let [selected-group (atom nil)
        status-list (atom nil)
        ;; Used to avoid setting statuses when group was changed before
        ;; response was received. TODO: Probably some kind of promise
        ;; cancellation should be used instead.
        load-demo-statuses-group (clojure.core/atom nil)
        load-demo-statuses (fn [hide-spinner]
                             (when @selected-group
                               (reset! load-demo-statuses-group @selected-group)
                               (->> ((if (is-user-license-admin)
                                       model/license-admin-demo-status-list
                                       model/group-admin-demo-status-list) @selected-group hide-spinner)
                                    (p/map (fn [response]
                                             (when (= @selected-group @load-demo-statuses-group)
                                               (reset! status-list response)
                                               (reset! load-demo-statuses-group nil))))
                                    (p/error (fn [err]
                                               (reset! load-demo-statuses-group nil)
                                               (throw err)))
                                    (process-error))))
        load-statuses #(load-demo-statuses false)

        demo-delete (fn [_ instance-uid] (->> (model/license-admin-demo-delete @selected-group instance-uid)
                                              (p/map #(load-statuses))
                                              (process-error)))
        show-form (atom false)
        status-interval-id (js/setInterval #(load-demo-statuses true) 20000)
        can-manage-demo? (is-user-license-admin)]
    (reagent/create-class
     {:reagent-render (fn []
                        [:div
                         [list-options
                          [group-chooser {:group-changed-cb load-statuses
                                          :admin-only (if (is-user-license-admin) false true)
                                          :group-atom selected-group} nil]]
                         [:table.t-table-redesign
                          (when (seq @status-list)
                            [:thead
                             [:tr
                              [:th "Name"]
                              [:th "Created"]
                              [:th]]])

                          [:tbody
                           (doall
                            (for [status @status-list]
                              [:tr {:key (:instance_uid status)}
                               [:td (:name status)]
                               [:td.u-text-align-center (util/date-reformat (:created_at status))]
                               [:td
                                (case (:status status)
                                  "none" [:div]
                                  "pending" [:p "Demo status: pending" [dots] " "
                                             (when can-manage-demo?
                                               [:button {:on-click #(when (js/confirm "Are you sure you want to cancel the demo request?")
                                                                      (demo-delete % (:instance_uid status)))} "Delete"])]
                                  [:p "Demo status: " (:status status) ". "
                                   (when (= (:status status) "ready")
                                     [:span
                                      "Demo will expire on " (util/date-format-simple (time-coerce/from-date
                                                                                       (tz/to-user-timezone
                                                                                        (util/parse-datetime (:expiration_time status))))) ". "
                                      [:button {:on-click (util/handler #(.open js/window (:url status) "_blank"))} "Open"]])
                                   (when can-manage-demo?
                                     [:button {:on-click #(when (js/confirm "Are you sure you want to delete the demo?")
                                                            (demo-delete % (:instance_uid status)))} "Delete"])])]]))]]
                         (when can-manage-demo?
                           [:section.o-media--bottom-shadow
                            (when-not @show-form
                              [:button {:on-click (util/handler #(reset! show-form true))} "New Demo"])
                            (when @show-form
                              [demo-form {:success-cb (fn []
                                                        (load-statuses)
                                                        (reset! show-form false))
                                          :cancel-cb #(reset! show-form false)}
                               @selected-group])])])
      :component-will-unmount #(js/clearInterval status-interval-id)})))


(defn category-list-controls [options]
  [:span
   (let [scope (scope/get-scope
                (value-if-not-none @(:selected-subscriber-atom options))
                (value-if-not-none @(:selected-group-atom options)))]
     (when (or (is-user-license-admin) (not= (:level scope) scope/level-global))
       [:button {:on-click (fn [_]
                             (util/set-location
                              (str "#/admin/category/add?operation_scope=" (scope/to-str scope))))} "Add Category"]))])

(defn category-list [selected-subscriber-atom selected-group-atom active]
  (let [subscriber selected-subscriber-atom
        categories (atom nil)
        filter-active (atom (or active "active"))
        group selected-group-atom
        scope-atom (track! (fn [] (get-scope (value-if-not-none @subscriber) (value-if-not-none @group))))
        set-categories! #(reset! categories (filterv (case @filter-active
                                                       "active" :active
                                                       "inactive" (comp not :active)
                                                       "all" identity) %))
        update-url (fn []
                     (util/set-location-params
                      (merge
                       (when (value-if-not-none @subscriber) {:subscriber @subscriber})
                       (when (value-if-not-none @group) {:group @group})
                       (when filter-active {:active @filter-active}))
                      true))
        show-list? (fn []
                     ;; Non- license admins should not see global templates
                     (or
                      (is-user-license-admin)
                      (and (value-if-not-none @subscriber) (is-user-subscriber-admin @subscriber))
                      (value-if-not-none @group)))
        load-categories (fn [subscriber-id group-id]
                          (->>
                           (category-model/category-admin-list
                            subscriber-id group-id (case @filter-active
                                                     "active"   true
                                                     "inactive" false
                                                     "all"      nil))
                           (p/map set-categories!)
                           (process-error)))]
    (when (is-user-license-admin)
      (load-categories nil nil))
    (when (or (value-if-not-none @subscriber) (value-if-not-none @group))
      (load-categories (value-if-not-none @subscriber) (value-if-not-none @group)))
    (fn []
      [:div.groups
       [list-options
        (when (is-user-any-subscriber-admin)
          [subscriber-chooser
           {:subscriber-changed-cb (fn [subscriber-id _]
                                     (update-url)
                                     (if (and subscriber-id
                                              (is-user-subscriber-admin subscriber-id))
                                       (load-categories subscriber-id nil)
                                       (reset! categories nil)))
            :allow-empty           true
            :subscriber-atom       subscriber
            :group-atom            group
            :admin-only            false
            :preselect-if-one      true}
           @subscriber])
        (when-not (is-user-license-admin)
          [group-chooser
           (merge
            {:group-changed-cb (fn [subscriber-id group-id]
                                 (update-url)
                                 (if (or (and subscriber-id (is-user-subscriber-admin subscriber-id)) group-id)
                                   (load-categories (when-not group-id subscriber-id) group-id)
                                   (reset! categories nil)))
             :admin-only       true
             :group-atom       group}
            (when (is-user-any-subscriber-admin)
              {:allow-empty     true
               :subscriber-atom subscriber}))
           @selected-group-atom])
        (when
         (or (is-user-license-admin)
             (or (value-if-not-none @group)
                 (and (value-if-not-none @subscriber) (is-user-subscriber-admin @subscriber))))
          [:div
           [:ul [:li "Active status"]]
           [:select {:on-change (fn [ev]
                                  ((reset-from-event filter-active) ev)
                                  (update-url)
                                  (load-categories (value-if-not-none @subscriber) (value-if-not-none @group)))}
            [:option (option-value @filter-active "active") "Active"]
            [:option (option-value @filter-active "inactive") "Inactive"]
            [:option (option-value @filter-active "all") "All"]]])]
       (when-not (is-user-license-admin)
         [:h2.o-media--medium
          (cond
            (and (not (value-if-not-none @group)) (value-if-not-none @subscriber) (not (is-user-subscriber-admin @subscriber))) "Select family "
            (and (not (value-if-not-none @subscriber)) (not (value-if-not-none @group)))                                        "Select family or subscriber")])
       (when (show-list?)
         (if (seq @categories)
           [:table.t-table-redesign
            [:thead
             [:tr
              [:th "Name"]
              [:th "Type"]
              [:th "Active"]]]
            [:tbody
             (doall
              (for [category @categories]
                [:tr {:key (:id category)}
                 [:td [:a {:href (str "#/admin/category/" (:id category) "/edit?operation_scope=" (scope/to-str @scope-atom) "&active=" @filter-active)} (:name category)]]
                 [:td (case (:type category)
                        "d" "Document"
                        "s" "Service")]
                 [:td (if (:active category) "yes" "no")
                  [:button.c-button.c-button--round
                   {:on-click (util/handler
                               (fn []
                                 (->> ((if (is-user-license-admin)
                                         model/license-admin-delete-categories
                                         (partial category-model/category-delete @scope-atom)) (:id category))
                                      (p/map (fn [_]
                                               (set-flash :success "Category deleted")
                                               (load-categories @subscriber @group)))
                                      (p/error (fn [err]
                                                 (if (and (= 403 (:status err))
                                                          (= (get-in err [:response :body :type]) "category_in_use"))
                                                   (set-flash :error (str "Can't delete category - it is assigned to some of the " ({"ttg" "task or compliance templates"
                                                                                                                                     "tg" "tasks or compliances"
                                                                                                                                     "d" "documents"} (get-in err [:response :body :data :object_type]) "objects") ". "))
                                                   (throw err))))
                                      (process-error))))}  "×"]]]))]]
           [:p.o-media "No categories."]))])))

(defn category-edit-form [scope category _]
  (let [errors (atom nil)
        category-name (atom (:name category))
        category-type (atom (or (:type category) "s"))
        is-active (atom (if category (:active category) true))
        family (atom nil)]
    (when (= (:level scope) scope/level-family)
      (->>
       (collection-model/collection-details (:id scope))
       (p/map #(reset! family %))
       (process-error)))
    (fn [scope category list-active]
      [:form.o-media--bottom-shadow.c-form--edit.c-form--spreaded
       {:on-submit (handler (fn []
                              (->> ((if category
                                      (partial (if (is-user-license-admin)
                                                 model/license-admin-category-update
                                                 (partial category-model/category-update scope)) (:id category))
                                      (if (is-user-license-admin)
                                        model/license-admin-category-add
                                        (partial category-model/category-add scope)))
                                    {:name @category-name
                                     :type @category-type
                                     :active @is-active})
                                   (p/map (fn [_]
                                            (set-flash :success "Category saved")
                                            (util/set-location
                                             (str (path-for :settings-categories) "?active=" list-active
                                                  (condp = (:level scope)
                                                    scope/level-subscriber (str "&subscriber=" (:id scope))
                                                    scope/level-family (str "&group=" (:id scope) "&subscriber=" (:subscriber_id @family))
                                                    "")))))
                                   (p/error (fn [err]
                                              (if (and (= 403 (:status err)) (= (get-in err [:response :body :type]) "category_in_use"))
                                                (set-flash :error "Can't modify category type - it is assigned to some of the objects of the current type.")
                                                (throw err))))
                                   (process-error errors))))}
       [:dl
        [:dt "Name"]
        [:dd
         [:input.u-width--full {:value @category-name :on-change (reset-from-event category-name)}]
         [:span.error (:name @errors "")]]]
       [:dl
        [:dt "Type"]
        [:dd
         [:select {:on-change (reset-from-event category-type)}
          [:option (option-value @category-type "s") "Service"]
          [:option (option-value @category-type "d") "Document"]]
         [:span.error (:type @errors "")]]]
       [:dl
        [:dd [:label [:input (set-checked @is-active {:on-click #(reset! is-active (checked? %))})] "Is Active?"]]]

       [:footer.u-flex.u-flex--justify-content-space-between
        [:button {:on-click (util/handler
                             #(util/set-location
                               (str (path-for :settings-categories) "?active=" list-active
                                    (condp = (:level scope)
                                      scope/level-subscriber (str "&subscriber=" (:id scope))
                                      scope/level-family (str "&group=" (:id scope) "&subscriber=" (:subscriber_id @family))
                                      ""))))} "Cancel"]
        [:button {:type :submit} "Save"]]])))

(defn category-edit [scope category list-active]
  (let [scope-name (atom "")]
    (->> (condp = (:level scope)
           scope/level-family (collection-model/collection-details (:id scope))
           scope/level-subscriber (model/subscriber (:id scope))
           (p/resolved nil))
         (p/map #(reset! scope-name (:name %)))
         (process-error))

    (fn [_]
      [common/header-tab-wrapper (if category
                                   (str "Edit category: " (:name category))
                                   (if @scope-name
                                     (str "Add a new category to " @scope-name)
                                     "Add a new category"))
       [category-edit-form scope category list-active]])))

(defn -op-type [operation] (keyword (:type operation)))

(defmulti status-text -op-type)

(defmethod status-text :compliance_edit [operation]
  (let [bulk-edit (:details operation)
        failed-count (+
                      (:failed_items_count bulk-edit)
                      ;; In some (past?) cases of system failures, the process ended before
                      ;; all items could be completed. Those uncompleted items are now included
                      ;; in failures in case of "Done"
                      (- (:item_count bulk-edit) (:completed_items_count bulk-edit)))]
    (case (:status bulk-edit)
      "d" (str "Done" (when (> failed-count 0) (str " (" failed-count " failed)")))
      "f" "Failed"
      "Processing")))

(defmethod status-text :template_apply [operation]
  (let [bulk-edit (:details operation)]
    (case (:status bulk-edit)
      "d" "Done"
      "f" "Failed"
      "Processing")))

(defmulti operation-type -op-type)

(defmethod operation-type :compliance_edit [_] "Compliance modification")

(defmethod operation-type :template_apply [_] "Template application")

(defmulti item-url -op-type)

(defmethod item-url :compliance_edit [operation group-id] (str "#/admin/bulkedit/" (get-in operation [:details :id]) "/item/list?group_id=" group-id))

(defmethod item-url :template_apply [operation group-id] (str (path-for :settings-bulkapply-details :operation-id (:id operation)) "?group_id=" group-id))

(defn bulk-edit-list [selected-group-atom group-id]
  (let [groups (subscribe :permitted-groups)
        current-page (atom 1)
        load-bulk-operations (fn [group-id page]
                               (controller/dispatch :bulk-operations :load {:group-id group-id
                                                                            :page  page})
                               (reset! current-page page))
        bulk-operations (subscribe :bulk-operations)
        group selected-group-atom
        get-group #(or @group (:id (first @groups)))]
    (controller/dispatch :permitted-groups :load {:collection-id nil
                                                  :admin-only false})
    (add-watch groups :groups (fn [_ _ _ new-groups]
                                (when-not @group
                                  (reset! group (or group-id (:id (first new-groups)))))))
    (add-watch group :selected-group (fn [_ _ _ new-group]
                                       (when new-group
                                         (load-bulk-operations new-group 1))))
    (fn []
      [:div.groups
       [:div.o-media--1x05.u-shadow--bottom
        [:ul [:li "Family"]]
        [:select {:on-change (fn [ev] ((reset-from-event group) ev))}
         (doall
          (for [gr @groups]
            [:option (option-value (get-group) (:id gr)) (util/add-inactive-to-name gr)]))]]
       (if (seq (:results @bulk-operations))
         [:table.t-table-redesign
          [:thead
           [:tr
            [:th "Created"]
            [:th "Type"]
            [:th "User"]
            [:th "Item count"]
            [:th "Status"]]]
          [:tbody
           (doall
            (for [operation (:results @bulk-operations)]
              (let [bulk-edit (:details operation)
                    item-link (fn [component]
                                (if (:details operation)
                                  [:a {:title (get-in operation [:details :error]) :href (item-url operation (get-group))} component]
                                  component))]
                [:tr {:key (:id bulk-edit)}
                 [:td.u-text-align-center
                  [item-link (some-> bulk-edit (:created_at bulk-edit) (util/parse-datetime) (tz/to-browser-time) (util/date-format-date-hour-minute))]]
                 [:td [item-link (operation-type operation)]]
                 [:td.u-text-align-center [item-link (auth-model/get-full-name (:user bulk-edit))]]
                 [:td.u-text-align-center [item-link (:item_count bulk-edit)]]
                 [:td.u-text-align-center
                  [item-link (status-text operation)]]])))]
          [tfoot-paginator
           [paginator
            (map (fn [page-number]
                   {:number page-number
                    :on-click (util/handler #(load-bulk-operations @group page-number))})
                 (:page_numbers @bulk-operations))
            @current-page
            (when (:has_previous @bulk-operations) (util/handler #(load-bulk-operations @group (- @current-page 1))))
            (when (:has_next @bulk-operations) (util/handler #(load-bulk-operations @group (+ @current-page 1))))]
           5
           (-> (:page_numbers @bulk-operations) count (> 1))]]
         [:p.o-media "No bulk operations."])])))

(defn bulk-edit-item-list [_ group-id bulk-edit-id]
  (let [bulk-edit-items (atom nil)
        current-page (atom 1)
        load-bulk-edit-items (fn [page-number]
                               (->> (model/group-admin-bulk-edit-items bulk-edit-id page-number)
                                    (p/map (fn [response]
                                             (reset! bulk-edit-items response)
                                             (reset! current-page page-number)))
                                    (process-error)))]
    (load-bulk-edit-items @current-page)
    (fn [_ _ _ _]
      [:div.groups
       (let [bulk-edit (:bulk_edit @bulk-edit-items)]
         (when @bulk-edit-items
           [:div.changes.o-media
            [:h4 "Changes"]
            (case (:edit_type bulk-edit)
              "user" [:ul
                      [:li "Assigned user changed to: " (auth-model/get-full-name (:assigned_user bulk-edit)) "."]]
              "date" [:ul
                      [:li "Complete by changed to: " (util/date-reformat (:complete_by bulk-edit)) "."]]
              "global" [:ul
                        (when-let [collections (seq (:bulk_edit_collections bulk-edit))]
                          (let [colnum (dec (count collections))]
                            [:li "Collections changed to: "
                             (doall
                              (map-indexed (fn [idx col]
                                             [:span [:a {:href (str "#/collection/details/" (:collection_id col))} (get-in col [:collection :name])] (when (< idx colnum) ", ")])
                                           collections)) "."]))
                        (when-let [category (:category bulk-edit)]
                          [:li "Category changed to: " (:name category) "."])
                        (when-let [rule (:rule bulk-edit)]
                          [:li "Repetition rule changed to: " (:name rule) "."] )
                        (when-let [labels (seq (:label_objects bulk-edit))]
                          [:li "Labels changed to: " (str/join ", " (map #(:name %) labels)) "."])
                        (when (:delete_labels bulk-edit)
                          [:li "Labels deleted"])])]))
       (condp = @bulk-edit-items
         nil [:p.o-media "Loading..."]
         [] [:p.o-media "No bulk edit items."]
         [:table.t-table-redesign.task-list
          [:thead
           [:tr
            [:th "Item"]
            [:th "Status"]
            [:th "Description"]]]
          [:tbody
           (doall
            (for [bulk-edit-item (:results @bulk-edit-items)]
              [:tr {:key (:id bulk-edit-item)}
               [:td
                [:a {:href (str "#/task/details/" (:task_id bulk-edit-item) "/")} (when-let [group-name (not-empty (:group_name bulk-edit-item))] [:p.group-name group-name])
                 (util/date-reformat (:complete_by bulk-edit-item)) " "  (:name bulk-edit-item)]]
               [:td.u-text-align-center
                (case (:status bulk-edit-item)
                  "n" "Pending"
                  "s" "Started"
                  "d" "Done"
                  "f" "Failed"
                  "Unknown")]
               [:td.u-text-align-center
                (:error bulk-edit-item)]]))]
          [tfoot-paginator
           [paginator
            (map (fn [page-number]
                   {:number page-number
                    :on-click (handler (fn [] (load-bulk-edit-items page-number)))})
                 (:page_numbers @bulk-edit-items))
            @current-page
            (when (:has_previous @bulk-edit-items) (handler #(load-bulk-edit-items (- @current-page 1))))
            (when (:has_next @bulk-edit-items) (handler #(load-bulk-edit-items (+ @current-page 1))))]
           3
           (-> (:page_numbers @bulk-edit-items) count (> 1))]])
       [:footer.u-flex.u-flex--justify-content-space-between.o-media
        [:button.c-button {:on-click (util/handler #(util/set-location (str (path-for :settings-bulkoperations-list) "?group_id=" group-id)))} "Back"]]])))

(defn bulk-apply-details [_ group-id operation-id]
  (let [bulk-apply-items (subscribe :bulk-apply-items)
        bulk-operation (subscribe :bulk-operation)
        current-page (atom 1)
        load-page (fn [page]
                    (controller/dispatch :bulk-apply-items :load {:group-id group-id
                                                                  :operation-id operation-id
                                                                  :page  page})
                    (reset! current-page page))
        intended-user-id (fn [step-index] (get-in @bulk-apply-items [:details :details :intended_user_ids step-index]))
        intended-user (fn [step-index] (get-in @bulk-apply-items [:details :details :intended_users (keyword (str (intended-user-id step-index)))]))]
    (controller/dispatch :bulk-operation :load {:group-id group-id :operation-id operation-id})
    (fn [_ _ _]
      [:div
       (when-let [error (not-empty (get-in @bulk-operation [:details :error]))]
         [:p.o-media (when (= "f" (get-in @bulk-operation [:details :status])) "Bulk application failed. ") error "."])
       (if (seq (:collections @bulk-apply-items))
         [:table.t-table-redesign
          [:thead
           [:tr
            [:th "Collection" #_(orderer order "Name" "name")]
            [:th "Assigned user replacement" #_(orderer order "Path" "path_info")]]]
          [:tbody
           (doall
            (for [collection-id (:collection-ids-ordered-unique @bulk-apply-items)]
              (let [collection ((:collection-map @bulk-apply-items) collection-id)]
                [:tr {:key (:id collection)}
                 [:td.assignments [assignment-list [(assoc collection
                                                           :collection collection
                                                           :collection_id (:id collection)
                                                           :main true)]]]
                 [:td
                  (let [items ((:collection-applications @bulk-apply-items) collection-id)]
                    [:ul (doall
                          (for [[index item _]
                                (filterv
                                 (fn [[_ _ replaced]] replaced)
                                 (map-indexed
                                  (fn [index item] [index item (not= (:assigned_user_id item) (intended-user-id index))])
                                  items))]
                            [:li
                             [:a {:href (str (path-for :task-group-details :id (:task_group_id item)) "?show_step_idx=" index)} (:template_name item)
                              ": "
                              (auth-model/get-full-name (intended-user index)) " replaced with " (auth-model/get-full-name (:assigned_user item))]]))])]])))]
          [tfoot-paginator
           [paginator
            (map (fn [page-number]
                   {:number page-number
                    :on-click (util/handler #(load-page page-number))})
                 (:page_numbers (:items @bulk-apply-items)))
            @current-page
            (when (:has_previous (:items @bulk-apply-items)) (util/handler #(load-page (- @current-page 1))))
            (when (:has_next (:items @bulk-apply-items)) (util/handler #(load-page (+ @current-page 1))))]
           2
           (-> (:page_numbers (:items @bulk-apply-items)) count (> 1))]]
         [:p.o-media--bottom-shadow "No items."])
       [:footer.u-flex.u-flex--justify-content-space-between.o-media
        [:button.c-button {:on-click (util/handler #(util/set-location (str (path-for :settings-bulkoperations-list) "?group_id=" group-id)))} "Back"]]])))

(defn application-licenses []
  [:div
   [:div.o-media--bottom-shadow
    [:p {:style {:font-weight :bold}} "This admin tab is available because iPaladin has been build in INTERNAL mode. It will not be available in EXTERNAL mode (for custom deployments.)"]]
   [:div.o-media--bottom-shadow
    [:h2 "License details"]
    [:form.c-form--edit.u-margin-top.u-margin-bottom
     [:p "You can upload a license file in order to display license details"]]]
   [:div.o-media
    [:h2 "Create new license"]]])

(defn nominations [status]
  (let [nominations (atom nil)
        groups-id-dict (atom {})
        filter-status (atom (or status "p"))
        current-page (atom 1)
        load-nominations (fn [page]
                           (->> (model/license-admin-nominations (if (= "<all>" @filter-status)
                                                                   nil
                                                                   @filter-status) page)
                                (p/map (fn [response] (reset! nominations response)
                                         (reset! current-page page)))
                                (process-error)))
        handle-nomination (fn [nomination-id status]
                            (->> (model/license-admin-nomination-handle nomination-id status)
                                 (p/map (fn [_] (load-nominations @current-page)))
                                 (process-error)))]
    (load-nominations @current-page)
    (->> (model/license-admin-groups)
         (p/map (fn [response] (reset! groups-id-dict (into {} (map (fn [group] [(:id group) group]) response)))))
         (process-error))
    (fn []
      [:div.groups
       [list-options
        [:div
         [:ul [:li "Nomination status"]]
         [:select {:on-change (fn [ev]
                                ((reset-from-event filter-status) ev)
                                (load-nominations @current-page))}
          [:option (option-value @filter-status "p") "Pending"]
          [:option (option-value @filter-status "a") "Accepted"]
          [:option (option-value @filter-status "r") "Rejected"]
          [:option (option-value @filter-status "<all>") "All"]]]]
       (if (and (seq @groups-id-dict) (seq (:results @nominations)))
         [:table.t-table-redesign
          [:thead
           [:tr
            [:th "User"]
            [:th "Family"]
            [:th "Status"]]]
          [:tbody
           (doall
            (for [nomination (:results @nominations)]
              [:tr {:key (:id nomination)}
               [:td (:user_full_name nomination)]
               [:td.u-text-align-center (get-in @groups-id-dict [(:group_id nomination) :name])]
               [:td.u-text-align-center (case (:status nomination)
                                          "p" [:div "Pending "
                                               [:button {:on-click (util/handler (fn [] (handle-nomination (:id nomination) "a")))} "Accept"] " "
                                               [:button {:on-click (util/handler (fn [] (handle-nomination (:id nomination) "r")))} "Reject"]]
                                          "a" "Accepted"
                                          "r" "Rejected")]]))]
          [tfoot-paginator
           [paginator
            (map (fn [page-number]
                   {:number page-number
                    :on-click (util/handler #(load-nominations page-number))})
                 (:page_numbers @nominations))
            @current-page
            (when (:has_previous @nominations) (util/handler #(load-nominations (- @current-page 1))))
            (when (:has_next @nominations) (util/handler #(load-nominations (+ @current-page 1))))]
           5
           (-> (:page_numbers @nominations) count (> 1))]]
         [:p.o-media "No categories."])])))

(defn subscribers-list []
  (let [subcsribers (atom nil)
        load-subscribers (fn []
                           (->> (model/license-admin-subscribers false nil)
                                (p/map (fn [response]
                                         (reset! subcsribers response)))
                                (process-error)))]
    (load-subscribers)
    (fn []
      [:div.groups
       (if  true
         [:table.t-table-redesign
          [:thead
           [:tr
            [:th "Name"]
            [:th "Active"]]]
          [:tbody
           (doall
            (for [subscriber @subcsribers]
              [:tr {:key (:id subscriber)}
               [:td [:a {:href (str "#/admin/subscribers/details/" (:id subscriber) "/")} (model/subscriber-name subscriber)]]
               [:td.u-text-align-center (if (:active subscriber) "yes" "no")]]))]]
         [:p.o-media "No subcsribers. Use Add button to add first subcsriber"])])))

(defn subscriber-edit [subscriber]
  (let [errors (atom {})
        subscriber-name (atom (:name subscriber))
        whitelabels (subscribe :whitelabels)
        whitelabel (atom (:whitelabel_domain subscriber))
        active (atom (:active subscriber))
        seconds-to-minutes (fn [sec] (/ sec 60))
        minutes-to-seconds (fn [mn] (* mn 60))
        session-duration (atom (when-let [sd (:session_duration subscriber)]
                                 (str (seconds-to-minutes sd))))
        groups (atom nil)
        load-groups (fn []
                      (->> (model/license-admin-families-for-subscriber (:id subscriber))
                           (p/map (fn [response]
                                    (reset! groups response)))
                           (process-error)))]
    (when subscriber
      (load-groups))
    (controller/dispatch :whitelabels :load)
    (fn []
      [:div.groups
       [:form.o-media.c-form--edit.c-form--spreaded.u-shadow--bottom
        {:on-submit (fn [ev]
                      (->> ((if subscriber
                              (partial model/license-admin-subscriber-update  (:id subscriber))
                              (partial model/license-admin-subscriber-add))
                            {:name @subscriber-name
                             :active @active
                             :domain (not-empty @whitelabel)
                             :session_duration (when (not-empty @session-duration)
                                                 (minutes-to-seconds (util/str->int @session-duration)))})
                        (p/map (fn [_]
                                 (set-flash :success "Subscriber saved")
                                    (util/back ev)))
                           (process-error errors))
                      (.preventDefault ev))}

        [:dl
         [:dt "Name: "]
         [:dd [:input (set-value subscriber-name)]
          [:span.error (:name @errors "")]]]
        [:dl
         [:dt "Branding:"]
         [:dd [:select {:on-change (fn [ev] ((reset-from-event whitelabel) ev))
                        :value @whitelabel}
               [:option {:value ""} "None"]
               (doall
                (for [wl @whitelabels]
                  [:option {:key (:domain wl)
                            :value (:domain wl)} (:name wl)]))]
          [:span.error (:domain @errors "")]]]
        [:dl
         [:dt "Session duration (minutes):"]
         [:dd
          [:input.no-spinner
           (set-value session-duration
             {:type :number
              :pattern "[0-9]{4}"
              :min 1
              :placeholder (seconds-to-minutes js/SESSION_DURATION)})]
          [:span.error (:domain @errors "")]]]
        [:dl
         [:dt "Active: "]
         [:dd [:label [:input (set-checked @active {:on-click #(reset! active (checked? %))})] "Is Active?"]]
         [:span.error (:active @errors "")]]
        [:footer.u-flex
         [:button.c-button {:on-click util/back} "Cancel"]
         [:div.u-flex__element-to-right.o-margin-elements--xs
          [:button.c-button "Save subscriber"]]]]
       (when subscriber
         [:div
          [:h2.o-media--medium "Families under subscription"]
          (if (seq @groups)
            [:table.t-table-redesign
             [:thead
              [:tr
               [:th {:style {:width "15%"}} "ID"]
               [:th "Name"]
               [:th "Active"]]]
             [:tbody
              (doall
               (for [group @groups]
                 [:tr {:key (:id group)}
                  [:td.u-text-align--center {:style {:white-space "nowrap" :padding-right "1em"}} [:a {:href (str "#/admin/group/" (:id group) "/edit")} (:id group)]]
                  [:td.u-text-align--center [:a {:href (str "#/admin/group/" (:id group) "/edit")} (collection-model/collection-name group)]]
                  [:td.u-text-align--center (if (:active group) "yes" "no")]]))]]
            [:p.o-media (str (:name subscriber) " has no families under subscription.")])])])))

(defn disposition-objects [options objects]
  [:ul
   (doall
    (for [obj objects]
      [:div
       {:key (:id obj)}
       [:li.o-margin-elements--medium
        [:span.c-linked-items__item
         {:class (condp = (:connected_object_type obj)
                   "compliance" (util/classes :t :compliance)
                   "task" :t
                   "template" :tm)}
         [:a.link
          (merge (condp = (:connected_object_type obj)
                   "compliance" {:href (task-url options obj)}
                   "task" {:href (task-url options obj)}
                   "template" {:href (str (path-for :settings-templategroup-edit :id (:group_id obj)) "/?group_id=" @(:selected-family-atom options))})
                 (:anchor-attrs options))
          (:group_name obj) " / " (:step_name obj)]]]]))])

(defn autocomplete-input [options]
  (let [label (:label options)
        search-phrase (:search-phrase options)
        chars-number-to-start (:chars-number-to-start options)
        load-cb (:load-cb options)
        show-spinner (atom false)
        timeout (atom nil)]
    (fn []
      [:div.filter-item.u-margin-top.c-form--edit
       [:h3.u-margin-bottom.u-border-bottom.u-cursor--pointer
        label]
       [:div.u-flex
        {:svaluetyle {:flex-warap "nowrap"}}
        [:input.u-width--full
         {:on-change (fn [ev]
                       (reset! search-phrase (-> ev .-target .-value))
                       (when (let [cnt (count @search-phrase)] (or (zero? cnt) (>= cnt chars-number-to-start)))
                         (when @timeout
                           (reset! show-spinner false)
                           (js/clearTimeout @timeout)
                           (reset! timeout nil))
                         (reset! show-spinner true)
                         (reset! timeout
                                 (js/setTimeout
                                  (fn []
                                    (load-cb))
                                  1000)))
                       (.preventDefault ev))
          :value        @search-phrase
          :autocomplete :off}]
        [:button.c-round-button
         {:style    {:margin "0.5em 0.5em"}
          :on-click (util/handler
                     (fn []
                       (reset! search-phrase nil)
                       (load-cb)))}
         "×"]]])))

(defn disposition-export-bt [key chosen-dispositions]
  (when key
    [:div.dropdown
     [:form
      {:method :post
       :action (str "/download/disposition/")}
      [:input
       {:type  :hidden
        :name  :key
        :value @key}]
      (for [disposition-id @chosen-dispositions]
        [:input
         {:type  :hidden
          :name  :disposition_ids
          :value disposition-id}])
      [:span.controls [:button "Export"]]]]))

(defn disposition-filter [options]
  (let [selected-family-atom (:selected-family-atom options)
        load-callback        (:load-callback options)
        chosen-objects       (:chosen-objects options)
        assign-mode (atom false)
        assign-label (atom nil)
        assign-label-error (atom nil)
        uid (:uid options)
        collection-name (:collection-name options)
        label-ids (:label_ids options)
        encrypted-token (:encrypted-token options)
        num-selected (fn [] (count @chosen-objects))
        load-labels (fn [family-atom]
                      (controller/dispatch :label-list :load {:family-id @family-atom
                                                              :object-type model/object-type-disposition}))]
    (when (:show-disposition-actions options)
      (add-watch chosen-objects :assign-mode-watch
                 (fn [_ _ _ objs] (when-not (seq objs) (reset! assign-mode false)))))
    (when @selected-family-atom (load-labels selected-family-atom))
    (fn []
      [sidebar
       [:div.filter-item.u-margin-top.c-form--edit
        [:h3.u-margin-bottom.u-border-bottom.u-cursor--pointer
         "Family"]
        [:div.u-flex
         [group-chooser {:group-changed-cb (fn [_]
                                             (load-labels selected-family-atom)
                                             (reset! collection-name nil)
                                             (reset! uid nil)
                                             (reset! label-ids [])
                                             (load-callback)
                                             (when chosen-objects (reset! chosen-objects #{})))
                         :admin-only true
                         :filter-pred (fn [family]
                                        (collection-model/has-document-automation-enabled (:id family)))
                         :hide-label true
                         :group-atom selected-family-atom} @selected-family-atom]]]
       [autocomplete-input {:label                 "Filter by disposition"
                            :search-phrase         uid
                            :chars-number-to-start 3
                            :load-cb               load-callback}]
       [autocomplete-input {:label                 "Filter by collection"
                            :search-phrase         collection-name
                            :chars-number-to-start 3
                            :load-cb               load-callback}]
       [label/filter-by-label {:load-cb load-callback :label-ids-atom (:label-ids options)}]
       (when (:show-disposition-actions options)
         [:div.filter-item.u-margin-top.c-form--edit
          [:h3.u-margin-bottom.u-padding-top.u-border-top.u-cursor--pointer
           (str (num-selected) " disposition(s) selected ")]
          (when (> (count @chosen-objects) 0)
            (if-not @assign-mode
              [:div.u-flex
               [disposition-export-bt encrypted-token chosen-objects]
               [:button.u-margin-left--xs {:on-click (util/handler #(reset! assign-mode true))} "Assign a label"]]
              [:div.c-disposition-label-chooser.c-form--edit
               [:h3.u-margin-bottom.u-border-bottom.u-cursor--pointer
                "Assign a label"]
               [:p
                [label/label-chooser
                 {:allow-create-new true
                  :allow-empty true}
                 @selected-family-atom
                 assign-label]
                [:div.u-margin-top
                 [:button
                  {:on-click (util/handler #(reset! assign-mode false))}
                  "Cancel"] " "
                 [:button {:on-click
                           (util/handler
                            (fn []
                              (controller/dispatch :automation-dispositions :assign-label
                                                   {:disposition-ids (vec @chosen-objects)
                                                    :label-id (when-not (:new @assign-label) (:id @assign-label))
                                                    :label-name (util/to-value (:name @assign-label))
                                                    :family-id @selected-family-atom
                                                    :errors assign-label-error
                                                    :on-success (fn []
                                                                  (load-labels selected-family-atom)
                                                                  (load-callback)
                                                                  (reset! assign-mode false)
                                                                  (reset! assign-label-error nil)
                                                                  (reset! assign-label nil))})))}
                  "Assign"]]]
               [:p [:span.error (:disposition_id @assign-label-error)]]
               [:p [:span.error (:label_id @assign-label-error)]]
               [:p [:span.error (:family_id @assign-label-error)]]]))])])))

(defn disposition-list [options]
  (controller/dispatch :automation-dispositions :clear)
  (let [selected-family-atom (:selected-family-atom options)
        current-page (atom 1)
        order (or (:order options) (atom "-created_at"))
        dispositions (subscribe :automation-dispositions)
        results (track! #(:results @dispositions))
        encrypted-token (track! #(:encrypted_token @dispositions))
        chosen-dispositions (atom #{})
        all-selected (fn [] (superset? @chosen-dispositions (set (map :id @results))))
        dis-checked? (fn [id] (contains? @chosen-dispositions id))
        uid (or (:uid options) (atom nil))
        collection-name (or (:collection_name options) (atom nil))
        label-ids (or (:label_ids options) (atom #{}))
        update-url           (fn []
                               (util/replace-location-query-string
                                (util/make-params
                                 (merge
                                  {:family_id @selected-family-atom}
                                  (when @order {:order @order})
                                  (when @uid {:uid @uid})
                                  (when @collection-name {:collection_name @collection-name})
                                  (when @label-ids {:label_id (vec @label-ids)})))))
        load-dispositions    (fn [page-number]
                               (update-url)
                               (reset! current-page page-number)
                               (controller/dispatch :automation-dispositions :load
                                                    {:family-id       @selected-family-atom
                                                     :page            page-number
                                                     :order           @order
                                                     :assignments     nil
                                                     :uid             @uid
                                                     :include-related-objects true
                                                     :collection-name @collection-name
                                                     :label-ids       @label-ids}))
        edit-label-atom (atom nil)
        edit-state? #(= % @edit-label-atom)
        edit-key (fn [disposition-id label-id]
                   (str disposition-id "-" label-id))
        set-edit-state! (fn [edit-key]
                          (reset! edit-label-atom edit-key))
        load-labels #(controller/dispatch :label-list :load {:family-id @selected-family-atom
                                                             :object-type model/object-type-disposition})
        set-label-cb (fn [disposition label]
                       (let [errors (atom nil)]
                         (->>
                          (model/disposition-update (:id disposition) {:uid (:uid disposition)
                                                                       :description (:description disposition)
                                                                       :label-id (when-not (:new @label)
                                                                                   (:id @label))
                                                                       :label-name-new (when (:new @label)
                                                                                         (:name @label))})
                          (p/map (fn [_]
                                   (reset! label nil)
                                   (reset! edit-label-atom nil)
                                   (load-dispositions @current-page)
                                   (load-labels)))
                          (process-error errors))))
        options (merge options {:load-callback   (fn []
                                                   (load-dispositions @current-page)
                                                   (load-labels))
                                :uid uid
                                :collection-name collection-name
                                :encrypted-token encrypted-token
                                :show-disposition-actions true
                                :label-ids label-ids
                                :chosen-objects chosen-dispositions
                                :family-id @selected-family-atom
                                :set-label-cb set-label-cb})]
    (when @selected-family-atom
      (load-dispositions 1)
      (load-labels))
    (add-watch order :changed-order (fn [& _] (update-url) (load-dispositions @current-page)))
    (fn [& _]
      [:div.o-main-aside
       [:main.o-main-aside__main
        (if (seq @results)
          [:table.t-table-redesign
           [:thead
            [:tr
             [:th "Collections/Objects"]
             [:th (orderer order "Created" "created_at")]
             [:th (orderer order "UID" "uid")]
             [:th {:style {:width "100px"}} "Label"]
             [:th {:style {:width "80px"}} "Clear"]
             [:th {:style {:width "65px"}}
              [:input (set-checked (all-selected)
                                   {:on-click (util/handler (fn []
                                                              (if (all-selected)
                                                                (swap! chosen-dispositions #(difference % (set (map :id @results))))
                                                                (swap! chosen-dispositions #(union % (set (map :id @results)))))))})]]]]
           [:tbody
            (doall
             (for [disposition @results]
               [:tr {:key (:id disposition)
                     :class (when (dis-checked? (:id disposition)) "selected")}
                [:td.assignments [:div
                                  [assignment-list (get-assignments disposition)]
                                  [disposition-objects options (:objects disposition)]]]
                [:td.u-text-align-center (-> (:created_at disposition) (util/parse-datetime) (tz/to-browser-time) (util/date-format-date-hour-minute))]
                [:td.u-text-align-center [:a {:href (str "#/disposition/" (:id disposition) "/edit/?family_id="  @selected-family-atom)} (:uid disposition)]]

                [:td
                 [:ul.c-disposition-list {:class :editable}
                  (if (edit-state? (edit-key (:id disposition) (get-in disposition [:labels 0 :id])))
                    [label/label-inline-chooser options disposition edit-label-atom]
                    [:li {:on-click
                          (util/handler #(set-edit-state! (edit-key (:id disposition) (get-in disposition [:labels 0 :id]))))}
                     (when (:labels disposition)
                       [label/label (get-in disposition [:labels 0 :name])])])
                  (when-not (:labels disposition)
                    (if (edit-state? (edit-key (:id disposition) :new))
                      [label/label-inline-chooser (merge {:new true} options) disposition edit-label-atom]
                      [:li.c-disposition-new {:key :new
                                              :on-click (util/handler #(set-edit-state! (edit-key (:id disposition) :new)))}
                       [:button.c-round-button "+"]]))]]
                [:td.u-text-align-center
                 (when (or (:collections disposition) (:objects disposition))
                   [:button.c-round-button
                    {:on-click (fn []
                                 (let [errors (atom {})
                                       text   (str "Are you sure you want to clear disposition: " (:uid disposition) " from assigned objects?")]

                                   (common/show-confirmation-modal
                                    {:title         "Clear disposition from assigned objects"
                                     :text           text
                                     :ok-cb          (fn []
                                                       (->> (model/disposition-clear-objects disposition)
                                                            (p/map
                                                             (fn []
                                                               (disposition-list options)
                                                               (common/hide-confirmation-modal)))
                                                            (process-error errors)))
                                     :errors         errors})))}
                    "×"])]
                [:td.choose.u-text-align-center
                 [:input (set-checked (dis-checked? (:id disposition))
                                      (merge
                                       {:on-change (fn [ev]
                                                     (if (checked? ev)
                                                       (swap! chosen-dispositions conj (:id disposition))
                                                       (swap! chosen-dispositions disj (:id disposition))))}))]]]))]
           [tfoot-paginator
            [paginator
             (map (fn [page-number]
                    {:number page-number
                     :on-click (util/handler #(load-dispositions page-number))})
                  (:page_numbers @dispositions))
             @current-page
             (when (:has_previous @dispositions) (util/handler #(load-dispositions (- @current-page 1))))
             (when (:has_next @dispositions) (util/handler #(load-dispositions (+ @current-page 1))))]
            5
            (-> (:page_numbers @dispositions) count (> 1))]]
          [:p.o-media "No dispositions."])]
       [disposition-filter options]])))

(defn transaction-list [options selected-family-atom]
  (let [selected-family-atom (or selected-family-atom (atom nil))
        show-rollback-leftovers (atom false)
        refresh-atom (or (:refresh-atom options) (atom nil))
        controls (:controls-atom options)
        rollback-leftovers (atom nil)
        current-page (atom 1)
        txs (subscribe :automation-transactions)
        results (track! #(:results @txs))
        load-txs (fn [page-number]
                   (controller/dispatch :automation-transactions :load {:family-id @selected-family-atom
                                                                        :page page-number
                                                                        :order nil})
                   (reset! current-page page-number))]
    (when @selected-family-atom
      (load-txs 1))

    (add-watch refresh-atom :refresh-watch #(load-txs @current-page))
    (fn [& _]
      (if @show-rollback-leftovers
        [rollback-leftover-documents nil @rollback-leftovers]
        [:div.groups [list-options [group-chooser {:group-changed-cb #(load-txs @current-page)
                                                   :admin-only true
                                                   :filter-pred (fn [family]
                                                                  (collection-model/has-document-automation-enabled (:id family)))
                                                   :group-atom selected-family-atom} @selected-family-atom]]
         (if (seq @results)
           [:table.t-table-redesign
            [:thead
             [:tr
              [:th "Created"]
              [:th "UID"]
              [:th.u-text-align--center "State"]
              [:th "Imports"]
              [:th]]]
            [:tbody
             (doall
              (for [tx @results]
                [:tr {:key (:id tx)}
                 [:td (-> (:created_at tx) (util/parse-datetime) (tz/to-browser-time) (util/date-format-date-hour-minute))]
                 [:td [:a {:href (path-for :settings-transaction-document-list :id (:id tx))} (:uid tx)]]
                 [:td.u-text-align--center (model/transaction-state-name (:state tx))]
                 [:td [:a {:href (path-for :settings-transaction-document-list :id (:id tx))}
                       [:p
                        [:p "Successes: " (:success_count tx)]
                        [:p "Failures: " (:failure_count tx)]]]]
                 [:td (when (= (:state tx) model/transaction-state-open)
                        [:button {:on-click (util/handler
                                             (fn []
                                               (when (js/confirm "Are you sure you want to roll back the transaction?")
                                                 (->>
                                                  (model/transaction-rollback (:id tx))
                                                  (p/map (fn [response]
                                                           (let [non-deletable-documents (:data response)]
                                                             (when (seq non-deletable-documents)
                                                               (reset! rollback-leftovers non-deletable-documents)
                                                               (reset! show-rollback-leftovers true);
                                                               (reset! controls
                                                                       [:button
                                                                        {:on-click (util/handler (fn []
                                                                                                   (reset! show-rollback-leftovers false)
                                                                                                   (reset! controls nil)))} "OK"]))
                                                             (load-txs @current-page))))
                                                  (process-error)))))}
                         "Roll back"])]]))]
            [tfoot-paginator
             [paginator
              (map (fn [page-number]
                     {:number page-number
                      :on-click (util/handler #(load-txs page-number))})
                   (:page_numbers @txs))
              @current-page
              (when (:has_previous @txs) (util/handler #(load-txs (- @current-page 1))))
              (when (:has_next @txs) (util/handler #(load-txs (+ @current-page 1))))]
             5
             (-> (:page_numbers @txs) count (> 1))]]
           [:p.o-media "No transactions."])]))))

(defn transaction-document-list [_ transaction-id]
  (let [current-page (atom 1)
        transaction-documents (subscribe :automation-transaction-documents)
        transaction (subscribe :automation-transaction)
        results (track! #(:results @transaction-documents))
        load-transaction-documents (fn [page-number]
                                     (controller/dispatch
                                      :automation-transaction-documents
                                      :load
                                      {:transaction-id transaction-id
                                       :page page-number
                                       :order nil})
                                     (reset! current-page page-number))]
    (controller/dispatch :automation-transaction :load {:transaction-id transaction-id})
    (load-transaction-documents 1)
    (fn [& _]
      [:div.groups
       [:h2.o-media--medium "Transaction " (:uid @transaction) " imports"]
       (if (seq @results)
         [:table.t-table-redesign
          [:thead
           [:tr
            [:th "Created"]
            [:th "Disposition"]
            [:th "Status"]
            [:th "Document"]]]
          [:tbody
           (doall
            (for [transaction-document @results]
              [:tr {:key (:id transaction-document)}
               [:td (-> (:created_at transaction-document) (util/parse-datetime) (tz/to-browser-time) (util/date-format-date-hour-minute))]
               [:td (if (:disposition_id transaction-document)
                      (get-in transaction-document [:disposition :uid])
                      (get-in transaction-document [:last_received_data :disposition_id]))]
               [:td.u-text-align--center
                (model/transaction-document-status-name (:status transaction-document))
                (when (= (:status transaction-document) model/transaction-document-status-failure)
                  (when (not (zero? (:last_error_type transaction-document)))
                    [:p
                     "("
                     (-> (:last_error_at transaction-document) (util/parse-datetime) (tz/to-browser-time) (util/date-format-date-hour-minute))
                     ": "
                     (condp = (:last_error_type transaction-document)
                       1 "System error"
                       2 (:last_error_message transaction-document)
                       3 (gstring/format "Invalid category \"%s\"" (-> transaction-document :last_received_data :category_name))) ")"]))]
               [:td (if-let [doc (:document transaction-document)]
                      [:a
                       {:href (path-for :document-details :id (:id doc))}
                       (common-model/document-complex-name doc)]
                      (when (or
                             (get-in transaction-document [:last_received_data :document_name])
                             (get-in transaction-document [:last_received_data :category_name]))
                        (str/join " » " (common-model/document-complex-name-build (:last_received_data transaction-document)))))]]))]
          [tfoot-paginator
           [paginator
            (map (fn [page-number]
                   {:number page-number
                    :on-click (util/handler #(load-transaction-documents page-number))})
                 (:page_numbers @transaction-documents))
            @current-page
            (when (:has_previous @transaction-documents) (util/handler #(load-transaction-documents (- @current-page 1))))
            (when (:has_next @transaction-documents) (util/handler #(load-transaction-documents (+ @current-page 1))))]
           5
           (-> (:page_numbers @transaction-documents) count (> 1))]]
         [:p.o-media "No transaction items."])])))

(defn disposition-edit-form [_ disposition]
  (let [errors (atom nil)
        disposition-uid (atom (:uid disposition))
        description (atom (:description disposition))
        label (atom (first (:labels disposition)))]
    (fn [family-id disposition]
      [:form.o-media--bottom-shadow.c-form--edit.c-form--spreaded
       {:on-submit (handler (fn []
                              (let [disposition-params {:uid @disposition-uid
                                                        :description @description
                                                        :label-id (when-not (:new @label)
                                                                    (:id @label))
                                                        :label-name-new (when (:new @label)
                                                                          (:name @label))}]
                                (->>
                                 (if disposition
                                   (model/disposition-update (:id disposition) disposition-params)
                                   (model/disposition-add family-id disposition-params))
                                 (p/map (fn [_]
                                          (set-flash :success "Disposition saved")
                                          (util/set-location (str (path-for :settings-disposition-list) "?family_id=" family-id))))
                                 (process-error errors)))))}
       [:dl
        [:dt "Disposition"]
        [:dd
         [:input.u-width--full {:value @disposition-uid :on-change (reset-from-event disposition-uid)}]
         [:span.error (:disposition_uid @errors "")]]]
       [:dl
        [:dt "Description"]
        [:dd [:textarea {:value @description
                         :rows 8
                         :on-change (reset-from-event description)}]
         [:span.error (:description @errors "")]]]
       [:dl
        [:dt "Assign label"]
        [:dd
         [label/label-chooser {:allow-empty true
                               :allow-create-new true} family-id label]
         [:span.error (:label-chooser @errors "")]]]
       [:footer.u-flex.u-flex--justify-content-space-between
        [:button {:on-click (util/handler #(util/set-location (str (path-for :settings-disposition-list) "?family_id=" family-id)))} "Cancel"]
        [:div.u-flex__element-to-right.o-margin-elements--md
         (when disposition
           [:button.c-button {:on-click (fn [ev]
                                          (when (js/confirm "Are you sure you want to delete disposition?\nIt will also clear all disposition assignments.")
                                            (->> (model/disposition-delete (:id disposition))
                                                 (p/map (fn [_]
                                                          (set-flash :success "Disposition deleted")
                                                          (util/back ev)
                                                          (.preventDefault ev)))
                                                 (process-error errors)))
                                          (.preventDefault ev))} "Delete disposition"])
         [:button {:type :submit} "Save disposition"]]]])))

(defn disposition-edit [family-id, disposition]
  (let [errors-atom (atom nil)
        load-labels (fn []
                      (controller/dispatch :label-list :load {:family-id family-id
                                                              :object-type model/object-type-disposition
                                                              :errors-atom errors-atom}))]
    (load-labels)
    (fn [_]
      [common/header-tab-wrapper (if disposition
                                   (str "Edit disposition: " (:uid disposition))
                                   "Add a new disposition")
       [disposition-edit-form family-id disposition]])))

(defn rollback-leftover-documents [options documents]
  [:div.groups
   [:h2.o-media--medium "Documents left after rollback"]
   [document-component/document-list (assoc options :disable-ordering true) nil {:results documents} false]])

(defn automation-collection-list [options selected-family-atom]
  (let [collections (subscribe :family-collection-list)
        current-page (atom 1)
        order (atom "path_info")
        disposition-uid (or (:uid options) (atom nil))
        collection-name (or (:collection_name options) (atom nil))
        label-ids (or (:label_ids options) (atom #{}))
        dispositions-atom (automation/chooser-dispositions-atom)
        labels-atom (automation/chooser-labels-atom)
        disposition-edit-atom (atom nil)
        update-url           (fn []
                               (util/replace-location-query-string
                                (util/make-params
                                 (merge
                                  {:family_id @selected-family-atom}
                                  (when @order {:order @order})
                                  (when @disposition-uid {:uid @disposition-uid})
                                  (when @collection-name {:collection_name @collection-name})
                                  (when @label-ids {:label_id (vec @label-ids)})))))
        load-collections (fn [page-number]
                           (update-url)
                           (controller/dispatch :family-collection-list :load {:family-id            @selected-family-atom
                                                                               :page                 page-number
                                                                               :include-dispositions true
                                                                               :disposition-uid      @disposition-uid
                                                                               :collection-name      @collection-name
                                                                               :order                @order
                                                                               :label-ids @label-ids})
                           (reset! current-page page-number))
        load-dispositions #(controller/dispatch :automation-dispositions :load {:family-id @selected-family-atom})
        load-labels #(controller/dispatch :label-list :load {:family-id @selected-family-atom
                                                             :object-type model/object-type-disposition})
        options (merge options {:selected-family-atom selected-family-atom
                                :load-callback (fn []
                                                 (load-collections @current-page)
                                                 (load-dispositions)
                                                 (load-labels))
                                :uid                  disposition-uid
                                :collection-name      collection-name
                                :label-ids label-ids})]
    (when @selected-family-atom
      (load-collections 1)
      (load-dispositions)
      (load-labels))
    (add-watch order :automation-collections-order
               (fn [& _]
                 (load-collections @current-page)))
    (fn [& _]
      [:div.o-main-aside
       [:main.o-main-aside__main
        (if (seq (:results @collections))
          [:table.t-table-redesign
           [:thead
            [:tr
             [:th.no-padding (orderer order "Path" "path_info")]
             [:th.no-padding (orderer order "Name" "name")]
             [:th.no-padding "Dispositions"]]]
           [:tbody
            (doall
             (for [collection (:results @collections)]
               [:tr {:key (:id collection)}
                [:td.assignments [assignment-list {:hide-path-leaf false}
                                  [(assoc collection
                                          :collection (assoc collection :ancestors (identity (:ancestors collection)))
                                          :collection_id (:id collection)
                                          :main true)]]]
                [:td.name (:name collection)]
                [:td
                 [collection/disposition-list
                  {:allow-edit true
                   :context-key (:id collection)
                   :edit-atom disposition-edit-atom
                   :dispositions-atom dispositions-atom
                   :labels-atom labels-atom
                   :list-change-cb (fn []
                                     (load-collections @current-page)
                                     (load-dispositions)
                                     (load-labels))}
                  (:id collection)
                  (:dispositions collection)]]]))]

           [tfoot-paginator
            [paginator
             (map (fn [page-number]
                    {:number page-number
                     :on-click (util/handler (fn [] (load-collections page-number)))})
                  (:page_numbers @collections))
             @current-page
             (when (:has_previous @collections) (util/handler #(load-collections (- @current-page 1))))
             (when (:has_next @collections) (util/handler #(load-collections (+ @current-page 1))))]
            3
            (-> (:page_numbers @collections) count (> 1))]]
          [:p.o-media--bottom-shadow "No collections."])]
       [disposition-filter options]])))

(defn label-form [options value-atom error-atom]
  (let [original-value @value-atom]
    (fn [& _]
      [:form.c-form--edit
       (when (:error-left options)
         [:span.error (:name @error-atom)])
       [:input {:value @value-atom
                :on-change (fn [ev]
                             ((reset-from-event value-atom) ev)
                             (some-> (:on-change options) (apply [@value-atom])))}]
       [:button {:on-click (util/handler
                            (fn [] (some-> (:on-cancel options) (apply []))))} "Cancel"]
       [:button (merge
                 {:type :submit
                  :on-click (util/handler
                             (fn [] (some-> (:on-save options) (apply []))))}
                 (when (= original-value @value-atom)
                   {:disabled :disabled})) "Save"]
       (when-not (:error-left options)
         [:span.error (:name @error-atom)])])))

(defn label-actions [options label]
  (let [refresh-atom (or (:refresh-atom options) (atom nil))
        show-menu (atom false)
        ref       (atom nil)
        export-form (clojure.core/atom nil)]
    (reagent/create-class
     {:display-name        "label-actions"
      :component-did-mount #(-> (js/$ "div.outer-container")
                                (.click
                                 (fn [e]
                                   (when-not (= (-> e .-target) @ref)
                                     (reset! show-menu false)
                                     (-> (js/$ "ul.dropdown-menu.dropdown-select") (.removeClass "show"))))))
      :reagent-render      (fn [{:keys [] :as options} _]
                             [:div.dropdown.c-actions {:style {:display :inline} :key :add}
                              [:div.dropdown-container

                               [:span
                                [:button
                                 {:ref (fn [com] (reset! ref com)) :on-click #(swap! show-menu not)}
                                 "..."]]
                               [:ul.dropdown-menu.dropdown-select
                                (when @show-menu {:class "show" :style {:left "-2.7em"}})

                                [:li
                                 {:on-click (util/handler
                                             (fn []
                                               (controller/dispatch :label-list :delete {:id (:id label)
                                                                                         :on-success #(swap! refresh-atom not)})))}
                                 "Delete"]
                                (when (= (:object_type label) model/object-type-disposition)
                                  [:li {:on-click (fn []
                                                    (when-let [export-form @export-form]
                                                      (.submit export-form)))}
                                   [:form
                                    {:method :post
                                     :action (str "/download/disposition/")
                                     :ref (fn [el]
                                            (reset! export-form el))}
                                    [:input
                                     {:type  :hidden
                                      :name  :key
                                      :value (:encrypted-token options)}]
                                    [:input
                                     {:type  :hidden
                                      :name  :label_ids
                                      :value (:id label)}]
                                    "Export dispositions to CSV"]])]]])})))

(defn label-list [options selected-family-atom]
  (let [labels (subscribe :label-list)
        refresh-atom (or (:refresh-atom options) (atom nil))
        errors-atom (atom nil)
        current-page (atom 1)
        order (atom "name")
        edit (atom nil)
        original-values (atom {})
        value (atom nil)
        label-list (subscribe :label-list)
        encrypted-token (track! #(:encrypted_token @label-list))
        load-labels (fn [page-number]
                      (controller/dispatch :label-list :load {:family-id @selected-family-atom
                                                              :page page-number
                                                              :order @order
                                                              :paginate true
                                                              :errors-atom errors-atom
                                                              :object-type (:object-type options)})
                      (reset! current-page page-number))
        options (merge options {:encrypted-token @encrypted-token})]
    (when @selected-family-atom
      (load-labels 1))
    (add-watch order :automation-labels-order
               (fn [& _]
                 (load-labels @current-page)))
    (add-watch labels :label-id-values (fn [_ _ _ new-labels]
                                         (reset! original-values (into {} (map (fn [label] [(:id label) (:name label)]) (:results new-labels))))))
    (add-watch refresh-atom :refresh-watch #(load-labels @current-page))
    (fn []
      [:div.groups
       [list-options [group-chooser {:group-changed-cb #(load-labels @current-page)
                                     :admin-only true
                                     :filter-pred (when (= (:object-type options) model/object-type-disposition)
                                                    (fn [family]
                                                      (collection-model/has-document-automation-enabled (:id family))))
                                     :group-atom selected-family-atom} @selected-family-atom]]
       (if (seq (:results @labels))
         [:table.t-table-redesign
          [:thead
           [:tr
            [:th.no-padding.u-text-align--left (orderer order "Name" "name")]]]
          [:tbody
           (doall
            (for [label (:results @labels)]
              [:tr {:key (:id label)}
               [:td.name (if (= @edit (:id label))
                           [label-form {:on-change (fn [new-name]
                                                     (reset! value new-name))
                                        :on-cancel (fn []
                                                     (reset! value (@original-values (:id label)))
                                                     (reset! edit nil))
                                        :on-save (fn []
                                                   (controller/dispatch :label-list :update {:family-id @selected-family-atom
                                                                                             :id (:id label)
                                                                                             :name @value
                                                                                             :errors-atom errors-atom
                                                                                             :on-success (fn [_]
                                                                                                           (load-labels @current-page)
                                                                                                           (reset! edit nil))}))}
                            (atom (:name label)) errors-atom]
                           [:span {:on-click (util/handler (fn []
                                                             (reset! value (@original-values (:id label)))
                                                             (reset! edit (:id label))))} (:name label)])
                [label-actions options label]]]))]

          [tfoot-paginator

           [paginator
            (map (fn [page-number]
                   {:number page-number
                    :on-click (util/handler (fn [] (load-labels page-number)))})
                 (:page_numbers @labels))
            @current-page
            (when (:has_previous @labels) (util/handler #(load-labels (- @current-page 1))))
            (when (:has_next @labels) (util/handler #(load-labels (+ @current-page 1))))]
           1
           (-> (:page_numbers @labels) count (> 1))]]
         [:p.o-media--bottom-shadow "No labels."])])))

(defn disposition-import [options]
  (let [family-id (:family-id options)
        family (atom nil)
        error (atom nil)
        import-result (atom nil)]
    (->> (collection-model/collection-details family-id)
         (p/map #(reset! family %))
         (process-error))
    (fn []
      [:div.o-media
       (when @family
         [:h2 "Importing dispositions to " (:name @family)])

       [:dl
        [:dt "CSV file:"]
        [:dd [upload-field {:url (api/api-url (str "/automation/import/" family-id "/"))
                            :error-cb (fn [err]
                                        (reset! error "Import failed. Try again later."))
                            :success-cb (fn [e response]
                                          (reset! error nil)
                                          (reset! import-result (js->clj response))
                                          (set-flash :success "Import successful"))}]]]
       [:span.error @error]
       (when-let
        [{imported-count "imported_count"
          import-error "import_error"}  @import-result]
         [:div
          [:p "Succesfully imported " imported-count " dispostions(s). "]
          [:p.error (get import-error "message")]
          [:ul
           (doall
            (for [row-error (get import-error "errors")]
              [:li
               "Errors in row "
               (:idx row-error) (get row-error "idx")
               ":"
               [:ul.u-disc-list
                (doall
                 (for [value-error (get row-error "errors")]
                   [:li (get  value-error "message")]))]]))]])
       [:button.u-flex.u-flex--element-to-right {:on-click #(util/set-location (str "#/automation/disposition/list?family_id=" family-id))} "I'm done"]])))

(defn template-label-list [options selected-family-atom]
  (label-list options selected-family-atom))

(defn template-tabs [options tab-content active-tab]
  (fn []
    (let [tab-list [["Templates"
                     {:url "#/task/templategroup/list"
                      :id :compliance-templates}
                     true
                     (or (is-user-license-admin) (model/can-view-any-family-template-list))
                     (when (is-user-admin) (partial templategroup-list-controls options))]
                    ["Labels"
                     {:url (path-for :settings-template-label-list) :id :template-label-list}
                     true
                     (is-user-any-group-admin)
                     (partial label-controls options)]]]
      [admin-tab-bar (assoc options
                            :header-additional-content
                            [:span " / " [:a {:href (path-for :settings-templategroup-list)} "Templates"]])
       tab-list tab-content active-tab])))

(defn dropbox-sign-report [_]
  (with-let [report-data (subscribe :dropbox-sign-usage-report)
             month-choices (into {} form/month-choices)
             non-zero (atom true)
             status (atom "c")
             now (time/now)
             beginning-of-current-month (time-core/date-time (time-core/year now) (time-core/month now) 1)
             current (atom beginning-of-current-month)
             load-report! #(controller/dispatch :dropbox-sign-usage-report :load
                                                [{} (time-core/year @current) (time-core/month @current) @status @non-zero false])
             change-month! (fn [diff]
                             (swap! current #(time-core/plus % (time-core/months diff))))
             _ (load-report!)
             _ (doall
                (for [atm [current status non-zero]]
                  (add-watch atm :load-report #(load-report!))))]
    [:div
     [list-options
      [:div.u-margin-top.u-margin-bottom
       [:button.c-round-button
        {:on-click (util/handler #(change-month! -1))}
        "<"]
       " "
       [:div.u-text-align--center {:style {:display :inline-block
                                           :width "8em"}} (month-choices (time-core/month @current)) " " (time-core/year @current)]
       " "
       [:button.c-round-button
        (merge
         {:on-click (util/handler #(change-month! 1))}
         (when (and
                (= (time-core/year beginning-of-current-month) (time-core/year @current))
                (= (time-core/month beginning-of-current-month) (time-core/month @current)))
           {:disabled :disabled}))
        ">"]]
      [:span.u-margin-left "Last status:"]
      [:select {:on-change (util/reset-from-event status)}
       [:option {:value "c"} "Complete"]
       [:option {:value "n"} "Initiated"]
       [:option {:value "p"} "Pending"]
       [:option {:value "x"} "Cancelled"]]
      [:label
       [:input (set-checked @non-zero {:on-change (fn [ev] (reset! non-zero (checked? ev)))})]
       "Only non-zero results"]
      [common/download-button {:ajax-url "/signature/report/"
                               :ajax-options (merge
                                              {:params {:year (time-core/year @current)
                                                        :month (time-core/month @current)
                                                        :status @status
                                                        :non_zero @non-zero
                                                        :csv true}
                                               :response-format (ajax.core/ring-response-format {:format (text-response-format)})})}
       "CSV"]]
     (if (seq @report-data)
       [:table.t-table-redesign
        [:thead
         [:tr
          [:th "Subscriber"]
          [:th "Family"]
          [:th "Signature Count"]]]
        [:tbody
         (doall
          (for [row @report-data]
            [:tr {:key (:family_id row)}
             [:td (:subscriber_name row)]
             [:td (:family_name row)]
             [:td.u-text-align--center (:signature_count row)]]))]]
       [:p.o-media "No signatures"])]))

(defn metrics [selected-subscriber-atom selected-group-atom]
  (let [subscriber selected-subscriber-atom
        family selected-group-atom
        show-subscriber-chooser (atom false)
        scope-atom (track! (fn [] (get-scope (value-if-not-none @subscriber) (value-if-not-none @family))))
        filter-time-range (atom model/one-day)
        order (atom "user_name")
        update-url (fn []
                     (util/set-location-params
                      (merge
                       (when (value-if-not-none @subscriber) {:subscriber @subscriber})
                       (when (value-if-not-none @family) {:group @family}))
                      true))
        token-usage-data (subscribe :token-usage)
        load-token-usage (fn [subscriber-id family-id time-range]
                           (if subscriber-id
                             (controller/dispatch :token-usage :load {:subscriber-id subscriber-id
                                                                      :family-id family-id
                                                                      :time-range time-range
                                                                      :timezone (tz/get-user-timezone)
                                                                      :order @order})
                             (controller/dispatch :token-usage :clear)))
        aark-enabled-families (subscribe :permitted-groups)
        load-aark-enabled-families (controller/dispatch :permitted-groups :load {:collection-id nil
                                                                                 :admin-only false
                                                                                 :aark-enabled true})]

    (add-watch order :token-usage-order
               (fn [& _]
                 (load-token-usage  @subscriber @family @filter-time-range)))
    (load-token-usage @subscriber @family @filter-time-range)
    (load-aark-enabled-families)
    (fn []
      (when @aark-enabled-families
       [:div
        [list-options
         (when (is-user-any-admin)
           [:span (when-not @show-subscriber-chooser {:style {:display :none}})
            [subscriber-chooser
             {:subscriber-changed-cb (fn [subscriber-id _]
                                       (load-token-usage subscriber-id nil @filter-time-range)
                                       (update-url))
              :allow-empty           false
              :subscriber-atom       subscriber
              :group-atom            family
              :admin-only            false
              :preselect-if-one      true
              :load-cb (fn [subscribers]
                         (let [aark-subscriber-ids (set (map :subscriber_id @aark-enabled-families))
                               aark-subscribers (filter (fn [sub]
                                                               (contains? aark-subscriber-ids (:id sub)))
                                                             subscribers)]
                           (when (> (count aark-subscribers) 1) 
                             (reset! show-subscriber-chooser true))))
              :filter-pred (fn [subscriber]
                             (some #(= (:id subscriber) (:subscriber_id %)) @aark-enabled-families))}
             @subscriber]])
         (when-not (is-user-license-admin)
           [group-chooser
            (merge
             {:group-changed-cb (fn [subscriber-id family-id]
                                  (load-token-usage subscriber-id family-id @filter-time-range)
                                  (update-url))
              :admin-only       true
              :group-atom       family
              :subscriber-atom  subscriber
              :filter-pred (fn [family]
                             (collection-model/has-aark-enabled (:id family)))}
             (when (is-user-any-subscriber-admin)
               {:allow-empty     true}))
            @selected-group-atom])]
        [:div.u-padding-bottom
         [:div.metrics-box
          [:div.o-flex-align--space-between
           [:div
            [:h2.u-margin-bottom "Token usage"]
            #_[:h1 "100%"]
            [:h4.u-color--secondary (get-in @token-usage-data [:token_usage_statistics :total]) " tokens"]]
           [:div
            [:select {:on-change (fn [ev]
                                   ((reset-from-event filter-time-range) ev)
                                   (load-token-usage (when (not= "<NONE>" @subscriber) @subscriber) (when (not= "<NONE>" @family) @family) @filter-time-range))}
             (for [[value label] model/time-range-choices]
               ^{:key value} [:option (option-value @filter-time-range value) label])]]]
          [:div.u-margin-top
           [:table.c-metrics-table
            [:thead
             [:tr
              [:th (orderer order "Family" "family_name")]
              [:th (orderer order "User" "user_name")]
              [:th.u-text-align--right (orderer order "Token usage" "total_tokens")]
              #_[:th "Percent"]
              #_[:th "Cost"]]]
            [:tbody
             (doall
              (for [usage (:results @token-usage-data)]
                [:tr
                 [:td (:family_name usage)]
                 [:td (str (:first_name usage) " " (:last_name usage))]
                 [:td.u-text-align--right (:total_tokens usage)]
                 #_[:td (:percent usage)]
                 #_[:td (:cost usage)]]))]]]]]]))))
